export const frLangDashboard = {
  updatePrompt: {
    title: 'Mise à jour prête',
    message: 'Rechargez pour utiliser la dernière version. Le travail non enregistré sur cet écran peut être perdu.',
    action: 'Recharger',
  },
  headerSearch: {
    placeholder: 'Rechercher des produits',
    cancel: 'Annuler',
    empty: 'Aucun produit trouvé',
    noShop: 'Aucun produit à rechercher pour l’instant',
  },
  common: {
    elements: 'Éléments',
    of: 'sur',
    itemsLower: 'éléments',
    extraContent: 'Contenu additionnel',
    you: 'Vous',
    post: 'Publication',
    article: 'Article',
    create: 'Créer',
    message: 'Message',
    popular: 'Populaire',
    emptyIntegrations: `Vous devez d'abord ajouter des intégrations`,
    categories: 'Catégories',
    edit: 'Modifier',
    share: 'Partager',
    plan: 'Forfait',
    sort: 'Trier',
    addArticle: 'Ajouter un article',
    articles: 'Articles',
    users: 'utilisateurs',
    scans: 'scans',
    clicks: 'clics',
    copy: 'Copier',
    customize: 'Personnaliser',
    link: 'lien',
    save: 'Enregistrer',
    uploadFile: 'Téléverser un fichier',
    customImage: 'Image personnalisée',
    customImageTooltip: 'Téléverser une image personnalisée',
    size: 'Taille',
    sizeTooltip: 'Faites glisser le curseur pour définir la taille',
    auto: 'Auto',
    rectangle: 'Rectangle',
    custom: 'Personnalisé',
    clean: 'Nettoyer',
    cleaning: 'Nettoyage',
    download: 'Télécharger',
    downloading: 'Téléchargement',
    preview: 'APERÇU',
    cover: 'Couverture',
    coverTooltip: 'Téléverser une photo de couverture',
    title: 'Titre',
    new: 'Nouveau',
    pro: 'Pro',
    free: 'Gratuit',
    limit: 'Limite',
    websites: 'sites web',
    site: 'Site',
    apiKey: 'Clé API',
    name: 'Nom',
    passwordChange: 'Changement de mot de passe',
    draft: 'Brouillon',
    page: 'Page',
    areYouSure: 'Êtes-vous sûr(e) ?',
    drop: 'Déposer',
    video: 'vidéo',
    image: 'image',
    chooseFile: 'Choisir un fichier',
    nothingFound: 'Aucun résultat trouvé',
    enterCorrectLink: 'Entrez un lien correct',
    off: 'Désactivé',
    disconnect: 'DÉCONNECTER',
    connect: 'CONNECTER',
    copied: 'Copié',
    saved: 'Enregistré',
    lostConnection: 'Connexion perdue',
    addedCategory: 'Catégorie ajoutée',
    none: 'Aucun',
    left: 'Gauche',
    right: 'Droite',
    solid: 'Plein',
    double: 'Double',
    welcome: 'Bienvenue',
    category: 'Catégorie',
    product: 'Produit',
    website: 'Site web',
    items: 'Éléments',
    square: 'Carré',
    round: 'Rond',
    border: 'Bordure',
    shadow: 'Ombre',
    subtle: 'Subtil',
    soft: 'Doux',
    hard: 'Fort',
    block: 'Bloc',
    primary: 'Principal',
    additional: 'Supplémentaire',
    normal: 'Normal',
    bold: 'Gras',
    uploadVideo: 'Téléverser une vidéo',
    compact: 'Compact',
    card: 'Carte',
    top: 'Haut',
    center: 'Centre',
    bottom: 'Bas',
    button: 'Bouton',
    addNewItem: 'Ajouter un nouvel élément',
    price: 'Prix',
    priceCaption: 'Ajoutez le prix de votre produit',
    oldPrice: 'Ancien prix',
    oldPriceCaption: `L'ancien prix sera barré`,
    areYouSureDeleteItem: 'Êtes-vous sûr(e) de vouloir supprimer cet élément ?',
    add: 'Ajouter',
    active: 'Actif',
    isActive: 'est actif',
    isDisabled: 'est désactivé',
    uploadImage: 'Téléverser une image',
    design: 'Design',
    addAccount: 'Ajouter un compte',
    hey: 'Bonjour',
    activeBackground: 'Arrière-plan actif',
    activeText: 'Texte actif',
    connectDomain: 'Connecter un domaine',
    shortLink: 'Lien court',
    appearanceSaved: 'Apparence enregistrée !',
    blockAdded: 'Bloc ajouté !',
    comingSoon: 'Bientôt disponible',
    easyMoney: 'Gagner facilement',
    content: 'Contenu',
    audience: 'Audience',
    view: 'Voir',
    delete: 'Supprimer',
    file: 'Fichier',
    type: 'Type',
    from: 'De',
    to: 'À',
    fullName: 'Nom complet',
    lastTimeUsed: 'Dernière utilisation',
    noMediaFiles: 'Aucun fichier média pour le moment...',
    withdraw: 'Retirer',
    congrats: 'Félicitations !',
    makeMoneyOnline: `Gagnez de l'argent en ligne !`,
    thin: 'Fin',
    blockEmptyTitle: 'Rien ici pour l’instant',
    blockEmptyText: 'Ce bloc n’a encore aucun élément. Ajoutez-en un pour le voir sur votre page.',
    noItemsTitle: 'Vous n’avez encore aucun élément',
    noItemsText: 'Ajoutez votre premier élément pour remplir ce bloc.',
  },
  sort: {
    title: 'Trier',
    search: 'Rechercher',
    default: 'Tri par défaut',
    dateNew: 'Date : du plus récent au plus ancien',
    dateOld: 'Date : du plus ancien au plus récent',
    priceLow: 'Prix : du moins cher au plus cher',
    priceHigh: 'Prix : du plus cher au moins cher',
    nameA: 'Nom : A à Z',
    nameZ: 'Nom : Z à A',
    popular: 'Plus populaires',
  },
  emailMenu: {
    broadcasts: 'Diffusions',
    automations: 'Automatisations',
    templates: 'Modèles',
    log: 'Journal',
    settings: 'Paramètres',
    noEmails: 'Aucun e-mail pour le moment',
    newBroadcast: 'Nouvelles diffusions',
  },
  aiContent: {
    title: 'Créez votre premier contenu IA !',
    text: 'Planifiez et publiez du contenu sur tous les réseaux sociaux en une seule fois !',
    create: 'Créer un contenu IA',
  },
  pageDesign: {
    page: 'Design de la page',
    image: 'Image',
  },
  toolsMenu: {
    title: 'Outils',
    account: 'Compte',
    instantPages: 'Pages instantanées',
    instantPagesText: 'Pages autonomes à chargement rapide',
    agents: 'Agents',
    agentsText: 'Assistants IA qui gèrent votre profil',
    socialPlanner: 'Planificateur social',
    socialPlannerText: 'Planification de contenu et inspiration',
    emailMarketing: 'Marketing par e-mail',
    emailMarketingText: 'Développez votre liste de contacts',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Envoyez des commentaires et messages automatiques',
    linkShortener: 'Raccourcisseur de liens',
    linkShortenerText: 'Raccourcissez les URL longues',
    posts: 'Publications',
    postsText: 'Créez et gérez vos publications',
    blog: 'Blog',
    blogText: 'Créez et gérez vos articles de blog',
  },
  insideMenu: {
    planner: 'Planificateur',
    aiContent: 'Contenu IA',
    aiPosts: 'Publications IA',
    postIdeas: 'Idées de publication',
    contentPlanner: 'Planificateur de contenu',
    aiImages: 'Images IA',
    brandProjects: 'Brand Identity',
    aiVideo: 'Vidéo IA',
    integrations: 'Intégrations',
    products: 'Produits',
    orders: 'Commandes',
    payments: 'Paiements',
    links: 'Liens',
    qrCodes: 'Codes QR',
    adBuilder: 'Créateur de publicités',
  },
  orders: {
    title: 'Commandes',
    empty: `Vous n'avez pas encore de commandes`,
    all: 'Toutes les commandes',
    shop: 'Boutique',
    digital: 'Produits numériques',
    appointments: 'Rendez-vous',
    services: 'Services',
    donations: 'Dons',
  },
  discounts: {
    title: 'Réductions',
    newDiscount: '+ Nouvelle réduction',
    code: 'Code',
    titleCol: 'Titre',
    type: 'Type',
    value: 'Valeur',
    status: 'Statut',
    used: 'Utilisé',
    actions: 'Actions',
    statusAll: 'Tous les statuts',
    statusActive: 'Active',
    statusExpired: 'Expirée',
    statusScheduled: 'Planifiée',
    statusInactive: 'Inactive',
    searchPlaceholder: 'Rechercher par code ou titre...',
    clearFilters: 'Effacer les filtres',
    emptyTitle: 'Pas encore de réductions',
    emptySubtitle: 'Créez votre premier code promo pour offrir des réductions sur vos produits',
    createDiscount: 'Créer une réduction',
    createTitle: 'Créer une réduction',
    editTitle: 'Modifier la réduction',
    fieldTitle: 'Titre',
    fieldTitlePlaceholder: 'ex. Vente de printemps',
    fieldCode: 'Code',
    fieldCodePlaceholder: 'ex. SAVE20',
    generate: 'Générer',
    sectionDiscount: 'Réduction',
    fieldType: 'Type',
    typePercentage: 'Pourcentage',
    typeFixed: 'Montant fixe',
    typeFreeShipping: 'Livraison gratuite',
    fieldValue: 'Valeur',
    sectionConditions: 'Conditions (optionnel)',
    appliesTo: `S'applique à`,
    appliesToAll: 'Tous les produits',
    appliesToShop: 'Boutique',
    appliesToDigital: 'Numérique',
    appliesToCourses: 'Cours',
    appliesToServices: 'Services',
    appliesToEvents: 'Événements',
    minOrderAmount: 'Montant minimum de commande ($)',
    maxDiscountAmount: 'Montant maximum de réduction ($) — 0 = sans limite',
    minItemCount: `Min. d'articles dans la commande — 0 = aucune exigence`,
    specificProducts: 'Produits spécifiques — vide = tous',
    specificProductsPlaceholder: 'Rechercher des produits...',
    noProductsFound: 'Aucun produit trouvé',
    sectionLimits: 'Limites',
    usageLimit: `Limite d'utilisation totale — 0 = sans limite`,
    usageLimitPerUser: 'Limite par client — 0 = sans limite',
    sectionSchedule: 'Planification',
    startDate: 'Date de début — vide = commence maintenant',
    endDate: 'Date de fin — vide = sans expiration',
    active: 'Active',
    cancel: 'Annuler',
    save: 'Enregistrer la réduction',
    createdSuccess: 'Réduction créée',
    updatedSuccess: 'Réduction mise à jour',
    deletedSuccess: 'Réduction supprimée',
    loadError: 'Échec du chargement des réductions',
    saveError: `Échec de l'enregistrement de la réduction`,
    deleteError: 'Échec de la suppression de la réduction',
    fieldTrigger: 'Mode d’application',
    triggerCode: 'Code de réduction',
    triggerAutomatic: 'Automatique (sans code)',
    triggerAutomaticHint:
      'Appliqué automatiquement au paiement lorsque les conditions sont remplies — aucun code requis. Définissez un montant minimum de commande ci-dessous pour une réduction sur la valeur de la commande.',
    automaticBadge: 'Automatique',
  },
  donation: {
    chooseSmiles: 'Choisir des émoticônes',
    item: 'Élément',
    itemTitle: `Titre de l'élément de don`,
    price: 'Prix',
    thanksMessagePlaceholder: 'Merci beaucoup',
    thanksMessage: 'Message de remerciement',
    thanksMessageCaption: `Le message de remerciement s'affichera pour vos fans après le don`,
    addDonation: 'Ajouter un don',
    addAmount: '+ Ajouter un montant',
    buttonTitle: 'Titre du bouton',
    buttonTitleCaption: 'Titre du bouton de don',
    acceptDonations: 'Accepter les dons',
    donationsType: 'Dons',
    tips: 'Pourboires',
    type: 'Type',
    addAnotherAmount: '+ Ajouter un autre montant',
  },
  blog: {
    empty: `Vous n'avez pas encore de blog`,
  },
  apps: {
    empty: `Vous n'avez pas encore d'applications`,
  },
  payments: {
    title: 'Paiements',
    text: `Vous n'avez pas encore de transactions`,
    single: 'Paiements uniques',
    subscriptions: 'Abonnements',
    wallet: 'Portefeuille',
    connectPromo: 'Connectez votre compte Stripe ou PayPal à votre page UniLink et recevez tous les paiements dans votre portefeuille.',
    connectSystem: 'Connecter un système de paiement',
    manageCards: 'Gérer vos cartes',
    addNewCard: 'Ajouter une nouvelle carte',
    editCard: 'Modifier les informations de la carte',
    addCard: 'Ajouter les informations de la carte',
    cardHolder: 'Nom du titulaire de la carte',
    cardHolderNecessary: 'Ce champ est obligatoire',
    withdrawalSuccess: 'Votre retrait a été soumis avec succès !',
    withdrawalError: `Une erreur s'est produite, veuillez réessayer plus tard.`,
    change: 'Modifier',
  },
  store: {
    emptyTitle: 'Vous n’avez pas encore de produits',
    emptyText: 'Commencez par ajouter votre premier produit',
    emptyButton: 'Ajouter un produit',
    createFirstProduct: 'Créez votre premier produit',
    startAdding: 'Commencez par ajouter vos produits préférés, biens numériques ou services. Un espace où vous pouvez vendre et promouvoir tout ce que vous proposez.',
    activate: 'Activer la boutique',
    empty: `Vous n'avez pas encore de produits`,
    products: 'Produits',
    addProducts: 'Ajouter des produits',
    whatDoYouWant: 'Que souhaitez-vous vendre ?',
    externalProduct: 'URL de produit externe',
    createOwnProduct: 'Créer votre propre produit',
    shop: 'Boutique',
    shopText: 'Vendez des produits physiques et numériques',
    digital: 'Produits numériques',
    digitalText: 'Vendez un téléchargement numérique',
    course: 'Cours ou tutoriel',
    courseText: 'Ajoutez un cours ou tutoriel au site web',
    service: 'Services',
    serviceText: 'Ajoutez des services pour vos clients',
    appointment: 'Rendez-vous',
    appointmentText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
    event: 'Événements ou billets',
    eventText: 'Créez un événement et invitez votre audience',
    tips: 'Pourboires',
    tipsText: 'Laissez un pourboire à vos créateurs préférés',
    donation: 'Dons',
    donationText: 'Faites un don',
    membership: 'Adhésion',
    membershipText: 'Ajoutez une adhésion au site web',
    links: 'Lien externe',
    linksText: `Ajoutez un lien externe vers n'importe quel site web`,
    coupon: 'Coupon',
    couponText: 'Ajoutez un coupon pour votre site web',
    singleProduct: 'Produit unique',
    singleProductText: 'Vendez un produit unique avec un paiement simple',
    booking: 'Réservation',
    bookingText: 'Permettez aux visiteurs de réserver vos espaces ou propriétés',
    rental: 'Location',
    rentalText: 'Listez des articles à louer avec disponibilité et tarifs',
    add: 'Ajouter',
    manageStore: 'Gérer la boutique',
    displayLast: 'Afficher le dernier produit',
  },
  products: {
    info: 'Info',
    uploadCover: 'Téléversez une photo de couverture, puis fournissez un titre et une description',
    thumbnail: 'Miniature',
    thumbnailTab: {
      intro:
        'La carte que les visiteurs voient dans votre boutique, avant d’ouvrir le produit. Elle n’a ni prix ni stock propres — ils sont dans Details, et ici vous choisissez seulement ce qu’elle en montre.',
      cardImage: 'Image de la carte',
      crop: 'Recadrage',
      cropSquare: 'Carré',
      cropPortrait: 'Portrait',
      cropWide: 'Large',
      imageHint: 'Laissez vide et la carte reprend la première image de Details. 1200×1200 ou plus rend le mieux.',
      cardCopy: 'Texte de la carte',
      cardTitle: 'Titre de la carte',
      sameAsTitle: 'Comme le titre du produit',
      shortDescription: 'Description courte',
      shortDescriptionHint: 'Une ligne qui donne envie de cliquer. La description longue est dans Details.',
      buttonLabel: 'Libellé du bouton',
      showOnCard: 'Afficher sur la carte',
      showOnCardNote: 'les valeurs viennent de Details — ici vous ne réglez que la visibilité',
      editInDetails: 'Modifier dans Details ↗',
      rowPrice: 'Prix',
      rowOldPrice: 'Ancien prix et remise',
      rowAvailability: 'Disponibilité',
      rowLabel: 'Étiquette',
      inStock: 'En stock',
      notShown: 'Non affiché',
    },
    thumbnailError: 'Veuillez ajouter une miniature',
    title: 'Titre',
    titleTooltip: 'Entrez le nom de votre produit',
    shortDescription: 'Description courte',
    shortDescriptionTooltip: 'Entrez une courte description de votre produit',
    description: 'Description',
    descriptionTooltip: 'Entrez la description de votre produit',
    descriptionTooltipExtra: 'Description optionnelle des caractéristiques du produit, types, couleurs, tailles, etc.',
    price: 'Prix',
    priceTooltip: 'Entrez le prix de votre produit',
    oldPrice: 'Ancien prix',
    oldPriceTooltip: `L'ancien prix sera barré`,
    category: 'Catégorie',
    categoryTooltip: 'Choisissez la catégorie de votre produit',
    image: 'Image',
    imageTooltip: 'Téléversez une image pour votre produit',
    groups: 'Groupes',
    rate: 'Note',
    rateTooltip: 'Entrez la note de votre produit',
    buttonTitle: 'Titre du bouton',
    buttonTitleTooltip: 'Entrez le titre du bouton de votre produit',
    limitQuantity: 'Quantité limitée',
    itemsLeft: 'Articles restants',
    itemsLeftTooltip: 'Articles de votre produit',
    trackStock: 'Suivre le stock',
    stockQuantity: 'Quantité en stock',
    stockQuantityTooltip: 'Unités actuellement en stock. Diminue automatiquement à chaque commande payée ; lorsqu’elle atteint 0, le produit ne peut plus être acheté.',
    lowStockThreshold: 'Alerte de stock faible',
    lowStockThresholdTooltip: 'Soyez averti lorsque le stock atteint ce nombre ou moins.',
    maxOrderQuantity: 'Quantité maximale par commande',
    maxOrderQuantityTooltip: 'Nombre maximal d’unités qu’un client peut acheter en une seule commande. Laissez vide pour aucune limite.',
    minOrderQuantity: 'Quantité minimale par commande',
    minOrderQuantityTooltip: 'Nombre minimal d’unités qu’un client doit acheter en une seule commande. Laissez vide pour aucune limite.',
    attachments: 'Pièces jointes',
    addAttachments: 'Ajoutez des pièces jointes à vos produits',
    addNewAttachment: 'Ajouter un nouvel élément',
    file: 'Fichier',
    uploadFile: 'Téléverser un fichier',
    uploadCoverTitle: 'Téléverser la couverture',
    optionalDescription: 'Description optionnelle des caractéristiques du produit, types, couleurs, tailles, etc.',
    customReviews: 'Avis personnalisés',
    addCustomReviews: 'Ajoutez des avis à vos produits',
    name: 'Nom',
    nameTooltip: 'Entrez le nom de votre client',
    comment: 'Commentaire',
    commentTooltip: 'Entrez le commentaire de votre client',
    rateTooltipCustomer: 'Note du client',
    imageTooltipCustomer: `Téléversez l'image de votre client`,
    displayPriceOnPreview: `Afficher le prix dans l'aperçu`,
    displayDetailsOnPreview: `Afficher les détails dans l'aperçu`,
    postOnSocials: 'Publier sur les réseaux sociaux',
    sendAnEmail: 'Envoyer un e-mail',
    highlights: 'Points forts',
    listProductSetup: 'Listez le produit et configurez votre bloc boutique',
    whereToSell: 'Où souhaitez-vous vendre ce produit ?',
    youHaveProducts: 'Vous avez {count} produits',
    shareThisProduct: 'Partager ce produit',
    shareAProduct: 'Partager un produit',
    monetizeWays: 'Différentes façons de monétiser sur UniLink',
    addProductToProfile: 'Ajouter un {title} à votre profil',
    productPage: 'Page produit',
    setUpPayments: 'Configurer vos paiements',
    connectPaymentMethods: `Connectez vos méthodes de paiement pour commencer à gagner de l'argent sur UniLink`,
    addPaymentMethod: 'Ajoutez une méthode de paiement {type} pour recevoir les paiements de vos abonnés',
    withdrawAttempt: 'Ceci est une tentative de recouvrement de créance et toute information sera utilisée à cette fin.',
    withdrawSuccess: 'Votre retrait a été soumis avec succès !',
    yourVisitorsPay: `Vos visiteurs paieront d'abord, puis seront redirigés vers votre {method}`,
    emailAddress: 'adresse e-mail',
    calendlyLink: 'lien Calendly',
    features: 'Avantages',
    featuresTooltip: 'Liste d’avantages affichée dans la mise en page de carte Vitrine',
    featurePlaceholder: 'Avantage',
    addFeature: 'Ajouter un avantage',
    pendingReviews: {
      title: 'Avis en attente',
      subtitle: 'Approuvez ou masquez les avis des acheteurs avant leur publication',
      empty: 'Aucun avis en attente de modération.',
      approve: 'Approuver',
      hide: 'Masquer',
    },
  },
  posts: {
    posts: 'Publications',
    title: 'Créez votre première publication',
    description:
      'Les publications vous permettent de créer des automatisations de chat dans un format simple et visuel. Essayez les automatisations que nous recommandons en fonction de vos objectifs',
    activate: 'Activer les publications',
    managePosts: 'Gérer les publications',
    postsTab: 'Onglet publications',
    displayLast: 'Afficher les dernières publications',
    tabNavigation: 'Paramètres de navigation par onglets',
    createFirstPost: 'Créez votre première publication sociale !',
    autoPostsText: 'Planifiez et publiez du contenu sur tous les réseaux sociaux en une seule fois !',
    createPost: 'Créer une publication',
  },
  messages: {
    title: 'Messages',
    addText: 'Ajoutez un bouton de message au bloc En-tête, permettant aux utilisateurs de vous envoyer facilement un message.',
    addButton: 'Ajouter un bouton Message',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'clics',
    createTitle: 'Créez votre première Instagram Reply !',
    text: 'Utilisez les messages directs automatiques Instagram pour partager automatiquement des liens avec votre audience !',
    createButton: 'Créer un Auto DM',
    subtitleComment: 'DM automatique avec un lien en réponse à un commentaire',
    subtitleDm: 'DM automatique en réponse à un message ou une Story',
    ready: 'prêt',
    edit: 'Modifier',
    stepContentTitle: 'Contenu IG',
    stepContentSub: 'Choisissez une publication ou un Reel',
    storiesAndDmsSub: 'DM automatique quand quelqu’un répond à une Story ou vous écrit',
    stepTriggerTitle: 'Déclencheur',
    stepTriggerSub: 'Mots-clés dans les commentaires',
    stepTriggerSubDm: 'Mots-clés dans les messages',
    stepDmTitle: 'DM',
    stepDmSub: 'Le message envoyé automatiquement',
    dmSummary: 'Message défini',
    activatesNow: 'La réponse automatique s’active immédiatement',
    saveAutomation: 'Enregistrer la réponse automatique',
    savedToast: 'Réponse automatique créée',
    linkLabel: 'Choisissez la destination du lien',
    selectDestination: 'Choisissez un lien, un produit ou un article',
    change: 'Changer',
    choose: 'Choisir',
    remove: 'Retirer',
    optional: 'facultatif',
    buttonText: 'Texte du bouton',
    addLink: 'Ajouter un lien',
    attachLink: 'Joindre un lien',
    noLinks: 'Aucun lien pour l’instant — ajoutez d’abord un lien dans votre Link in Bio.',
    tabLinks: 'Liens',
    tabProducts: 'Produits',
    noProducts: 'Aucun produit pour l’instant — créez d’abord un produit dans votre boutique.',
    tabArticles: 'Articles',
    noArticles: 'Aucun article pour l’instant — créez d’abord un article.',
    choosePost: 'Choisissez une publication ou un Reel',
    searchPosts: 'Rechercher dans vos publications',
    loadingPosts: 'Chargement de vos publications…',
    done: 'Terminé',
    oneSelected: '1 publication sélectionnée',
    postSelected: 'Publication sélectionnée',
    noPosts: 'Aucune publication pour l’instant — publiez une publication ou un Reel sur Instagram.',
    postsError: 'Impossible de charger les publications. Veuillez réessayer.',
    reauthTitle: 'Certains DM pourraient ne pas être délivrés.',
    reauthText: 'Instagram exige que vous réautorisiez le compte.',
    reconnect: 'Reconnecter',
    statActive: 'Automatisations actives',
    statDmSent: 'DM envoyés · 30 j',
    statClicks: 'Clics sur le lien',
    activeReplies: 'Réponses automatiques actives',
    filterAll: 'Toutes',
    filterActive: 'Actives',
    filterOff: 'Désactivées',
  },
  businessCards: {
    title: 'Cartes de visite',
    emptyTitle: 'Créez votre carte de visite numérique',
    emptySubtitle: 'Ajoutez vos coordonnées pour que chacun puisse les enregistrer sur son téléphone en un seul geste, puis partagez-les via un code QR ou un fichier .vcf.',
    createButton: 'Créer une carte de visite',
    sectionButton: 'Bouton « Enregistrer le contact »',
    sectionButtonSubtitle: `L'apparence du bouton « Enregistrer le contact » et son emplacement sur votre profil.`,
    showButton: 'Afficher sur mon profil',
    showButtonSubtitle: 'Affichez le bouton « Enregistrer le contact » sur votre page publique.',
    placement: 'Emplacement du bouton',
    placementSubtitle: 'Choisissez où le bouton apparaît.',
    showInHeader: 'Afficher dans l’en-tête',
    placementHeader: 'En-tête du profil',
    placementHeaderHint: 'Apparaît juste sous votre nom et votre avatar.',
    placementContact: 'Section Contacts',
    placementContactHint: 'Apparaît dans la fenêtre Contacts.',
    placementBottom: 'Bouton flottant',
    placementBottomHint: 'Reste en bas de la page lors du défilement.',
    none: 'Aucun',
    buttonLabel: 'Libellé du bouton',
    buttonLabelSubtitle: 'Texte affiché sur le bouton.',
    saveContact: 'Enregistrer le contact',
    sectionDetails: 'Coordonnées',
    sectionDetailsSubtitle: 'Ces coordonnées sont enregistrées dans la fiche de contact.',
    delete: 'Supprimer la carte de visite',
    previewHint: 'Voici comment votre carte apparaît aux visiteurs.',
    share: 'Partage et QR',
    shareSubtitle: 'Scannez le code ou partagez le lien pour ouvrir votre profil.',
    download: 'Télécharger le .vcf',
    copyLink: 'Copier le lien',
    copied: 'Lien copié !',
    digitalCard: 'Carte numérique',
    physicalCard: 'Carte physique',
    cardStyle: 'Style de la carte',
    cardStyleSubtitle: 'Définissez votre nom affiché, choisissez une couleur de fond et ajoutez votre carte à un portefeuille.',
    displayName: 'Nom affiché',
    backgroundColour: 'Couleur de fond',
    addAppleWallet: 'Ajouter à Apple Wallet',
    addGoogleWallet: 'Ajouter à Google Wallet',
    nameLabel: 'Nom',
    urlLabel: 'URL',
    walletScanTitle: `Scannez le code QR pour l'enregistrer dans votre portefeuille`,
    walletScanSubtitle: 'Elle sera enregistrée dans le portefeuille numérique de votre téléphone.',
    walletUseLink: 'Ou utilisez plutôt ce lien',
    walletComingSoonTitle: 'Presque terminé',
    walletComingSoon: 'Les cartes de portefeuille arrivent bientôt.',
    done: 'Terminé',
    physicalTitle: 'Commander une carte physique',
    physicalSubtitle: 'Les cartes de visite NFC arrivent bientôt.',
    leadCapture: 'Collecter des contacts',
    leadCaptureSubtitle: 'Permettez aux personnes qui reçoivent votre carte de partager leurs coordonnées en retour — directement dans votre Audience.',
    leadCaptureToggle: 'Activer « Partagez vos coordonnées »',
    leadCaptureToggleHint: 'Affiche un formulaire de contact sur votre carte publique.',
    leadTag: 'Taguer les nouveaux leads',
    leadTagSubtitle: 'Chaque contact collecté est tagué avec ceci (par ex. le nom d’un événement ou d’une campagne).',
    leadTagPlaceholder: 'par ex. Conférence 2026',
    renewLink: 'Renouveler le lien',
    renewing: 'Renouvellement…',
    renewConfirm: 'Renouveler le lien de la carte ? Votre QR code actuel et les liens partagés cesseront de fonctionner.',
    linkRenewed: 'Lien de la carte renouvelé',
    scans: '{count} scans',
  },
  shortLinks: {
    title: 'Raccourcisseur de liens',
    addLink: 'Ajouter un lien',
    name: 'Nom',
    slug: 'Slug',
    slugTooltip: 'Vous pouvez modifier le slug en cliquant sur le bouton de modification',
    destinationUrl: 'URL de destination',
    metadata: 'Métadonnées',
    utmTags: 'Tags UTM',
    customizeMetadata: 'Personnaliser les métadonnées du lien',
    metaTitle: 'Titre',
    metaDescription: 'Description',
    favicon: 'Favicon',
    imagePreview: `Aperçu de l'image`,
    addUtm: 'Ajouter des tags UTM au lien (optionnel)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Collez votre long lien ici',
    shorten: 'Raccourcir le lien',
    shortenGreeting: 'What are we shortening',
    shortenGreetingPlain: 'What are we shortening?',
    pasteLinkMulti: 'Paste a long link — or several, one per line',
    customSlug: 'Custom slug',
    customSlugPlaceholder: 'my-link',
    qrCode: 'QR code',
    qrDesign: {
      title: 'QR code for',
      close: 'Close',
      subtitle: 'Customize the look and download it — the link stays the same',
      codeColor: 'Code color',
      background: 'Background',
      transparent: 'Transparent',
      logo: 'Logo in the middle',
      logoSize: 'Logo size',
      none: 'None',
      avatar: 'Avatar',
      upload: 'Upload',
      quietZone: 'Quiet zone',
      quietZoneHint: 'the frame a scanner looks for',
      small: 'Small',
      normal: 'Normal',
      format: 'Format',
      size: 'Size',
      reset: 'Reset',
      copyImage: 'Copy image',
      copied: 'Copied',
      download: 'Download',
      preparing: 'Preparing…',
      contrastOk: 'Contrast is good enough to scan',
      contrastLow: 'Contrast is too low — phones may fail to scan',
      avatarFailed: 'Could not load your profile picture — upload an image instead',
      fileFailed: 'Could not read that image',
      downloadFailed: 'Could not prepare the file',
      copyFailed: 'Your browser did not allow copying the image',
    },
    edit: `Modifier les détails de l'élément`,
    status: 'Statut',
    expires: 'Expiration',
    noExpiry: 'sans limite',
    tags: 'Tags',
    noSocialPreview: 'Aucun aperçu social défini',
    addImage: 'Ajouter une image',
    regenerate: 'En générer un autre',
    all: 'Tous',
    addTag: 'tag',
    newTagPlaceholder: 'Nouveau tag, puis Entrée',
    frequent: 'Fréquents',
    duplicateTitle: 'Vous avez déjà un lien court pour cette URL',
    duplicateCreate: 'En créer un autre',
  },
  audience: {
    title: 'Audience',
    total: 'Total',
    totalMembers: `Nombre total de membres de l'audience`,
    totalContacts: 'Total des contacts',
    forms: 'Formulaires',
    subscribers: 'Abonnés',
    customers: 'Clients',
    noAudienceMembers: 'Aucun contact',
    emptyAudienceMembers: 'Ajoutez de nouveaux contacts en cliquant sur le bouton',
    addAudienceMember: 'Ajouter un contact',
    noSubscribers: 'Aucun abonné',
    emptySubscribers: 'Ajoutez de nouveaux abonnés en ajoutant des blocs à votre lien en bio',
    addDataCollect: 'Ajouter un bloc Collecte de données',
    noResponses: 'Aucune réponse',
    emptyResponses: 'Ajoutez de nouvelles réponses en ajoutant des blocs à votre lien en bio',
    addFormBlock: 'Ajouter un bloc Formulaire',
    noCustomers: 'Aucun client',
    emptyCustomers: 'Ajoutez de nouveaux clients en ajoutant un produit à votre lien en bio',
    addProduct: 'Ajouter un produit',
    addContactModal: {
      title: 'Ajouter un nouveau contact',
      name: 'Nom',
      nameTooltip: 'Entrez le nom de votre contact',
      email: 'E-mail',
      emailTooltip: `Entrez l'adresse e-mail de votre contact`,
      phone: 'Téléphone',
      phoneTooltip: 'Entrez le numéro de téléphone de votre contact',
      telegram: 'Telegram',
      telegramTooltip: `Entrez le nom d'utilisateur ou l'URL Telegram de votre contact`,
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Entrez le numéro WhatsApp de votre contact',
      instagram: 'Instagram',
      instagramTooltip: `Entrez le nom d'utilisateur ou l'URL Instagram de votre contact`,
      messenger: 'Messenger',
      messengerTooltip: `Entrez le nom d'utilisateur ou l'URL Messenger de votre contact`,
      viber: 'Viber',
      viberTooltip: 'Entrez le numéro Viber de votre contact',
      address: 'Adresse',
      addressTooltip: `Entrez l'adresse de votre contact`,
      add: 'Ajouter',
    },
    search: {
      search: 'Rechercher',
      error: 'Caractère invalide saisi dans le champ de recherche',
      notFound: 'Aucun résultat trouvé',
    },
  },
  auth: {
    logIn: 'Se connecter',
    logInWith: 'Se connecter avec',
    signIn: 'Se connecter',
    signInWith: `S'inscrire avec`,
    email: 'E-mail',
    password: 'Mot de passe',
    notHaveAccount: `Vous n'avez pas de compte ?`,
    createAccount: 'Créer un nouveau compte',
    createYourAccount: 'Créez votre compte',
    signUp: `S'inscrire`,
    haveAccount: 'Si vous avez déjà un compte',
    or: 'ou',
    reset: 'Réinitialiser',
    resetPassword: 'Réinitialiser le mot de passe',
    resetTitle: 'Le lien de récupération a été envoyé à votre e-mail',
    goToHome: `Aller à la page d'accueil`,
    byClicking: 'En cliquant sur',
    youAreAgree: 'vous acceptez les',
    terms: `Conditions d'utilisation`,
    andConfirm: 'et notre',
    usagePolicy: `Politique d'utilisation`,
    signInGoogle: 'Se connecter avec Google',
    forgotPassword: 'Mot de passe oublié ?',
  },
  menu: {
    moreApps: `Plus d'applications`,
    account: 'Compte',
    more: 'Plus',
    storyWidget: 'Embed Stories',
    integrations: 'Intégrations',
    socialAccounts: 'Comptes sociaux',
    aiContent: 'Contenu IA',
    aiPosts: 'Publications IA',
    postIdeas: 'Idées de publication',
    contentPlanner: 'Planificateur de contenu',
    aiImages: 'Images IA',
    aiVideo: 'Vidéo IA',
    planner: 'Planificateur',
    customers: 'Clients',
    subscribers: 'Abonnés',
    forms: 'Formulaires',
    allAudience: `Toute l'audience`,
    payments: 'Paiements',
    orders: 'Commandes',
    products: 'Produits',
    events: 'Événements',
    appointments: 'Rendez-vous',
    discounts: 'Réductions',
    affiliates: 'Affiliés',
    instantPages: 'Pages instantanées',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    linkInBio: 'Lien en bio',
    linkInBioApps: 'Lien en bio',
    website: 'Site web',
    store: 'Boutique',
    audience: 'Audience',
    emailMarketing: 'Marketing par e-mail',
    postPlaner: 'Planificateur de publications',
    posts: 'Publications',
    agents: 'Agents',
    community: 'Communauté',
    profileHealth: 'Santé du profil',
    socialPlanner: 'Planificateur social',
    shortLinks: 'Raccourcisseur de liens',
    businessCards: 'Cartes de visite',
    views: 'Vues',
    clicks: 'Clics',
    allWebsites: 'Tous les sites web',
    createNewAccount: 'Créer un nouveau compte',
    createNewWebsite: 'Créer un nouveau profil',
    tools: 'Outils',
    borderGenerator: 'Générateur de bordures',
    yourPlan: 'Votre forfait :',
    upgrade: 'Mettre à niveau',
    accountSettings: 'Paramètres du compte',
    manageWebsites: 'Gérer les profils',
    updates: 'Mises à jour',
    autoUpdate: 'Mise à jour automatique',
    logOut: 'Se déconnecter',
    myPages: 'Mes pages',
    design: 'Design',
    heading: 'En-tête',
    analytics: 'Analytique',
    settings: 'Paramètres',
    open: 'Ouvrir',
    language: 'Langue',
    siteLanguage: 'Langue du site public',
    dashboardLanguage: 'Langue du tableau de bord',
    movePage: 'Déplacer la page',
    editBlock: 'Modifier le bloc',
    renameBlock: 'Renommer le bloc',
    rename: 'Renommer',
    deleteBlock: 'Supprimer le bloc',
    archiveBlock: 'Archiver le bloc',
    archive: 'Archiver',
    scheduleBlock: 'Planifier le bloc',
    copyBlock: 'Copier le bloc',
    dublicateBlock: 'Dupliquer le bloc',
    content: 'Contenu',
    preview: 'Aperçu',
    copy: 'Copier',
    moveBlock: 'Déplacer le bloc',
    move: 'Déplacer',
    edit: 'Modifier',
    delete: 'Supprimer',
    schedule: 'Planifier',
    dublicate: 'Dupliquer',
    smartReply: 'Instagram Reply',
    marketing: 'Marketing',
    selectBlocks: 'Sélectionner des blocs',
    selectAll: 'Tout sélectionner',
    cancelSelection: 'Annuler',
    blocksSelected: 'sélectionnés',
    moveToPage: 'Déplacer vers la page',
    newPage: 'Nouvelle page',
    openPage: 'Ouvrir la page',
    pageSettings: 'Paramètres de la page',
    deletePage: 'Supprimer la page',
    appInBio: 'App en bio',
    blog: 'Blog',
    publish: 'Publier',
    creatorHub: 'Hub créateur',
    qrCodes: 'Codes QR',
    apps: 'Apps',
    automations: 'Automatisations',
    messages: 'Boîte de réception',
    form: 'Formulaires',
    embedTools: 'Embed Tools',
    adBuilder: 'Créateur de publicités',
    emailSignatures: 'Signatures d’e-mail',
    virtualBackgrounds: 'Arrière-plans virtuels',
    adsCampaigns: 'Gestionnaire de publicités',
    thumbnail: 'Miniature',
    buildFromReference: 'Créer à partir d’une référence',
  },
  modal: {
    addInstagram: 'Ajouter Instagram',
    addYourInstagram: 'Ajoutez votre compte Instagram',
    cropYourAvatar: 'Recadrer votre avatar',
    removeSite: 'Êtes-vous sûr(e) de vouloir supprimer le site ?',
    areYouSure: 'Êtes-vous sûr(e) de vouloir',
    areYouSureDelete: 'Êtes-vous sûr(e) de vouloir supprimer cette section ?',
    areYouSureArchive: 'Êtes-vous sûr(e) de vouloir archiver ce bloc ?',
    areYouSurePermanentDelete: 'Êtes-vous sûr(e) de vouloir supprimer définitivement ce bloc ? Cette action est irréversible.',
    remove: 'supprimer',
    site: 'site',
    removeAccountText: 'supprimer votre compte',
    moveBlock: 'Déplacer le bloc vers une autre page',
    moveBlockText: `Le bloc sera déplacé en bas d'une autre page. Vous pourrez ensuite réorganiser le bloc sur la nouvelle page`,
    profileTitle: 'Changer la photo de profil',
    profileText: 'Choisissez une image ou un GIF depuis votre appareil.',
    profileAvatar: 'Avatar de profil',
    addProfilePicture: 'Ajouter une photo de profil',
    storiesTitle: 'Stories',
    storiesText: 'Partagez vos moments quotidiens.',
    thoughtsTitle: 'Pensées',
    thoughtsText: 'Partagez vos pensées.',
    accountPageDescription: `Ceci est votre page de compte, où vous pouvez personnaliser l'apparence de votre page, ajouter différents blocs de fonctionnalités, et plus encore.`,
  },
  modalSubscribe: {
    plan: 'Forfait',
    usdMonth: 'USD/mois',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notifications',
    noNotification: 'Aucune notification pour le moment',
    inCategory: `Il n'y a aucun élément dans la catégorie`,
    categoryYet: 'pour le moment.',
    externalPixels: 'Pixels externes',
    parameters: 'paramètres',
    analyticsReports: 'Analytique et rapports',
    noUniLinkLogo: 'Sans logo UniLink',
    inProfile: 'dans le profil',
    verifiedBadge: 'Badge vérifié',
    your: 'Votre',
    customDomain: 'domaine personnalisé',
    emailMarketing: 'Marketing par e-mail',
    liveSupport: 'Support en direct',
    dataSecured: 'Les données sont sécurisées conformément à la norme PCI DSS',
    thankYou: 'Merci pour votre intérêt. Nous vous contacterons bientôt.',
    socialMediaScheduler: 'Planificateur de réseaux sociaux',
    featureRequest: 'Demande de fonctionnalité',
    markAllRead: 'Tout marquer comme lu',
    currentPlan: 'Forfait actuel',
    features: 'Fonctionnalités',
  },
  buttons: {
    upgrade: 'Mettre à niveau',
    buyProPlan: 'Acheter le forfait Pro',
    continue: 'Continuer',
    skip: 'Ignorer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    back: 'Retour',
    save: 'Enregistrer',
    add: 'Ajouter',
    added: 'Ajouté',
    done: 'Terminé',
    ok: 'OK',
    edit: 'Modifier',
    delete: 'Supprimer',
    remove: 'Retirer',
    setAsDefault: 'Définir par défaut',
    subscribeNow: `S'abonner maintenant`,
    yes: 'Oui',
    preview: 'Aperçu',
    generate: 'Générer',
    changePassword: 'Changer le mot de passe',
    deleteAccount: 'Supprimer le compte',
    removeAccount: 'Retirer le compte',
    deleteProfile: 'Supprimer le profil',
    addBlock: 'Ajouter un bloc',
    copyLink: 'Copier le lien',
    active: 'Actif',
    update: 'Mettre à jour',
    updatePro: 'Mettre à niveau',
    prev: 'Précédent',
    next: 'Suivant',
    uploadImage: 'Téléverser une image',
    uploadVideo: 'Téléverser une vidéo',
    loadMore: 'Charger plus',
    uploadProductImage: `Téléverser l'image du produit`,
    claim: 'Réclamer',
    removeSite: 'Supprimer le site',
    move: 'Déplacer',
    addButton: 'Ajouter un bouton',
    actionButton: `Bouton d'action`,
    directMessage: 'Message direct',
    subscribe: `S'abonner`,
    button: 'Bouton',
    generateWithAI: `Générer avec l'IA`,
    cta: 'CTA',
    cart: 'Panier',
    direct: 'Direct',
    follow: 'Suivre',
    addNewItem: 'Ajouter un nouvel élément',
  },
  support: {
    liveSupport: 'Support en direct',
    response: 'Nous répondons généralement en 1 minute pendant les heures de travail (8h - 22h) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Fondateur et PDG chez UniLink',
  },
  wizard: {
    createNewProfile: 'Créer un nouveau profil',
    createProfile: 'Créer le profil',
    continue: 'Continuer',
    tellUs: 'Parlez-nous de vous',
    addSocialLinks: 'Ajoutez tous les réseaux sociaux, et nous les afficherons dans votre base de données',
    addMoreLinks: 'Ajouter plus de liens',
    addLink: 'Ajouter un lien',
    selectCategory: 'Sélectionnez la catégorie qui vous décrit le mieux :',
    chooseTemplate: 'Choisir un modèle',
    skip: 'Ignorer',
    step: 'Étape',
    of: 'sur',
    yourName: 'Votre nom',
    search: 'Rechercher',
    blog: 'Blog',
    creator: 'Créateur',
    music: 'Musique',
    events: 'Événements',
    esoteric: 'Ésotérique',
    fashion: 'Mode',
    influencer: 'Influenceur',
    food: 'Alimentation',
    smallBusiness: 'Petite entreprise',
    marketing: 'Marketing',
    education: 'Éducation',
    socialMedia: 'Réseaux sociaux',
    coaching: 'Coaching',
    ecommerce: 'E-commerce',
    healthAndFitness: 'Santé et fitness',
    beautyWellness: 'Beauté et bien-être',
  },
  billing: {
    back: 'Retour',
    findPlan: 'Trouvez le forfait qui vous convient',
    changeAnytime: 'Vous pouvez changer à tout moment.',
    subtitle: 'Changez de formule ou résiliez à tout moment.',
    currentPlan: 'Formule actuelle',
    mostPopular: 'Le plus populaire',
    upgradeTo: 'Passer à {plan}',
    includes: 'Comprend :',
    everythingIn: 'Tout ce qui est dans {plan}, plus :',
    secure: 'Les paiements sont sécurisés conformément à la norme PCI DSS.',
  },
  field: {
    fullName: 'Nom complet',
    username: `nom d'utilisateur`,
    addValue: 'Ajouter une valeur',
    newValue: 'Nouvelle valeur',
    placeholderDefault: 'Texte, chiffres, symboles, etc.',
    addInstagramUsername: `Ajouter le nom d'utilisateur Instagram`,
    nameDefault: 'Jean',
    enterYourLink: 'Entrez votre lien',
    searchImage: 'Rechercher une image',
    pasteLink: 'Coller le lien',
    pasteLinkTip: `Ajoutez un lien vers n'importe quelle page web`,
    searchGIFs: 'Rechercher des GIF',
    searchIcons: 'Rechercher des icônes',
    searchVideo: 'Rechercher une vidéo',
    search: 'Rechercher',
    insertURL: `Insérer l'URL`,
    writeYourDescription: 'Rédigez votre description',
    headerCTAbutton: 'En-tête, bouton CTA',
    enterTitle: 'Entrez le titre',
    enterDescription: 'Entrez la description',
    enterURL: `Entrez l'URL canonique`,
  },
  tooltip: {
    addImage: 'Ajouter une image',
    labelModalTitle: `Paramètres de l'étiquette`,
    addLabel: '+ Ajouter une étiquette',
    label: 'Étiquette',
    labelCaption: `Entrez l'étiquette`,
    labelText: `Texte de l'étiquette`,
    labelTextCaption: `Entrez le texte de l'étiquette`,
    labelTextPlaceholder: 'Étiquette',
    labelUrl: `URL de l'étiquette`,
    labelUrlCaption: `Entrez l'URL de l'étiquette`,
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Aucune étiquette',
    colorFrom: 'Couleur de départ',
    colorTo: `Couleur d'arrivée`,
    highlight: 'Mise en avant',
    firstName: 'Prénom',
    firstNameCaption: 'Entrez votre prénom',
    lastName: 'Nom de famille',
    lastNameCaption: 'Entrez votre nom de famille',
    jobTitle: 'Intitulé du poste',
    jobTitleCaption: 'Entrez votre intitulé de poste',
    organization: 'Organisation',
    organizationCaption: 'Entrez votre organisation',
    email: 'E-mail',
    emailCaption: 'Entrez votre e-mail',
    workPhone: 'Téléphone professionnel',
    workPhoneCaption: 'Entrez votre téléphone professionnel',
    mobilePhone: 'Téléphone mobile',
    mobilePhoneCaption: 'Entrez votre téléphone mobile',
    website: 'Site web',
    websiteCaption: 'Entrez votre site web',
    information: 'Information',
    informationCaption: 'Entrez vos informations',
    streetAddress: 'Adresse',
    streetAddressCaption: 'Entrez votre adresse',
    city: 'Ville',
    cityCaption: 'Entrez votre ville',
    state: 'État/Région',
    stateCaption: 'Entrez votre état/région',
    postalCode: 'Code postal',
    postalCodeCaption: 'Entrez votre code postal',
    country: 'Pays',
    countryCaption: 'Entrez votre pays',
    titleColor: 'Couleur du titre',
    titleColorCaption: 'Vous pouvez changer la couleur du titre',
    fontFamily: 'Famille de police',
    fontFamilyCaption: 'Vous pouvez changer la famille de police',
    fontSize: 'Taille de police',
    fontSizeLabel: `Taille de police de l'étiquette`,
    fontSizeCaption: 'Vous pouvez changer la taille de police',
    fontSelect: 'Police',
    fontSelectCaption: 'Choisissez une police',
    imageMargin: `Marge de l'image`,
    profilePicture: 'Photo de profil',
    profilePictureCaption: 'Changez votre photo de profil',
    pictureSize: `Taille de l'image`,
    pictureSizeCaption: `Vous pouvez changer la taille de l'image`,
    title: 'Titre',
    titleCaption: 'Entrez un titre',
    blockCaption: 'Entrez le titre de votre bloc',
    titlePageCaption: 'Entrez le titre de votre page',
    templates: 'Modèles',
    templatesCaption: 'Choisissez un modèle pour votre page',
    background: 'Arrière-plan',
    backgroundColor: `Couleur d'arrière-plan`,
    textBackground: 'Arrière-plan du texte',
    textBackgroundCaption: `Choisir la couleur d'arrière-plan du texte`,
    textColor: 'Couleur du texte',
    textColorCaption: 'Choisir la couleur du texte',
    gradientBackground: 'Arrière-plan dégradé',
    gradientColor: 'Couleur du dégradé',
    BackgroundType: 'Type',
    backgroundSource: `Source de l'arrière-plan`,
    backgroundSourceCaption: `Choisissez la source de l'arrière-plan`,
    backgroundStyle: `Style de l'arrière-plan`,
    backgroundStyleCaption: `Choisissez le style de l'arrière-plan`,
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Verre',
    backgroundStylesOutline: 'Contour',
    backgroundTypeCaption: `Choisissez le type d'arrière-plan`,
    color: 'Couleur',
    colorTooltip: 'Vous pouvez changer la couleur',
    backgroundOpacityTooltip: `Faites glisser le curseur pour définir l'opacité de l'arrière-plan`,
    backgroundBlur: `Flou de l'arrière-plan`,
    backgroundBlurCaption: `Faites glisser le curseur pour régler le flou de l'arrière-plan`,
    backgroundBrightness: `Luminosité de l'arrière-plan`,
    backgroundBrightnessCaption: `Faites glisser le curseur pour changer la luminosité de l'arrière-plan`,
    backgroundContrast: `Contraste de l'arrière-plan`,
    backgroundContrastCaption: `Faites glisser le curseur pour changer le contraste de l'arrière-plan`,
    color1: 'Couleur 1',
    color2: 'Couleur 2',
    colorCaption: 'Entrez la couleur de votre page',
    gradient: 'Dégradé',
    image: 'Image',
    photo: 'Photo',
    gif: 'GIF',
    animation: 'Animation',
    video: 'Vidéo',
    hexColor: 'Couleur hexadécimale',
    direction: 'Direction',
    gradientDirection: 'Direction du dégradé',
    directionCaption: 'Faites glisser le curseur pour définir la direction du dégradé',
    offset: 'Décalage',
    gradientOffset: 'Décalage du dégradé',
    offsetCaption: 'Faites glisser le curseur pour définir le décalage du dégradé',
    backgroundDarkness: `Obscurcissement de l'arrière-plan`,
    backgroundDarknessCaption: `Faites glisser le curseur pour assombrir l'image d'arrière-plan`,
    uploadVideo: 'Téléverser une vidéo',
    uploadFile: 'Téléverser un fichier',
    uploadVideoCaption: `Vidéo de l'arrière-plan de votre page`,
    linkToVideo: 'Lien vers la vidéo',
    linkToVideoCaption: 'Ajoutez un lien vers la vidéo',
    videoWithSound: 'Vidéo avec son',
    videoWithSoundCaption: 'Lire la vidéo avec le son',
    fonts: 'Polices',
    fontWeight: 'Épaisseur de police',
    fontWeightCaption: 'Cliquez pour choisir votre destin',
    preloader: 'Préchargeur',
    preview: 'Aperçu',
    hideLogo: 'Masquer le logo UniLink',
    cover: 'Couverture',
    coverCaption: 'Changer la couverture',
    coverCaptionHeader: `Ajoutez une image ou une vidéo à la couverture de l'en-tête`,
    pageNavigation: 'Navigation de page',
    websiteNavigation: 'Navigation par onglets',
    backgroundOpacity: `Opacité de l'arrière-plan`,
    backgroundOpacityCaption: `Faites glisser le curseur pour régler l'opacité de l'arrière-plan du bouton`,
    borderRadius: 'Rayon de bordure',
    borderRadiusCaption: 'Faites glisser le curseur pour définir le rayon de bordure',
    heightTabs: 'Hauteur des onglets',
    heightTabsCaption: 'Faites glisser le curseur pour définir la hauteur des onglets',
    backgroundShadow: `Ombre de l'arrière-plan`,
    backgroundShape: `Forme de l'arrière-plan`,
    backgroundBorder: `Bordure de l'arrière-plan`,
    opacity: 'Opacité',
    opacityCaption: `Faites glisser le curseur pour définir l'opacité`,
    shape: 'Forme',
    shapeCaption: 'Définir la forme',
    text: 'Texte',
    textCaption: 'Entrez le texte',
    textSize: 'Taille du texte',
    textSizeCaption: 'Faites glisser le curseur pour définir la taille du texte',
    additionalText: 'Texte supplémentaire',
    username: `Nom d'utilisateur`,
    currency: 'Devise',
    language: 'Langue',
    timeZone: 'Fuseau horaire',
    websiteNiche: 'Niche du site web',
    websiteNicheCaption: 'Entrez la niche de votre site web',
    renameCaption: 'Renommer le titre du bloc',
    description: 'Description',
    descriptionCaption: 'Entrez une description',
    actionButton: `Bouton d'action`,
    actionButtonCaption: `Le bouton d'appel à l'action motive les visiteurs à agir`,
    animationDirection: `Direction de l'animation`,
    animationDirectionCaption: `Choisissez la direction de l'animation`,
    buttonTitle: 'Titre du bouton',
    buttonTitleCaption: 'Entrez le titre du bouton',
    buttonUrl: 'URL du bouton',
    buttonUrlCaption: `L'URL s'ouvrira dans une nouvelle fenêtre`,
    imageSize: `Taille de l'image`,
    imageSizeCaption: `Faites glisser le curseur pour définir la taille de l'image`,
    view: 'Vue',
    viewCaption: 'Choisissez une vue',
    margin: 'Marge',
    marginCaption: `Faites glisser le curseur pour ajouter une marge en haut et en bas de l'élément`,
    separateTopBottom: 'Haut / Bas',
    padding: 'Espacement',
    paddingCaption: `Faites glisser le curseur pour ajouter de l'espacement en haut et en bas de l'élément`,
    fullWidth: 'Pleine largeur',
    lineHeight: 'Hauteur de ligne',
    lineHeightCaption: 'Vous pouvez changer la hauteur de ligne',
    button: 'Bouton',
    titleSize: 'Taille du titre',
    titleSizeCaption: 'Vous pouvez changer la taille du titre',
    titleLineHeight: 'Hauteur de ligne du titre',
    titleLineHeightCaption: 'Personnalisez la hauteur de ligne du titre pour apporter plus de solutions de design au texte',
    layout: 'Disposition',
    layoutCaption: `Créez la disposition de l'en-tête que vous souhaitez`,
    layoutAlign: 'Alignement de la disposition',
    alignText: 'Aligner le texte',
    align: 'Alignement',
    alignCaption: `Choisissez l'alignement`,
    position: 'Position',
    positionCaption: 'Choisissez la position',
    width: 'Largeur',
    widthCaption: 'Choisissez la largeur de votre bannière',
    nameHeader: 'Nom',
    nameCaption: 'Entrez le nom de votre compte',
    shortBio: 'Courte biographie',
    shortBioCaption: 'Entrez une courte biographie de votre compte',
    externalLink: 'Lien externe',
    externalLinkCaption: 'Entrez un lien externe vers votre compte',
    location: 'Localisation',
    locationCaption: 'Entrez votre localisation',
    locationMap: 'Carte de localisation',
    locationMapCaption: `Entrez l'URL de votre localisation`,
    rightIcon: 'Icône droite',
    rightIconCaption: 'Cette icône apparaîtra à droite du bouton',
    buttons: 'Boutons',
    buttonsCaption: `Ajouter des boutons d'action`,
    nameLogo: 'Logo du nom',
    nameLogoCaption: 'Téléversez un logo pour votre nom',
    buttonText: 'Texte du bouton',
    buttonTextCaption: 'Entrez le nom de votre bouton',
    buttonColor: 'Couleur du bouton',
    buttonColorCaption: 'Choisissez les couleurs du bouton',
    buttonColorCTACaption: `Choisissez la couleur d'arrière-plan du bouton CTA`,
    cartColor: 'Couleur du panier',
    cartColorCaption: `Choisissez la couleur d'arrière-plan du panier`,
    ctaButton: 'Bouton CTA',
    ctaButtonCaption: 'Cette icône apparaîtra à droite du bouton',
    style: 'Style',
    socialIconsStyleCaption: 'Vous pouvez choisir le style de vos icônes sociales',
    socialIconsShape: 'Forme des icônes sociales',
    socialIconsShapeCaption: 'Vous pouvez choisir la forme des icônes sociales',
    headerTextColorCaption: `Vous pouvez choisir la couleur du texte de l'en-tête`,
    pictureShape: `Forme de l'image`,
    pictureShapeCaption: 'Vous pouvez choisir la forme de la photo de profil',
    socialLinks: 'Liens sociaux',
    socialLinksCaption: 'Ajoutez des boutons de liens sociaux pour une connexion rapide entre vous et vos clients en un clic',
    URL: 'URL',
    URLCaption: `Entrez l'adresse URL`,
    heading: 'En-tête',
    headingTitle: `Titre de l'en-tête`,
    headingTitleCaption: `Entrez le titre de l'en-tête`,
    headingDescription: `Description de l'en-tête`,
    headingDescriptionCaption: `Entrez la description de l'en-tête`,
    headingImage: `Image de l'en-tête`,
    headingImageCaption: 'Téléversez une image pour votre en-tête',
    headingPosition: `Position de l'en-tête`,
    headingInsideBlock: `À l'intérieur du bloc`,
    headingOutsideBlock: `À l'extérieur du bloc`,
    headingDivider: `Séparateur d'en-tête`,
    canonicalURL: 'URL canonique',
    seo: 'SEO',
    seoCaption: 'Personnalisez votre produit avec des balises méta SEO',
    themes: 'Thèmes',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Appliquer au profil',
    syncBlocks: 'Synchroniser tous les blocs',
    brandColorsApplied: 'Couleurs de marque appliquées',
    generatedPalette: 'Palette générée',
    applying: 'Application...',
    syncing: 'Synchronisation...',
    backgroundType: `Type d'arrière-plan`,
    palettes: 'Palettes',
    previewTitle: 'Titre',
    previewTitleCaption: `Saisir le titre de l'aperçu`,
    previewDescription: 'Description',
    previewDescriptionCaption: `Saisir la description de l'aperçu`,
    previewButton: 'Texte du bouton',
    previewButtonCaption: `Saisir le texte du bouton de l'aperçu`,
    previewLabel: `Texte de l'étiquette`,
    previewLabelCaption: `Saisir le texte de l'étiquette de l'aperçu`,
    previewThumbnail: 'Miniature',
    previewThumbnailCaption: `Téléverser la miniature de l'aperçu`,
    myTemplates: 'Mes modèles',
    myTemplatesEmpty: `Aucun modèle pour l'instant. Enregistrez le design de votre page actuelle pour le réutiliser plus tard.`,
    saveAsTemplate: 'Enregistrer comme modèle',
    saveCurrentAsTemplate: `Enregistrer l'actuel comme modèle`,
    templateSaved: 'Modèle enregistré',
    templateApplied: 'Modèle appliqué',
    buildFromReference: 'Créer depuis une référence',
    templateAppliedCount: 'Modèle appliqué — {n} blocs ajoutés',
    searchTemplates: 'Rechercher des modèles…',
    favorites: 'Favoris',
    previewLive: 'Aperçu en direct',
    previewingTemplate: 'Aperçu',
    exitPreview: 'Quitter',
    templateKind: 'Que faut-il inclure',
    publish: 'Publier',
    unpublish: 'Dépublier',
    templatePublished: 'Modèle publié',
    templateUnpublished: 'Modèle dépublié',
    discoverTemplates: 'Découvrir la communauté',
    discoverSubtitle: `Modèles gratuits publiés par d'autres créateurs sur UniLink.`,
    discoverEmpty: `Aucun modèle public pour l'instant — soyez le premier à en publier un.`,
    pricing: 'Tarifs',
    fontRoles: {
      heading: 'Titre',
      subtitle: 'Sous-titre',
      body: 'Global',
    },
  },
  table: {
    clicks: 'Clics',
    signups: 'Inscriptions',
    views: 'Impressions',
    orderNumber: 'Numéro de commande',
    amount: 'Montant',
    credits: 'Crédits',
    invoice: 'Facture',
    email: 'E-mail',
    card: 'Carte',
    currency: 'Devise',
    name: 'Nom',
    contact: 'Contact',
    optIn: 'Consentement',
    notes: 'Notes',
    address: 'Adresse',
    date: 'Date',
    action: 'Action',
    custom: 'Personnalisé',
    status: 'Statut',
    tags: 'Tags',
    view: 'Voir',
    remove: 'Supprimer',
    sendEmail: 'Envoyer un e-mail',
    details: 'Détails',
    purchases: 'Achats',
    order: 'Commande',
    money: 'Argent',
    type: 'Type',
    orderCode: 'Code de commande',
  },
  settings: {
    title: 'Paramètres',
    settings: 'paramètres',
    accountSettings: 'Paramètres du compte',
    email: 'E-mail',
    subscription: 'Abonnement',
    billingHistory: 'Historique de facturation',
    dueTo: 'Échéance le',
    subscriptionDueTo: `Abonnement valable jusqu'au`,
    cancelSubscription: `Annuler l'abonnement`,
    cancelSubscriptionConfirm: 'Êtes-vous sûr de vouloir annuler votre abonnement ?',
    subscriptionCancelled: `Votre abonnement a été annulé. Votre plan reste actif jusqu'à la fin de la période de facturation.`,
    subscriptionCancelError: `Échec de l'annulation. Veuillez contacter le support.`,
    deleteFirst: 'Supprimer définitivement votre',
    deleteSecond: 'et toutes ses données. Cette action est irréversible.',
    account: {
      title: 'Compte',
      usernameNotAvailable: `Le nom d'utilisateur n'est pas disponible`,
      setupCustomDomain: 'Configurer un domaine personnalisé',
      subtitle: 'E-mail du compte, facturation, mot de passe et clé API',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: `Le nom d'utilisateur n'est pas disponible`,
      setupCustomDomain: 'Configurer un domaine personnalisé',
      subtitle: `Gérer le nom d'utilisateur, la langue, la devise, le fuseau horaire`,
      category: 'Catégorie',
      categoryCaption: 'Entrez la catégorie de votre profil',
      usernameDesc: 'Votre identifiant public',
      currencyDesc: 'Utilisée pour les revenus et les versements',
      languageDesc: 'Langue affichée à vos visiteurs',
      timeZoneDesc: 'Pour la planification et les analyses',
      categoryDesc: 'Décrit le mieux votre profil',
      privateProfile: 'Profil privé',
      privateProfileDesc: 'Seuls les abonnés approuvés peuvent voir votre profil',
    },
    aiassistant: {
      title: 'Assistant IA',
      subtitle: 'Personnalisez votre assistant IA pour des réponses meilleures et plus personnalisées',
      titleText: `Aidez l'IA à comprendre qui vous êtes pour des réponses plus pertinentes`,
      customAiTitle: 'Instructions personnalisées',
      customAiPlaceholder: `Ajoutez des instructions spécifiques pour l'IA...`,
      customAiDescription: `Ces instructions seront appliquées à chaque conversation avec l'IA`,
      nicknameTitle: `Comment l'IA doit-elle vous appeler ?`,
      nicknamePlaceholder: 'Surnom',
      titleBio: 'Bio / Description',
      bioPlaceholder: 'Parlez-nous un peu de vous...',
      occupation: 'Que faites-vous ?',
      occupationPlaceholder: `ex. Étudiant en ingénierie à l'Université de Waterloo`,
      aboutYouTitle: 'À propos de vous',
      aboutYouTooltip: 'Dites à votre assistant IA un peu sur vous',
      locationTitle: 'Localisation',
      locationPlaceholder: 'ex. Kyiv, Ukraine',
      categoryTitle: 'Catégorie',
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Configurez les notifications pour les nouveaux visiteurs, e-mails et commandes',
      text: 'Connectez des messageries pour recevoir des notifications sur les nouveaux e-mails et commandes de vos clients',
      setUpWebhooks: 'Configurez les webhooks dans la section Webhooks',
      save: 'Enregistrer',
      connect: 'CONNECTER',
      disconnect: 'DÉCONNECTER',
      webhook: 'Webhook',
      emailSubmit: 'Soumission de collecte de données',
      formSubmit: 'Soumission de formulaire',
      showSubmit: 'Soumission boutique',
      digitalSubmit: 'Soumission numérique',
      appointmentSubmit: 'Soumission de rendez-vous',
      requestSubmit: 'Soumission de service',
      donationSubmit: 'Soumission de don',
      email: 'E-mail',
      settings: 'paramètres',
      cartSubmit: 'Soumission du panier',
      linkClick: 'Clic sur le lien',
      contactClick: 'Clic sur le contact',
      all: 'Tous',
      updates: 'Mises à jour',
      messages: 'Messages',
      opportunities: 'Opportunités',
      insights: 'Informations',
      activity: 'Activité',
      system: 'Système',
      news: 'Actualités',
      more: 'Afficher plus',
      less: 'Afficher moins',
      connectedAccounts: 'Comptes connectés',
      addEmailAccount: 'Ajouter un compte e-mail',
    },
    paymentSystem: {
      title: 'Système de paiement',
      subtitle: 'Configurez les paiements via Stripe ou PayPal',
      text: 'Voir les frais de traitement',
      connected: 'Connecté',
      active: 'Accepter les paiements sur le site web',
      pending: 'En attente',
      disconnect: 'Déconnecter',
      connect: 'Connecter',
      add: 'Ajouter',
      ofYourAccount: 'de votre compte',
      save: 'Enregistrer',
    },
    shop: {
      title: 'Boutique',
      subtitle: 'Paramétrer les catégories et propriétés',
      label: {
        title: 'Étiquettes',
        subtitle: 'Ajoutez des étiquettes aux fiches produits',
        addValue: 'Ajouter une valeur',
        save: 'Enregistrer',
        value: 'Valeur',
        enterTitle: 'Entrez le titre',
        maximum: 'Le nombre maximum de valeurs est de 5',
        add: 'Ajouter',
        edit: 'Modifier',
        labels: 'Étiquettes',
      },
      category: {
        title: 'Catégories',
        subtitle: 'Ajoutez une catégorie à vos produits',
        addCategory: 'Ajouter une catégorie',
        save: 'Enregistrer',
        maximum: 'Le nombre maximum est de',
        editTitle: 'Catégorie',
        name: 'Nom',
        namePlaceholder: 'Saisissez la catégorie',
        visibility: 'Visibilité',
        visible: 'Visible',
        hidden: 'Masquée',
        description: 'Description',
        descriptionHint: 'La description doit faire moins de 100 caractères',
        descriptionPlaceholder: 'Ajoutez une brève description',
        cover: 'Couverture',
        view: 'Voir',
        share: 'Partager',
        linkCopied: 'Lien copié',
        saveFirst: `Enregistrez d'abord la catégorie`,
        moveOut: 'Retirer',
      },
      property: {
        title: 'Propriété',
        subtitle: 'Ajoutez une propriété à vos produits',
        addProperties: 'Ajouter des propriétés',
        properties: 'Propriétés',
        type: 'Type',
        typeTooltip: 'Type de vos propriétés',
        titleModal: 'Titre',
        titleModalTooltip: 'Nom de vos propriétés',
        enterTitle: 'Entrez le titre',
        value: 'Valeur',
        addValue: 'Ajouter une valeur',
        maximum: 'Le nombre maximum de valeurs est de',
        save: 'Enregistrer',
        cancel: 'Annuler',
        remove: 'Supprimer',
        addPropertyToItem: `Ajouter une propriété à l'élément`,
        add: 'Ajouter',
        edit: 'Modifier',
        propertiesSmall: 'propriétés',
        required: 'Obligatoire',
        requiredTooltip: `Définir les propriétés obligatoires pour l'achat`,
        selectAll: 'Tout sélectionner',
      },
      actionButtons: {
        contentTab: 'Contenu',
        designTab: 'Design',
        buttonTitle: 'Titre du bouton',
        buttonColor: 'Couleur du bouton',
        cancel: 'Annuler',
        save: 'Enregistrer',
        maxChars: 'Maximum {count} caractères',
        minChars: 'Minimum {count} caractères',
        enterTitle: 'Saisissez un titre de bouton',
        contactTooltip: 'Un moyen pour les clients de vous joindre : e-mail, message ou formulaire',
        contactNotConfigured: 'Choisissez comment les clients vous joignent',
        methodEmail: 'Lettre par email',
        methodMessenger: 'Messagerie',
        methodForm: 'Formulaire de demande',
        enterAddress: 'Saisissez une adresse',
        invalidAddress: 'Adresse invalide',
        enterContact: 'Saisissez un numéro ou un nom d’utilisateur',
        summaryFields: '{count} champs',
        dragToReorder: 'Faites glisser pour réordonner',
        fieldName: 'Nom du champ',
        fieldRequired: 'Obligatoire',
        deleteField: 'Supprimer le champ',
        enterFieldName: 'Saisissez le nom du champ',
        addAtLeastOneField: 'Ajoutez au moins un champ',
        maxFields: 'Maximum {count} champs',
        typeText: 'Texte',
        typeEmail: 'E-mail',
        typePhone: 'Téléphone',
        preorderTooltip: 'Formulaire de précommande pour ce produit',
        preorderRowHint: 'Champs remplis par l’acheteur — ouvrez pour modifier',
        saveFailed: 'Enregistrement impossible. Réessayez.',
        preorderNotConfigured: 'Configurez le formulaire de précommande',
        enableAtLeastOneField: 'Activez au moins un champ',
        enterSubmitTitle: 'Saisissez le titre du bouton d’envoi',
        invalidUrl: 'Lien invalide',
        redirectHelper: 'Si vide, le client reste sur la page et voit le texte ci-dessous.',
        discardTitle: 'Fermer sans enregistrer ?',
        discardText: 'Les modifications des réglages du bouton seront perdues.',
        discardContinue: 'Continuer l’édition',
        discardClose: 'Fermer',
        contactModalTitle: 'Bouton Contact',
        preorderModalTitle: 'Bouton de précommande',
        contactModalSubtitle: 'Une action par bouton. Où arrive le résultat se règle à l’étape suivante',
        actionTab: 'Action',
        methodFormDesc: 'Le client remplit des champs',
        methodChat: 'Chat en direct',
        methodChatDesc: 'Une conversation en temps réel ici même',
        methodMessengerDesc: 'WhatsApp, Telegram, Viber…',
        methodEmailDesc: 'Ouvre la messagerie du client',
        inboxDefaultNote: 'Par défaut tout est conservé dans votre Unilink Inbox — vous pourrez le changer plus tard.',
        readyToSave: 'Prêt à enregistrer',
        apply: 'Appliquer',
        back: 'Retour',
        pickAction: 'Choisissez ce que fait le bouton',
        buttonText: 'Texte du bouton',
        buttonBackground: 'Fond du bouton',
        buttonTextColor: 'Couleur du texte',
        lowContrastWarning: 'Le texte se confond avec le fond — le client ne pourra pas lire le libellé.',
        colorsSharedNote: 'Les couleurs s’appliquent au bouton sur la page du produit.',
        chatNoSetup: "Rien à régler : le chat s'ouvre sur la page et la conversation arrive dans votre Inbox.",
        yourEmail: 'Votre email',
        yourEmailHelper: "La messagerie du client s'ouvre avec une lettre à cette adresse.",
        channelAndContact: 'Canal et contact',
        singleChannelNote: "Le bouton ouvre la discussion dans l'application choisie directement.",
        addContact: 'Ajouter un contact',
        deleteContact: 'Supprimer le contact',
        contactsCount: '{count} contacts',
        maxContacts: 'Maximum {count} contacts',
        duplicateContact: 'Cette application est déjà dans la liste',
        multiChannelNote: "Le bouton ouvre une liste et le client choisit l'application.",
        recapMessengers: 'Le client choisit : {apps}',
        whatToAsk: "Ce qu'on demande",
        fieldsOfMax: '{count} champs sur {max}',
        fieldOptional: 'Facultatif',
        typeLongText: 'Texte long',
        duplicateField: 'Un champ de ce nom existe déjà au-dessus',
        addReplyableField: "Ajoutez un email ou un téléphone — sinon il n'y aura aucun moyen de répondre",
        presetName: 'Nom',
        presetEmail: 'Email',
        presetPhone: 'Téléphone',
        presetComment: 'Commentaire',
        presetOwnField: 'champ personnalisé',
        thanksText: "Texte après l'envoi",
        thanksPlaceholder: 'Merci ! Nous répondrons dans la journée.',
        recapForm: 'La demande arrive {targets}',
        recapChat: 'La conversation arrive dans votre Unilink Inbox',
        recapMessenger: 'Le client passe sur {app}',
        recapEmail: "La messagerie du client s'ouvre avec une lettre à {address}",
        recapEmailFallback: 'votre adresse',
        recapTargetInbox: 'dans votre Unilink Inbox',
        actionsLabel: 'Moyens de contact',
        actionsOfMax: '{count} sur {max}',
        actionsCount: '{count} actions',
        addAction: 'Ajouter une action',
        addFirstAction: 'Ajoutez le premier moyen de vous joindre',
        deleteAction: "Supprimer l'action",
        actionNeedsAttention: 'À compléter',
        severalActionsNote: 'Chaque action est un bouton distinct sur la page du produit, dans cet ordre.',
        methodAlreadyAdded: 'Déjà dans la liste',
        duplicateChannel: 'Ce canal avec ce contact est déjà dans la liste',
        duplicateTitle: 'Un autre bouton utilise déjà ce texte',
        defaultTitleForm: 'Nous contacter',
        defaultTitleChat: 'Discuter avec nous',
        defaultTitleEmail: 'Nous écrire un email',
        buyModalTitle: 'Bouton Buy',
        buyModalSubtitle: 'Emmène l’acheteur directement au paiement',
        buyTooltip: 'Le bouton emmène l’acheteur directement au paiement',
        buyNoPrice: 'Texte seul, sans prix',
        priceOnButton: 'Prix sur le bouton',
        priceOnButtonHelper: 'Laissez vide et le bouton n’affiche que le texte',
        invalidPrice: 'Le prix est un nombre seulement, p. ex. 990',
        redirectModalTitle: 'Bouton Redirect',
        redirectModalSubtitle: 'Renvoie vers n’importe quelle page par un lien',
        redirectTooltip: 'Le bouton ouvre n’importe quelle page par un lien',
        linkLabel: 'Lien',
        linkPlaceholder: 'https://example.com/page',
        opensHost: 'Ouvrira : {host}',
        openInNewTab: 'Ouvrir dans un nouvel onglet',
        enterLink: 'Indiquez le lien qu’ouvre ce bouton',
        noLinkSet: 'Aucun lien',
        preorderModalSubtitle: 'Recueille les précommandes avant l’ouverture des ventes — sans paiement',
        shipEta: 'Quand vous expédiez',
        shipEtaPlaceholder: 'p. ex. avant le 15 septembre',
        shipEtaHelper: 'Affiché dans le formulaire — l’acheteur voit le délai et le demande moins souvent',
        fieldsInForm: 'Champs dans le formulaire : {count}',
        enableFieldFirst: 'Activez d’abord le champ',
        submitInForm: 'Texte du bouton du formulaire',
        afterSubmit: 'Après l’envoi',
        afterSubmitText: 'Afficher un texte',
        afterSubmitUrl: 'Renvoyer vers une page',
        afterSubmitTextHelper: 'L’acheteur reste sur la page et lit ce texte',
        preorderThanksPlaceholder: 'Merci ! Nous vous écrirons dès que le produit sera prêt.',
        enterRedirectUrl: 'Indiquez l’URL de la page, ou revenez à l’affichage d’un texte',
      },
      preorderForm: {
        title: 'Formulaire de précommande',
        subtitle: 'Configurer les champs du formulaire de précommande',
        fields: 'Champs',
        fieldsTooltip: 'Ajouter des champs au formulaire',
        required: 'Obligatoire',
        submitButton: 'Titre du bouton de soumission',
        redirectUrl: 'URL de redirection (optionnel)',
        resultText: 'Texte de résultat',
        save: 'Enregistrer',
        name: 'Nom',
        emailAddress: 'Adresse e-mail',
        phone: 'Téléphone',
        address: 'Adresse',
        comment: 'Commentaire',
      },
      shipping: {
        title: 'Formulaire de paiement',
        subtitle: 'Champs que l’acheteur remplit lors de la commande',
        fields: 'Champs',
        fieldsTooltip: 'Ajouter des champs au formulaire de livraison',
        required: 'Obligatoire',
        save: 'Enregistrer',
        name: 'Nom',
        emailAddress: 'Adresse e-mail',
        phone: 'Téléphone',
        address: 'Adresse',
        comment: 'Commentaire',
        askDetails: 'Demander les coordonnées de l’acheteur',
        askDetailsHint: 'Désactivé — la commande est prise sans formulaire',
        askDetailsPaymentWarning:
          'Le paiement se fait en ligne. Sans e-mail, le reçu n’a pas de destinataire : laissez au moins E-mail activé, ou passez au mode «Prendre la commande, sans paiement».',
        askDetailsRedirectNote: 'La commande se termine sur un autre site : ces champs ne sont jamais montrés aux acheteurs.',
        askDetailsNoContactNote: 'La commande arrivera sans coordonnées. Laissez Téléphone activé si vous comptez rappeler l’acheteur.',
        promoCode: 'Code promo',
        addCustomField: 'Ajouter un champ personnalisé',
        addFormInfo: 'Ajouter les informations du formulaire',
        editFormInfo: 'Modifier les informations du formulaire',
        type: 'Type',
        typeTooltip: 'Type de champ personnalisé',
        fieldName: 'Nom du champ',
        fieldNameTooltip: 'Nom du champ personnalisé',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder du champ personnalisé',
        delete: 'Supprimer',
        update: 'Mettre à jour',
        add: 'Ajouter',
      },
      delivery: {
        title: 'Modes de livraison',
        subtitle: `Expédition, livraison et retrait`,
        loading: 'Chargement…',
        inactive: 'inactif',
        confirmDelete: 'Supprimer ce mode de livraison ?',
        category: {
          shipping: 'Expédition',
          localDelivery: 'Livraison locale',
          selfPickup: 'Retrait en magasin',
        },
        rateType: {
          free: 'Gratuit',
          conditionalFree: 'Gratuit sous conditions',
          flatRate: 'Tarif fixe',
          customRates: 'Tarifs personnalisés',
          carrierApi: 'API transporteur',
        },
        carrier: {
          custom: 'Transporteur personnalisé',
        },
        add: {
          shipping: 'Ajouter une expédition',
          localDelivery: 'Ajouter une livraison locale',
          selfPickup: 'Ajouter un retrait en magasin',
        },
        actions: {
          edit: 'Modifier',
          delete: 'Supprimer',
          save: 'Enregistrer',
          cancel: 'Annuler',
        },
        fields: {
          name: 'Nom',
          namePh: 'p. ex. Livraison standard',
          description: 'Description',
          isActive: 'Actif',
          estimatedDays: 'Délai estimé (jours)',
          currency: 'Devise',
          countryCodes: 'Codes pays (CSV)',
          carrier: 'Transporteur',
          rateType: 'Type de tarif',
          flatPrice: 'Tarif fixe',
          freeThreshold: 'Gratuit à partir de (sous-total)',
          fallbackPrice: 'Tarif de secours',
          customRates: 'Lignes de tarifs personnalisés',
          senderCity: `Nom de la ville d'expédition`,
          senderCityRef: `Réf. de la ville d'expédition`,
          pickupInstructions: 'Instructions de retrait',
          pickupCharge: 'Frais de retrait',
          askPickupDateTime: 'Demander la date/heure de retrait au paiement',
        },
        rateRow: {
          subtotal: 'Par sous-total',
          weight: 'Par poids (g)',
          min: 'Min',
          max: 'Max',
          price: 'Prix',
          add: 'Ajouter une ligne',
        },
      },
      legal: {
        title: 'Documents légaux',
        subtitle: 'CGV, confidentialité, retours',
        loading: 'Chargement…',
        empty: `Aucun document légal pour l'instant.`,
        inactive: 'inactif',
        required: 'obligatoire',
        confirmDelete: 'Supprimer ce document ?',
        addNew: '+ Ajouter un document',
        types: {
          terms: `Conditions d'utilisation`,
          privacy: 'Politique de confidentialité',
          returns: 'Politique de retour / remboursement',
          shipping: `Politique d'expédition`,
          cookies: 'Politique de cookies',
          custom: 'Personnalisé',
        },
        fields: {
          title: 'Titre',
          titlePh: `p. ex. Conditions d'utilisation`,
          type: 'Type de document',
          content: 'Contenu',
          contentPh: 'Rédigez votre texte légal ici…',
          isActive: 'Actif',
          requireAcceptance: `Exiger l'acceptation au paiement`,
        },
        actions: {
          edit: 'Modifier',
          delete: 'Supprimer',
          save: 'Enregistrer',
          cancel: 'Annuler',
        },
      },
      checkoutGroup: 'Paiement',
      serviceCharge: {
        title: 'Frais de service',
        subtitle: 'Ajoutez des frais de service ou un pourboire à chaque commande.',
        label: 'Description',
        labelPh: 'p. ex. Frais de service 5 % et pourboire de livraison 3 $',
        rate: 'Taux',
        rateHint: 'Pourcentage du sous-total de la commande.',
        amount: 'Montant',
        amountHint: 'Montant fixe ajouté en supplément.',
      },
      tip: {
        title: 'Pourboires',
        subtitle: `Permettez aux clients d'ajouter un pourboire à leur commande au paiement.`,
        enable: 'Activer les pourboires',
        presets: 'Pourboires prédéfinis (%)',
        noPresets: `Aucun préréglage pour l'instant — ajoutez-en un ci-dessous.`,
        presetPh: 'p. ex. 10',
        addPreset: '+ Ajouter un préréglage',
        presetsHint: `Affichés comme boutons de sélection rapide au paiement. Jusqu'à 6.`,
        remove: 'Retirer',
        allowCustom: 'Autoriser un montant personnalisé',
        label: `Libellé de l'invite`,
        labelPh: 'p. ex. Ajoutez un pourboire pour un excellent service',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
      },
      orderNumber: {
        title: 'Numéro de commande',
        subtitle: `Personnalisez l'apparence des numéros de commande.`,
        next: 'Prochain numéro de commande',
        prefix: 'Préfixe',
        suffix: 'Suffixe',
        showInMessage: 'Afficher dans la facture et le message de commande',
        reset: 'Réinitialiser le numéro de commande',
      },
      orderMessage: {
        title: 'Message de commande',
        subtitle: 'Personnalisez la confirmation de commande envoyée aux clients.',
        footer: 'Pied du message',
        footerPh: 'p. ex. Merci pour votre commande ! Suivez-nous @votremarque',
        footerHint: 'Ajouté à chaque message de confirmation de commande.',
        plain: 'Message brut',
        plainHint: 'Supprimer toute la mise en forme du message de commande.',
      },
      invoice: {
        title: 'Facture',
        subtitle: 'Facture personnalisée jointe aux commandes payées.',
        upgrade: 'Passer à la version supérieure',
        showLogo: 'Afficher le logo',
        header: 'En-tête',
        footer: 'Pied de page',
        companyName: `Nom de l'entreprise`,
        companyEmail: `E-mail de l'entreprise`,
        companyPhone: `Téléphone de l'entreprise`,
        companyAddress: `Adresse de l'entreprise`,
        companyAddressPh: `Saisissez l'adresse`,
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personnalisez votre page avec des balises méta SEO',
      titleText: 'Titre',
      titlePlaceholder: 'Entrez le titre de la page',
      description: 'Description',
      descriptionPlaceholder: 'Entrez la description de la page',
      favicon: 'Favicon',
      uploadFavicon: 'Téléverser le favicon',
      imagePreview: `Aperçu de l'image`,
      useCustom: 'Utiliser une image personnalisée',
      save: 'Enregistrer',
      visualise: `Visualisez l'aperçu de votre site web dans Google`,
      inMessengers: 'Dans les messageries',
      inSocial: 'Sur les réseaux sociaux',
      searchEngine: 'Moteur de recherche',
      googleIndexable: 'Indexable par Google',
      sitemap: {
        title: 'Plan du site',
        entryHint: 'Gérez les pages et produits que les moteurs de recherche peuvent indexer.',
        setupLink: 'personnaliser',
        mainEntry: 'Indexer le site web',
        subtitle: 'Choisissez les pages que les moteurs de recherche doivent indexer. Les pages désactivées reçoivent une balise noindex et sont retirées de votre plan du site.',
        mainPage: 'Page de profil principale',
        pagesSection: 'Pages',
        pagesHint: `Activez l'indexation pour chaque page supplémentaire de votre site.`,
        noPages: `Aucune page supplémentaire pour l'instant.`,
        productsSection: 'Produits',
        productsHint: `Activez l'indexation pour chaque page produit.`,
        noProducts: `Aucun produit pour l'instant.`,
        postsSection: 'Publications',
        postsHint: `Activez l'indexation pour chaque publication.`,
        noPosts: `Aucune publication pour l'instant.`,
        blogSection: 'Articles de blog',
        blogHint: `Activez l'indexation pour chaque article de blog.`,
        noArticles: `Aucun article de blog pour l'instant.`,
        loadMore: 'Charger plus',
        loading: 'Chargement…',
      },
    },
    analytics: {
      title: 'Analytique',
      subtitle: 'Intégrez Facebook Pixel, Google Analytics et les paramètres UTM',
      facebookTooltip: 'Connectez Facebook pour afficher les analyses',
      googleAnalyticsTooltip: 'Google Analytics vous permet de mesurer le retour sur investissement de votre publicité et de suivre tous vos liens.',
      googleTagManagerTooltip: 'Google Tag Manager vous permet de configurer et de déployer instantanément des balises sur votre site web',
      tikTokPixelTooltip: `Le pixel TikTok est un outil de mesure puissant qui suit l'impact de vos publicités TikTok sur votre site web`,
      pinterestTag: 'Balise Pinterest',
      pinterestTagTooltip: `La balise Pinterest est un morceau de code que vous ajoutez à votre site web, ce qui permet à Pinterest de suivre les visiteurs de votre site ainsi que les actions qu'ils effectuent après avoir vu votre publicité Pinterest.`,
      tag: 'balise',
      headerTagTooltip: `Collez la balise qui apparaît dans l'en-tête de votre site web`,
      bodyTagTooltip: 'Collez la balise qui apparaît dans le corps de votre site web',
      utmParameters: 'Paramètres UTM',
      utmParametersTooltip: 'Collectez des données de campagne avec des URL personnalisées. Ajoutez des paramètres aux URL pour identifier les campagnes qui génèrent du trafic.',
      makeAnalytics: 'Faire afficher le trafic UniLink comme Social dans Google Analytics',
      the: 'Le',
      campaign: 'paramètre de campagne',
      parameter: 'est défini dynamiquement à partir du titre de chaque publication ou lien',
      save: 'Enregistrer',
    },
    customDomain: {
      title: 'Domaine personnalisé',
      subtitle: 'Personnalisez votre page avec un domaine personnalisé',
      titleTooltip: 'Ajouter un domaine personnalisé',
      save: 'Enregistrer',
      connect: 'Connecter',
      connecting: 'Connexion en cours',
      instructions: 'Instructions',
      submit: 'Soumettre',
      submitting: 'Soumission en cours...',
      enterDomain: 'Entrez votre domaine',
      domainPlaceholder: 'votre-domaine.com',
      steps: {
        submitting: 'Soumission de la demande',
        validation: 'Validation du domaine',
        certificate: 'Provisionnement du certificat',
        complete: 'Terminé',
      },
      txtRecord: {
        title: 'Enregistrement TXT',
        description: `Ajoutez l'enregistrement TXT suivant à vos paramètres DNS :`,
        verifyButton: `Vérifier l'enregistrement TXT`,
        verifying: 'Vérification en cours...',
        verified: 'Enregistrement TXT vérifié',
      },
      cnameRecord: {
        title: 'Enregistrement CNAME',
        description: `Ajoutez l'enregistrement CNAME suivant à vos paramètres DNS :`,
        verifyButton: `Vérifier l'enregistrement CNAME`,
        verifying: 'Vérification en cours...',
        verified: 'Enregistrement CNAME vérifié',
      },
      dnsTable: {
        type: 'Type',
        host: 'Hôte',
        value: 'Valeur',
        ttl: 'TTL',
        copy: 'Copier',
        copied: 'Copié !',
      },
      provisioning: {
        title: 'Le certificat SSL est en cours de provisionnement...',
        description: 'Cela peut prendre quelques minutes. Veuillez patienter.',
        timeout: 'Le provisionnement du certificat prend plus de temps que prévu. Veuillez vérifier plus tard.',
      },
      complete: {
        title: 'HTTPS a été activé avec succès sur votre domaine.',
        connected: 'Connecté',
      },
      failed: {
        title: 'La connexion du domaine a échoué',
        tryAgain: 'Réessayer',
      },
      rootDomainWarning: `Les domaines racine nécessitent que votre fournisseur DNS prenne en charge l'aplatissement CNAME (ex. Cloudflare, Route53).`,
      deleteConfirm: {
        title: 'Déconnecter le domaine',
        message: 'Êtes-vous sûr(e) de vouloir déconnecter ce domaine ? Votre site web ne sera plus accessible via ce domaine.',
        confirm: 'Déconnecter',
        cancel: 'Annuler',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: `Envoyez des notifications d'événements en temps réel à des services externes`,
      webhook: 'Webhook',
      webhookTooltip: 'Ajouter un webhook',
      send: 'Envoyer des événements vers un site web tiers',
      webhookUrl: 'URL du webhook (requête POST)',
      error: 'Entrez un lien correct',
      save: 'Enregistrer les modifications',
      enableWebhooks: 'Activer les webhooks',
      enableDescription: 'Requêtes POST sur les événements sélectionnés',
      endpointUrl: 'URL du point de terminaison',
      endpointTooltip: `L'URL qui recevra les requêtes POST lorsque les événements sélectionnés se produisent`,
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Événements',
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      filterPlaceholder: 'Filtrer les événements...',
      all: 'Tous',
      none: 'Aucun',
      active: 'Actif',
      inactive: 'Inactif',
      categories: {
        submissions: 'Soumissions',
        engagement: 'Engagement',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Abonnement en-tête',
        SubmitHeaderMessage: 'Message en-tête',
        SubmitDataCollect: 'Collecte de données',
        SubmitForm: 'Soumission de formulaire',
        SubmitShop: 'Commande boutique',
        SubmitShopPreorder: 'Précommande boutique',
        SubmitDigital: 'Produit numérique',
        SubmitAppointment: 'Rendez-vous',
        SubmitService: 'Commande de service',
        SubmitEvent: 'Inscription à un événement',
        SubmitCourse: 'Inscription à un cours',
        SubmitDonation: 'Don',
        SubmitMembership: 'Adhésion',
        SubmitBlog: 'Achat de blog',
        SubmitCoupon: 'Coupon utilisé',
        SubmitTip: 'Pourboire',
        SubmitLink: 'Achat de lien',
        SubmitProductMessage: 'Question sur le produit',
        SubmitPodcast: 'Achat de podcast',
        SubmitBooking: 'Réservation',
        SubmitRental: 'Location',
        SubmitSingleProduct: 'Produit unique',
        SubmitDiscount: 'Commande avec réduction',
        SubmitListing: 'Demande de listing',
        SubmitUnlock: 'Déverrouillage de contenu',
        SubmitChatAi: 'Message de chat IA',
        ClickLink: 'Clic sur un lien',
        ClickContact: 'Clic sur un contact',
        AddToCart: 'Ajout au panier',
        AddToCartSingleProduct: 'Produit unique au panier',
        AddToWishlist: 'Ajout aux favoris',
        InitiateCheckout: 'Initier le paiement',
        DownloadFile: 'Téléchargement de fichier',
        DownloadMusic: 'Téléchargement de musique',
        CopyCoupon: 'Copie de coupon',
        CopyDiscount: 'Copie de réduction',
        QR_ScanQrCode: 'Scan de code QR',
        VisitPage: 'Visite de page',
      },
    },
    sensitive: {
      title: 'Contenu sensible',
      subtitle: `Afficher un avertissement de contenu sensible avant d'afficher votre site web`,
    },
    socialIntegration: {
      title: 'Intégration sociale',
      subtitle: 'Gérez vos intégrations Instagram, TikTok',
      connectInstagram: 'Connecter Instagram',
    },
    emailIntegration: {
      title: `Intégrations d'audience`,
      subtitle: 'Transmettez les adresses e-mail de vos visiteurs à MailChimp, Reply',
      emailCaption: 'Ajoutez une intégration pour transmettre les adresses e-mail de vos abonnés à MailChimp',
      mailChimp: 'Intégrations MailChimp',
      selzy: 'Intégrations Selzy',
      selzyCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à Selzy',
      sendPulse: 'Intégrations SendPulse',
      sendPulseCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à SendPulse',
      reply: 'Intégrations Reply',
      replyCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à',
      integrations: 'intégrations',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Stockage',
      subtitle: 'Enregistrez les commandes des visiteurs dans Google Spreadsheet',
      storageCaption: 'Ajoutez une intégration pour enregistrer toutes les commandes de vos clients dans Google Spreadsheet',
      emailSignup: 'Inscription par e-mail',
      emailSignupsCaption: 'Choisissez un tableau pour enregistrer les inscriptions par e-mail',
      formSignups: 'Inscription par formulaire',
      forSignupsCaption: 'Choisissez un tableau pour enregistrer les inscriptions par formulaire',
      shopOrders: 'Commandes de la boutique',
      shopOrderCaption: 'Choisissez un tableau pour enregistrer les commandes de la boutique',
      disconnect: 'Déconnecter le tableur',
      storageUsage: 'Utilisation du stockage',
      of: 'de',
      uses: 'Cette application utilise',
      space: 'de votre espace disque gratuit',
      view: 'voir les détails',
      noItems: `Il n'y a aucun élément`,
      files: 'Fichiers',
      images: 'Images',
      videos: 'Vidéos',
      audio: 'Audio',
      settings: 'paramètres',
      free: 'libre',
      needMoreSpace: `Besoin de plus d'espace ?`,
      unlockStorage: 'Débloquez un stockage illimité, la vidéo 4K',
      upgradePlan: 'Améliorer le forfait',
      addFile: 'Ajouter un fichier',
      uploading: 'Import en cours...',
      dragDrop: 'ou glissez-déposez ici',
      noFilesYet: `Aucun fichier pour l'instant`,
      noImagesYet: `Aucune image pour l'instant`,
      noVideosYet: `Aucune vidéo pour l'instant`,
      noAudioYet: `Aucun audio pour l'instant`,
      filesHint: 'Importez des PDF, documents et autres téléchargements pour les joindre aux liens de votre page bio.',
      imagesHint: 'Importez des images à utiliser sur votre page bio.',
      videosHint: 'Importez des vidéos à intégrer sur votre page bio.',
      audioHint: 'Importez des pistes audio à partager sur votre page bio.',
    },
    accountLabel: 'Compte',
    profileLabel: 'Profil',
    switchProfile: 'Changer de profil',
    createNewProfile: 'Créer un nouveau profil',
    active: 'Actif',
    currentPlan: 'Forfait actuel',
    freePlanHint: 'Passez à Pro pour débloquer les fonctionnalités et supprimer les limites.',
    to: 'à',
    renews: 'Renouvellement',
    passwordChangeDesc: 'Modifiez le mot de passe de votre compte',
    apiKeyDesc: 'Utilisez cette clé pour authentifier les requêtes API',
    apiDocumentation: `Documentation de l'API`,
    dashboardLanguageDesc: `Langue d'interface de votre compte`,
    manualPayments: {
      title: 'Paiements manuels / hors ligne',
      hint: 'Les clients paient hors ligne (virement bancaire, espèces, QR). Vous confirmez la commande manuellement.',
      save: 'Enregistrer',
      iban: 'IBAN',
      accountHolder: 'Nom du titulaire du compte',
      bankName: 'Nom de la banque',
      phone: 'Téléphone',
      payeeName: 'Nom du bénéficiaire',
      instruction: 'Instruction',
      instructionHint: 'Mettez en forme avec **gras** ~barré~ _italique_',
      requireProof: 'Exiger une preuve de paiement',
      requireProofHint: `Pour finaliser la commande, les clients doivent importer une capture d'écran (reçu, confirmation de virement bancaire ou toute preuve de paiement).`,
      markPaidOnConfirm: 'Marquer comme payé à la confirmation du client',
      markPaidOnConfirmHint: 'Met automatiquement le statut de paiement à « Payé » dès que le client confirme son paiement.',
      contactBeforePay: 'Activer le contact du vendeur avant le paiement',
      contactBeforePayHint: 'Permet aux clients de contacter le vendeur sans payer, augmentant les demandes tout en renforçant la confiance et en réduisant les annulations.',
    },
    developerApi: {
      title: 'API développeur',
      subtitle: 'Créez des clés API pour accéder à vos commandes, produits et clients via les endpoints /api/v2.',
      keyName: 'Nom de la clé',
      keyNamePh: 'p. ex. Synchro entrepôt',
      scopes: 'Autorisations',
      scopeLabels: {
        'orders:read': 'Lire les commandes',
        'products:read': 'Lire les produits',
        'products:write': 'Mettre à jour le stock produit',
        'customers:read': 'Lire les clients',
      },
      create: 'Créer une clé',
      creating: 'Création…',
      created: 'Clé API créée',
      copyWarning: 'Copiez cette clé maintenant — elle ne sera plus affichée.',
      done: 'Terminé',
      revoke: 'Révoquer',
      revoked: 'Révoquée',
      confirmRevoke: `Révoquer cette clé API ? Les applications qui l'utilisent cesseront de fonctionner.`,
      empty: `Aucune clé API pour l'instant.`,
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Connectez votre numéro WhatsApp Business pour recevoir et répondre aux messages des clients.',
      phoneNumberId: 'ID du numéro de téléphone',
      accessToken: `Token d'accès`,
      displayPhone: 'Téléphone affiché (facultatif)',
      connect: 'Connecter',
      connecting: 'Connexion…',
      connected: 'Connecté',
      disconnect: 'Déconnecter',
      confirmDisconnect: 'Déconnecter WhatsApp ?',
      webhookHelp: 'Renseignez cette URL de rappel et ce token de vérification dans votre App Meta → WhatsApp → Configuration :',
      webhookUrl: 'URL de rappel',
      verifyToken: 'Token de vérification',
      inbox: 'Boîte de réception',
      noMessages: `Aucun message pour l'instant.`,
      selectThread: 'Sélectionnez une conversation.',
      replyPlaceholder: 'Saisissez un message…',
      send: 'Envoyer',
      broadcast: {
        title: 'Diffusion',
        audienceInbox: 'Contacts de la boîte de réception',
        audienceCrm: 'Audience CRM (modèle)',
        message: 'Message',
        inboxHint: 'Texte libre — uniquement délivré aux contacts dans la fenêtre de service client de 24 h.',
        templateName: 'Nom du modèle',
        templateLang: 'Langue du modèle',
        crmHint: 'Utilisez un modèle WhatsApp approuvé — requis pour joindre les contacts hors de la fenêtre de 24 h.',
        send: 'Envoyer la diffusion',
        sending: 'Envoi…',
        empty: `Aucune diffusion pour l'instant.`,
        sent: 'envoyé',
        failed: 'échoué',
      },
      autoReply: {
        title: 'Réponses automatiques',
        type: 'Type',
        typeKeyword: 'Mot-clé',
        typeGreeting: 'Accueil (premier message)',
        typeAway: 'Absence (hors des heures)',
        keyword: 'Mot-clé',
        from: 'Heures de',
        to: 'Heures à',
        reply: 'Texte de la réponse',
        add: 'Ajouter une règle',
        empty: `Aucune règle de réponse automatique pour l'instant.`,
        delete: 'Supprimer',
      },
    },
  },
  productStore: {
    title: `Afficher l'onglet Boutique sur votre lien en bio`,
    subtitle: 'Votre boutique est actuellement masquée.',
  },
  sections: {
    elements: {
      editTitle: 'Edit section',
      sectionTitle: 'Section title',
      sectionTitleCaption: 'Shown above the section. Leave empty, or hide it with the toggle below.',
      sectionTitlePlaceholder: 'For example, Delivery terms',
      hideHeader: 'Hide header',
      textBody: 'Text',
      textBodyCaption: 'A paragraph that supports the block: terms, a disclaimer, an explanation.',
      textBodyPlaceholder: 'Write the text of this section',
      itemsLayout: 'Layout',
      itemsLayoutCaption: 'How the rows are arranged inside this section.',
      layoutList: 'List',
      layoutGrid: 'Grid',
      layoutRow: 'Row',
      image: 'Image',
      imageCaption: 'Uploaded or picked from your media library.',
      imageAlt: 'Alt text',
      imageAltCaption: 'Read by screen readers and shown if the image fails to load.',
      imageAltPlaceholder: 'What is in the picture',
      ratio: 'Proportions',
      ratioCaption: 'Auto keeps the original shape. The others crop to fit.',
      ratioAuto: 'Auto',
      caption: 'Caption',
      captionCaption: 'A short line under the media. Optional.',
      captionPlaceholder: 'Caption',
      linkUrl: 'Link',
      linkUrlCaption: 'Where a click leads. Leave empty for no link.',
      videoUrl: 'Video link',
      videoUrlCaption: 'YouTube, Vimeo, or a direct mp4 link.',
      videoDetected: 'Detected',
      videoNotDetected: 'This link cannot be played here. Use YouTube, Vimeo or a direct mp4 link.',
      videoPoster: 'Cover image',
      videoPosterCaption: 'Shown before playback. YouTube covers are picked up automatically.',
      embedHtml: 'HTML',
      embedHtmlCaption: 'Scripts are removed. Iframes work for YouTube, Vimeo and Spotify only.',
      embedStripped: 'Will be removed on save',
      countdownEnds: 'Ends on',
      countdownEndsCaption: 'The date and time the countdown runs to.',
      countdownNoDate: 'Pick a date and time, otherwise nothing is shown.',
      timezone: 'Time zone',
      timezoneCaption: 'The zone the time above is in. Visitors see the countdown in their own.',
      countdownStyle: 'Style',
      countdownStyleCaption: 'Strip shows days, hours and minutes. Compact is one line.',
      countdownStyleStrip: 'Strip',
      countdownStyleCompact: 'Compact',
      countdownHideWhenEnded: 'Hide timer when countdown ends',
      couponCode: 'Promo code',
      couponCodeCaption: 'Visitors copy it with one tap.',
      couponDescription: 'Description',
      couponDescriptionCaption: 'What the code gives. Optional.',
      couponDescriptionPlaceholder: '20% off your first order',
      couponExpires: 'Valid until',
      couponExpiresCaption: 'After this date the coupon is hidden.',
      couponButtonText: 'Link text',
      couponButtonTextCaption: 'Shown instead of the bare address.',
      couponButtonTextPlaceholder: 'Shop now',
      address: 'Address',
      addressCaption: 'Start typing and pick a suggestion so the pin is exact.',
      addressPlaceholder: 'Street, city',
      addressNotPicked: 'Pick one of the suggestions — without a pin the map is not shown.',
      showDirections: 'Show "Get directions" link',
      galleryItems: 'Images',
      galleryItemsCaption: 'Up to 12. Each can carry a caption.',
      addImage: 'Add image',
      itemTitlePlaceholder: 'Name',
      reviewsItems: 'Reviews',
      reviewsItemsCaption: 'Up to 10 quotes you write yourself.',
      reviewsShowRating: 'Show star ratings',
      addReview: 'Add review',
      reviewName: 'Name',
      reviewRole: 'Role',
      reviewRating: 'Rating 1-5',
      reviewText: 'Review',
      contactItems: 'Contacts',
      contactItemsCaption: 'Up to 6 channels.',
      addContact: 'Add contact',
      contactValuePlaceholder: 'Number, address or username',
      contactLabelPlaceholder: 'Label (optional)',
      channels: {
        phone: 'Phone',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        instagram: 'Instagram',
        website: 'Website',
        address: 'Address',
      },
      summary: {
        oneImage: '1 image',
        manyImages: '{n} images',
        oneReview: '1 review',
        manyReviews: '{n} reviews',
        oneContact: '1 contact',
        manyContacts: '{n} contacts',
      },
    },
    splashScreen: {
      title: 'Écran de démarrage',
      subtitle: `S'affiche pendant le chargement de la page`,
    },
    promo: {
      title: 'Barre promotionnelle',
      subtitle: `Mise en avant qui vous permet d'afficher des promotions`,
      masterPromoMessage: `La barre promotionnelle principale est actuellement activée. Si vous souhaitez créer une barre promotionnelle personnalisée pour cette page, vous devez d'abord désactiver la barre promotionnelle principale.`,
      titlePlaceholder: 'Bienvenue sur mon site web !',
      switcherIsMasterPromobar: 'Afficher sur toutes les pages',
    },
    contact: {
      title: 'Contacts',
      subtitle: 'Fournissez un moyen de communiquer avec vous',
      caption: 'Ajoutez des boutons de messagerie pour une connexion rapide entre vous et vos clients en un clic',
      tooltip: 'Les contacts permettent aux utilisateurs de communiquer directement avec vous. Ajoutez votre téléphone, e-mail, messagerie ou localisation',
      addNewContact: 'Ajouter un nouveau contact',
      addContact: 'Ajouter un contact',
      chooseContact: 'Choisir un contact',
      enterLink: 'Entrez le lien de votre contact',
      showDetails: 'Afficher les détails',
      enterAnyContact: 'Veuillez entrer un contact',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Adhésion',
      subtitle: 'Créez un abonnement gratuit ou payant à votre contenu',
      addNewTier: 'Ajouter un nouveau niveau',
      editTier: 'Modifier le niveau',
      name: 'Nom',
      nameCaption: 'Entrez le nom de votre niveau',
      price: 'Prix par mois',
      priceCaption: 'Entrez le prix de votre niveau',
      month: 'mois',
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre niveau',
    },
    pricing: {
      title: 'Tarification',
      subtitle: 'Créez un menu avec des prix',
      add: 'Ajouter un nouvel élément',
      edit: `Modifier l'élément`,
      name: 'Nom',
      nameCaption: 'Entrez le nom de votre élément',
      duration: 'Attribut',
      durationCaption: 'Entrez le temps, la quantité ou la durée de votre élément',
      category: 'Catégorie',
      categoryCaption: 'Entrez la catégorie de votre élément',
      price: 'Prix',
      priceCaption: 'Entrez le prix de votre élément',
      month: 'mois',
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre élément',
    },
    subscribe: {
      dataCollectTitle: 'Collecte de données',
      title: `S'abonner`,
      subtitle: 'Collectez les e-mails ou numéros de téléphone de vos visiteurs',
      instructionsMessage: `Ajoutez un champ d'inscription par e-mail à votre page pour que vos visiteurs puissent facilement s'inscrire !`,
      instructionsLink: 'Transmettez les e-mails à MailChimp pour lancer des campagnes marketing.',
      sectionHeaderCaption: 'Abonnez-vous à notre newsletter',
      collecting: 'Collecte',
      collectingCaption: 'Choisissez votre type de saisie',
      addDataToCollect: 'Ajouter des données à collecter',
      email: 'E-mail',
      enterEmail: `Entrez l'e-mail`,
      thanksForEmail: 'Merci pour votre e-mail',
      phone: 'Téléphone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'YouTube',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Ajouter des liens mis à jour',
      placeholder: 'Placeholder',
      placeholderCaption: 'Entrez le texte du placeholder',
      button: 'Bouton',
      buttonCaption: 'Texte qui motivera le visiteur à entrer son e-mail (réduction de 10%, abonnez-vous maintenant, téléchargez le fichier, etc.)',
      submitButton: 'Bouton de soumission',
      enterButton: 'Entrez le bouton',
      thanksMessage: 'Message de remerciement',
      thanksMessageCaption: 'Message de remerciement pour vos abonnés',
      resultAction: 'Action (après soumission)',
      resultActionCaption: 'Action après avoir rempli le formulaire',
      sendAnEmail: 'Envoyer un e-mail',
      downloadFile: 'Télécharger un fichier',
      redirect: 'Redirection',
      messageBody: 'Corps du message',
      messageBodyCaption: `Ces données seront envoyées à l'e-mail de l'utilisateur en cadeau pour son inscription (coupon, lien de téléchargement, etc.)`,
      integration: 'Intégration',
      integrationCaption: 'Transmettez les adresses e-mail de vos visiteurs à MailChimp, Reply',
      storage: 'Stockage',
      storageCaption: 'Enregistrez les commandes des visiteurs dans Google Spreadsheet',
      maxSize: 'Vous pouvez ajouter un maximum de 3 canaux',
    },
    text: {
      title: 'Texte',
      subtitle: `Écrivez n'importe quoi sur vous/votre entreprise`,
      trimBio: 'Bouton Voir plus',
    },
    header: {
      title: 'En-tête',
      subtitle: 'Image ou vidéo agrandie en vedette sur votre page',
      verifiedBadge: 'Badge vérifié',
      showProfilePic: 'Afficher la photo de profil',
      profilePicRatio: 'Ratio',
      profilePicRatioSquare: 'Carré',
      profilePicRatioLandscape: 'Paysage',
      profilePicRatioPortrait: 'Portrait',
      namePlaceholder: 'Votre nom',
      shortBioPlaceholder: 'Ma courte présentation',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Ville',
      addSocial: '+ Ajouter un réseau social',
      addCover: '+ Ajouter une couverture',
      addButton: '+ Ajouter un bouton',
      addText: '+ Ajouter du texte',
      addLabel: '+ Ajouter une étiquette',
      subtitleName: `Personnalisez l'apparence de votre nom`,
      subtitleShortBio: `Personnalisez l'apparence de votre courte biographie`,
      shortBioSize: 'Taille de la courte biographie',
      subtitleShortBioSize: 'Vous pouvez changer la taille de la courte biographie',
      subtitleLocation: 'Définissez la ville/le pays pour guider les visiteurs vers un lieu spécifique',
      headerCoverWarningMessage: 'Votre navigateur ne prend pas en charge la balise vidéo.',
      headerCoverTitle: `Définir la couverture au-dessus de l'en-tête`,
      coverHeight: 'Hauteur de la couverture',
      subtitleCoverHeight: 'Vous pouvez changer la hauteur de la couverture',
      coverDarkness: 'Obscurcissement de la couverture',
      subtitleCoverDarkness: `Faites glisser le curseur pour assombrir l'image de couverture`,
      nameSize: 'Taille du nom',
      subtitleNameSize: 'Vous pouvez changer la taille du nom',
      positionText: 'Position du nom',
      subtitlePositionName: 'Faites glisser le curseur pour définir la position du nom',
      positionContent: 'Position du contenu',
      subtitlePositionContent: 'Définissez la position pour la bio, le lien, la localisation',
      coverText: 'Texte sur la couverture',
      subtitleCoverText: 'Ajoutez du texte à votre couverture',
      position: 'Position',
      subtitlePosition: 'Faites glisser le curseur pour définir la position du bouton',
      buttonCover: 'Bouton sur la couverture',
      subtitleButtonCover: 'Ajoutez un bouton à votre couverture en choisissant une action',
      subtitleFollow: 'Le bouton Suivre permet aux utilisateurs de suivre vos actualités',
      buttonOpacity: `Faites glisser le curseur pour changer l'opacité du bouton`,
      subtitleCart: `Icône du panier pour offrir une expérience d'achat`,
      subtitleDirect: 'Bouton rapide pour diriger le visiteur vers les messageries',
      subtitleCTAButton: `Bouton (appel à l'action) qui motive l'utilisateur à cliquer`,
      subtitleSocialLinks: 'Donnez un aspect visuel à vos réseaux sociaux',
      chooseSocialLink: 'Choisir un lien social',
      alignSocialLink: 'Alignement des liens sociaux',
      enterYourSocialLink: 'Entrez votre lien social',
      blockShadow: 'Ombre du bloc',
      activeButtonPosition: 'Position du bouton actif',
      gradientColor: 'Couleur du dégradé',
      bottomGradient: 'Dégradé du bas',
      autoGradient: 'Auto',
      customGradient: 'Personnalisé',
      transparentGradient: 'Transparent',
      uploadLogo: 'Téléverser le logo',
      customBackground: 'Arrière-plan personnalisé',
      headingLabel: `Étiquette de l'en-tête`,
      customizeLabel: `Personnalisez l'apparence de l'étiquette de l'en-tête`,
      labelText: `Texte de l'étiquette`,
      enterLabelText: `Entrez le texte de l'étiquette de l'en-tête`,
      verticalCropStep: 'photo verticale',
      squareCropStep: 'avatar carré',
      topButtons: 'Boutons du haut',
      bottomButtons: 'Boutons du bas',
      buttonSubtitleLanguage: 'Sélecteur de langue',
      buttonSubtitleContact: 'Appeler / envoyer un message',
      buttonSubtitleCart: 'Panier',
      buttonSubtitleCta: `Appel à l'action`,
      buttonSubtitleMessage: 'Message',
      buttonSubtitleSubscribe: `S'abonner`,
      buttonSubtitleQrcode: 'QR code',
      buttonSubtitleSearch: 'Recherche de produits',
      buttonDisabledHint: 'Masqué · désactivé',
      gradientPositionLabel: `Position de l'ombre`,
      gradientPositionPhoto: 'Sous la photo',
      gradientPositionHeader: `Plus bas dans l'en-tête`,
      bottomBadge: 'Teinte du bas',
      addTint: 'Ajouter une teinte',
      bottomBadgeText: 'Texte (facultatif)',
      bottomBadgePreset: 'Préréglage',
      bottomBadgeShape: 'Forme',
      bottomBadgeSize: 'Hauteur',
      bottomBadgeAction: 'Action',
      bottomBadgeBgColor: `Couleur d'arrière-plan`,
      bottomBadgeTextColor: 'Couleur du texte',
      bottomBadgeGradientFrom: 'Dégradé de',
      bottomBadgeGradientTo: 'Dégradé vers',
      bottomBadgeGradientAngle: 'Angle du dégradé',
    },
  },
  billingHistory: {
    title: 'Historique de facturation',
    invoices: 'Factures',
    messageText: `Vous n'avez pas encore d'historique de paiement.`,
  },
  migrate: {
    title: 'Avez-vous LinkTree ou Taplink ?',
    text: 'Collez le lien et migrez vers UniLink en un seul clic !',
    button: 'Migrer',
  },
  pages: {
    title: 'Pages',
    addPage: 'Ajouter une page',
    addNewPage: 'Ajouter une nouvelle page',
    deleteTitle: 'Êtes-vous sûr(e) de vouloir supprimer cette page ?',
    managePage: 'Gérer les onglets',
    empty: `Cette page n'a pas encore de bloc.`,
    dragAndDrop: 'Faites glisser et déposez vos autres onglets pour les réorganiser',
    pageNavigation: 'Paramètres de navigation des pages',
    goToDesign: 'Aller aux paramètres de design',
    viewArchive: 'Voir les archives',
    archivedBlocks: 'Blocs archivés',
    noArchivedBlocks: `Gardez votre page propre et organisée en archivant les blocs que vous n'utilisez pas actuellement.`,
    archiveAllUnpublished: 'Archiver tous les blocs non publiés',
    restore: 'Restaurer',
    permanentDelete: 'Supprimer définitivement',
  },
  analytics: {
    lifeTimeAnalytics: 'Analytique globale',
    impressions: 'Impressions',
    impressionsText: `Performance des statistiques d'impressions pour la période choisie`,
    clicks: 'Clics',
    clicksText: 'Performance des événements "clic" pour la période choisie',
    signUps: 'Inscriptions',
    signUpsText: 'Performance des événements "fermeture" pour la période choisie',
    totalInteractions: 'Interactions',
    totalInteractionsText: 'Clics et inscriptions via formulaire pour la période choisie',
    engagementRate: `Taux d'engagement`,
    engagementRateText: 'Part des vues de profil ayant mené à une interaction',
    visitor: 'Sources de visiteurs',
    country: 'Pays',
    countries: 'Pays',
    linkClicks: 'Clics sur les liens',
    content: 'Contenu',
    views: 'Vues',
    links: 'Liens',
    products: 'Produits',
    blocks: 'Blocs',
    pages: 'Pages',
    clicksLower: 'clics',
    of: 'sur',
    noContentData: 'Aucune donnée pour la période choisie pour l’instant',
  },
  aiInsights: {
    title: 'Insights IA',
    generate: 'Analyser mon profil',
    description: `Obtenez des recommandations basées sur l'IA pour améliorer les performances de votre profil.`,
    analyzing: 'Analyse de votre profil...',
    refresh: 'Actualiser',
    action: 'Action',
  },
  post: {
    subscriptionTypePlaceholder: `Disponible pour l'abonnement '{type}' et supérieur`,
    postButtonText: 'Publier',
    newPostPlaceholder: `Qu'avez-vous en tête`,
    free: 'Gratuit',
    pro: 'Pro',
    premium: 'Premium',
    noPost: `Vous n'avez pas encore de publications`,
    editPost: 'Modifier la publication',
  },
  preview: {
    buy: 'Acheter',
    connect: 'Connecter',
  },
  activeButton: {
    initialText: 'Site web',
    inputPlaceholder: 'Rechercher des actions...',
    existing: 'Existant',
    redirect: 'Redirection',
    scroll: 'Défilement',
    title: 'Bouton actif',
    modalTitle: 'Action du bouton actif',
    subtitle: `Bouton qui motive l'utilisateur à effectuer une action`,
    next: 'Suivant',
    save: 'Enregistrer',
    opensALinkFromLinksBlock: 'Ouvre un lien du bloc Liens',
    url: 'URL',
    opensAWebsite: 'Ouvre un site web',
    openInApp: `Ouvrir dans l'application`,
    addAction: 'Ajouter une action',
    actionTitle: 'Action',
    actionCaption: `Modifier le type d'action`,
    chooseOption: 'Choisissez une option',
    tellPeople: `Indiquez aux utilisateurs comment interagir avec le bouton d'action`,
    urlRedirect: 'Redirection URL',
    customUrl: 'URL personnalisée',
    customUrlText: 'Ouvre un site web',
    links: 'Liens',
    linksText: 'Ouvre un lien depuis le bloc Liens',
    downloadDocument: 'Télécharger le document',
    sendEmail: 'Envoyer un e-mail',
    opensEmailClient: 'Ouvre le client de messagerie',
    phoneCall: 'Appel téléphonique',
    initiatesPhoneCall: 'Lance un appel téléphonique',
    navigation: 'Navigation',
    openPage: 'Ouvrir la page',
    opensInternalPage: 'Ouvre une page interne',
    openPageText: 'Ouvre une page interne',
    openProduct: 'Ouvrir le produit',
    openProductText: 'Ouvre la page produit depuis la boutique',
    openBlog: 'Ouvrir le blog',
    opensBlogPageFromStore: 'Ouvre la page de blog depuis la boutique',
    openBlock: 'Ouvrir le bloc',
    opensContentBlock: 'Ouvre le bloc de contenu',
    openItem: `Ouvrir l'élément`,
    opensItemPageFromStore: `Ouvre la page de l'élément depuis la boutique`,
    showNewModal: 'Afficher la nouvelle modale',
    displayContentInModalWindow: 'Afficher le contenu dans une fenêtre modale',
    showProduct: 'Afficher le produit',
    displayProductInModalWindow: 'Afficher le produit dans une fenêtre modale',
    showBlog: 'Afficher le blog',
    scrollToBlock: 'Défiler vers le bloc',
    scrollToBlockText: 'Défiler vers le bloc de page spécifié',
    scrollToItem: `Faire défiler jusqu'à l'élément`,
    action: 'Action',
    showBlock: 'Afficher le bloc',
    showBlockText: 'Afficher le bloc dans une fenêtre modale sur la page',
    showItem: `Afficher l'élément`,
    showItemText: `Afficher le bloc d'élément dans une fenêtre modale sur la page`,
    linksCaption: 'Liens',
    linksTooltip: 'Choisissez un lien depuis le bloc de liens',
    pagesCaption: 'Pages',
    pagesTooltip: 'Choisissez une page parmi les pages',
    productsCaption: 'Produits',
    productsTooltip: 'Choisissez un produit dans la liste',
    blocksCaption: 'Blocs',
    blocksTooltip: 'Choisissez un bloc dans la liste',
    itemsCaption: 'Éléments',
    itemsTooltip: 'Choisissez un élément dans la liste',
    showProductText: 'Afficher le produit dans une fenêtre modale sur la page',
    more: 'Afficher plus',
    less: 'Afficher moins',
    showNewModalTitle: 'Données de la nouvelle modale',
    uploadDocumentTitle: 'Cliquez pour téléverser ou glissez-déposez',
    uploadProgressTitle: 'Téléversement...',
    haveNoModal: `Vous n'avez aucune modale`,
    haveModal: 'Vous avez sélectionné une modale',
    openNewModalHandler: 'Créer une nouvelle modale',
    linkGroupSubTitle: 'Sélectionner un bloc',
    linkItemSubTitle: 'Sélectionner un lien',
    urlItemSubTitle: 'URL du site web',
    openInAppItemSubTitle: `URL de l'application`,
    sendEmailItemSubTitle: 'Adresse e-mail',
    phoneCallItemSubTitle: 'Numéro de téléphone',
    openPageGroupSubTitle: 'Sélectionner une page',
    openPageItemSubTitle: 'Sélectionner une page',
    openProductGroupSubTitle: 'Sélectionner le type de produit',
    openProductItemSubTitle: 'Sélectionner un produit',
    openBlogGroupSubTitle: 'Sélectionner une chaîne de blog',
    openBlogItemSubTitle: 'Sélectionner un article de blog',
    openBlockGroupSubTitle: 'Sélectionner une page',
    openBlockItemSubTitle: 'Sélectionner un bloc',
    openItemGroupSubTitle: 'Sélectionner un bloc',
    openItemItemSubTitle: 'Sélectionner un élément',
    showProductGroupSubTitle: 'Sélectionner le type de produit',
    showProductItemSubTitle: 'Sélectionner un produit',
    showBlogGroupSubTitle: 'Sélectionner une chaîne de blog',
    showBlogItemSubTitle: 'Sélectionner un article de blog',
    showBlockGroupSubTitle: 'Sélectionner une page',
    showBlockItemSubTitle: 'Sélectionner un bloc',
    showItemGroupSubTitle: 'Sélectionner un bloc',
    showItemItemSubTitle: 'Sélectionner un élément',
    scrollToBlockGroupSubTitle: 'Sélectionner une page',
    scrollToBlockItemSubTitle: 'Sélectionner un bloc',
    scrollToItemGroupSubTitle: 'Sélectionner un bloc',
    scrollToItemItemSubTitle: 'Sélectionner un élément',
    linkGroupPlaceholder: 'Choisir un bloc...',
    linkItemPlaceholder: 'Choisir un lien...',
    openPageItemPlaceholder: 'Choisir une page...',
    openProductGroupPlaceholder: 'Choisir un type de produit...',
    openProductItemPlaceholder: 'Choisir un produit...',
    showProductGroupPlaceholder: 'Choisir un groupe de produits...',
    showProductItemPlaceholder: 'Choisir un produit...',
    openBlogGroupPlaceholder: 'Choisir une chaîne de blog...',
    openBlogItemPlaceholder: 'Choisir un article de blog...',
    openBlockGroupPlaceholder: 'Choisir une page...',
    openBlockItemPlaceholder: 'Choisir un bloc...',
    openItemGroupPlaceholder: 'Choisir une page et un bloc...',
    openItemItemPlaceholder: 'Choisir un élément...',
    showBlogGroupPlaceholder: 'Choisir un groupe de blog...',
    showBlogItemPlaceholder: 'Choisir un article de blog...',
    showBlockGroupPlaceholder: 'Choisir une page...',
    showBlockItemPlaceholder: 'Choisir un bloc...',
    showItemGroupPlaceholder: 'Choisir une page et un bloc...',
    showItemItemPlaceholder: 'Choisir un élément...',
    scrollToBlockGroupPlaceholder: 'Choisir une page...',
    scrollToBlockItemPlaceholder: 'Choisir un bloc...',
    scrollToItemGroupPlaceholder: 'Choisir une page et un bloc...',
    scrollToItemItemPlaceholder: 'Choisir un élément...',
    linkReadable: 'Lien',
    urlReadable: 'URL',
    openInAppReadable: `Ouvrir dans l'app`,
    downloadDocumentReadable: 'Télécharger le document',
    sendEmailReadable: 'Envoyer un e-mail',
    phoneCallReadable: 'Appel téléphonique',
    openPageReadable: 'Ouvrir la page',
    openProductReadable: 'Ouvrir le produit',
    showNewModalReadable: 'Afficher une nouvelle fenêtre',
    showProductReadable: 'Afficher le produit',
    openBlogReadable: 'Ouvrir le blog',
    openBlockReadable: 'Ouvrir le bloc',
    openItemReadable: `Ouvrir l'élément`,
    showBlogReadable: 'Afficher le blog',
    showBlockReadable: 'Afficher le bloc',
    showItemReadable: `Afficher l'élément`,
    scrollToBlockReadable: `Défiler jusqu'au bloc`,
    scrollToItemReadable: `Défiler jusqu'à l'élément`,
  },
  design: {
    textColorHint: 'La couleur du contenu de ce bloc. Le titre a sa propre couleur.',
    tabs: 'Onglets',
    imageView: `Vue de l'image`,
    preview: 'Aperçu',
    buttonOpacity: 'Opacité du bouton',
    buttonBorder: 'Bordure du bouton',
    buttonShadow: 'Ombre du bouton',
    itemView: `Vue de l'élément`,
    itemViewTooltip: `Choisissez la vue de l'élément`,
    itemLayout: `Disposition de l'élément`,
    itemLayoutTooltip: `Choisissez la disposition de l'élément`,
    top: 'Haut',
    center: 'Centre',
    bottom: 'Bas',
    bottomLeft: 'Bas gauche',
    bottomHorizontal: 'Bas horizontal',
    under: 'Dessous',
    title: 'Titre',
    titleButton: 'Titre et bouton',
    displayOptions: `Options d'affichage`,
    displayOptionsTooltip: `Choisissez les options d'affichage`,
    landscape: 'Paysage',
    square: 'Carré',
    portrait: 'Portrait',
    desktopMode: 'Mode bureau',
    mobile: 'Compact',
    desktop: 'Large',
    responsive: 'Responsive',
    custom: 'Personnalisé',
    templates: 'Modèles',
    chooseTemplates: 'Choisissez vos modèles',
    viewAll: 'Tout voir',
    previousTheme: 'Veuillez noter que le thème précédent sera définitivement effacé.',
    useThisTemplate: 'Utiliser ce modèle',
    notSupportedVideo: 'Votre navigateur ne prend pas en charge la balise vidéo.',
    photosBy: 'Photos par',
    animationBy: 'Animation par',
    searchTheSame: 'Recherchez le même terme à nouveau pour des résultats différents.',
    addImage: 'Ajouter une image',
    addVideo: 'Ajouter une vidéo',
    orSelectFrom: 'ou sélectionnez depuis',
    noImagesYet: 'Aucune image pour le moment',
    noVideosYet: 'Aucune vidéo pour le moment',
    videoBy: 'Vidéo par',
    hamburgerMenu: 'Menu hamburger',
    menuContent: 'Contenu du menu',
    menuShowContacts: 'Afficher les contacts',
    menuShowAddress: 'Afficher l’adresse',
    menuAddress: 'Adresse',
    menuAddressCaption: 'Si vide, l’adresse du bloc Contacts est utilisée',
    menuShowCta: 'Afficher le bouton',
    menuCtaText: 'Texte du bouton',
    menuCtaCaption: 'Si vide, le bouton de l’en-tête est utilisé',
    menuCtaUrl: 'Lien du bouton',
    menuShowSocials: 'Afficher les réseaux sociaux',
    tabsOnTop: 'Onglets en haut',
    tabsOnBottom: 'Onglets en bas',
    borderType: 'Type de bordure',
    subTitle: `Choisissez la forme, le type de bordure, l'ombre, etc.`,
    icon: 'Icône',
    iconTooltip: 'Choisissez la bonne icône pour votre bouton',
    background: 'Arrière-plan',
    color: 'Couleur',
    backgroundOpacity: `Opacité de l'arrière-plan`,
    backgroundOpacityTooltip: `Faites glisser le curseur pour définir l'opacité de l'arrière-plan`,
    gradient: 'Dégradé',
    color1: 'Couleur 1',
    color2: 'Couleur 2',
    direction: 'Direction',
    directionTooltip: 'Faites glisser le curseur pour définir la direction du dégradé',
    offset: 'Décalage',
    offsetTooltip: 'Faites glisser le curseur pour définir le décalage du dégradé',
    minHeight: 'Hauteur minimale',
    minHeightTooltip: 'Faites glisser le curseur pour changer la hauteur minimale du bouton',
    align: 'Alignement',
    alignTooltip: 'Changer la position du bouton',
    insert: `Insérer l'URL`,
    upload: 'Téléverser une vidéo',
    search: 'Rechercher une vidéo',
    layout: 'Disposition',
    layoutTooltip: 'Choisissez la disposition que vous souhaitez',
    view: 'Vue',
    viewTooltip: 'Choisissez la vue que vous souhaitez',
    media: 'Média',
    mediaTooltip: 'Choisissez le média que vous souhaitez',
    none: 'Aucun',
    small: 'Petit',
    medium: 'Moyen',
    large: 'Grand',
    round: 'Rond',
    feed: 'Flux',
    slider: 'Carrousel',
    text: 'Texte',
    colorTooltip: 'Choisissez les couleurs',
    button: 'Bouton',
    buttonTooltip: 'Choisissez les couleurs du bouton',
    chooseEmoji: 'Choisir un émoji',
    changeEmoji: 'Changer votre émoji',
    quantum: 'Quantum',
    emoji: 'Émoji',
    warp: 'Warp',
  },
  components: {
    blockTemplates: {
      title: 'Modèles',
      empty: 'Aucun modèle ne correspond',
      preview: 'Aperçu',
      apply: 'Utiliser ce modèle',
      viewAll: 'Voir les {count} modèles',
      search: 'Rechercher un modèle',
      selected: 'Sélectionné',
      cancel: 'Annuler',
      applyTemplate: 'Appliquer le modèle',
    },
    quickAdd: {
      addLink: 'Ajouter un lien',
      addVideo: 'Ajouter une vidéo',
      addProduct: 'Ajouter un produit',
      addPost: 'Ajouter une publication',
      addArticle: 'Ajouter un article',
      addPhoto: 'Ajouter une photo',
      addMusic: 'Ajouter de la musique',
      addFiles: 'Ajouter des fichiers',
      addStory: 'Ajouter une story',
    },
    emoji: {
      search: 'Rechercher',
      clear: 'Effacer',
      notfound: 'Aucun émoji trouvé',
      skintext: 'Choisissez votre teinte de peau par défaut',
      categories: {
        search: 'Résultats de recherche',
        recent: 'Fréquemment utilisés',
        smileys: 'Émoticônes et émotions',
        people: 'Personnes et corps',
        nature: 'Animaux et nature',
        foods: 'Nourriture et boissons',
        activity: 'Activité',
        places: 'Voyages et lieux',
        objects: 'Objets',
        symbols: 'Symboles',
        flags: 'Drapeaux',
        custom: 'Personnalisé',
      },
      categorieslabel: `Catégories d'émojis`,
      skintones: {
        1: 'Teinte de peau par défaut',
        2: 'Teinte de peau claire',
        3: 'Teinte de peau moyennement claire',
        4: 'Teinte de peau moyenne',
        5: 'Teinte de peau moyennement foncée',
        6: 'Teinte de peau foncée',
      },
    },
    blogPreviewModal: {
      title: 'Aperçu du blog',
      notify: 'Notifier les abonnés',
    },
    standAloneModal: {
      title: 'Aperçu du lien',
      save: 'Enregistrer',
      chooseLayout: 'Choisissez une disposition pour votre lien',
      linkSettings: 'Paramètres du lien',
      linkSettingsSubtitle: 'Redirection, apparence',
      whenVisitorsClicks: 'Quand un visiteur clique sur ce lien :',
      redirect: 'Redirection',
      redirectText: `Envoyer les visiteurs directement vers l'URL`,
      highlight: 'Mise en avant',
      highlightText: 'Envoyer les visiteurs vers votre UniLink et mettre en avant',
      standalone: 'Autonome',
      standaloneText: 'Faites ressortir votre lien YouTube et jouez le contenu directement sur votre',
      cover: 'Couverture',
      imageTab: 'Image',
      videoTab: 'Vidéo',
      uploadImage: 'Téléverser une image',
      whenVisitors: 'Quand un visiteur sélectionne le lien partagé :',
      compact: 'Vue compacte',
      fullView: 'Vue complète',
      videoSound: 'Lire la vidéo avec le son',
    },
    instagramModal: {
      title: 'Envoyez des DM Instagram automatiques',
      subtitle: `Envoyez ce lien par message direct lorsque quelqu'un commente votre publication ou Reel IG`,
      promo: 'Choisissez depuis quel IG vous souhaitez envoyer',
      connect: 'Connecter un compte Instagram',
      added: 'Compte Instagram ajouté',
      addNew: 'Ajouter une nouvelle automatisation',
      igContent: 'Contenu IG',
      trigger: 'Déclencheur',
      dmContent: 'DM',
      linkDestination: 'Destination du lien',
      buttonTitle: 'Titre du bouton',
      buttonTitleTooltip: 'Entrez le titre du bouton',
      directMessage: 'Message direct',
      directMessageTooltip: 'Entrez le message direct',
      selectPosts: 'Sélectionnez la publication ou le Reel qui déclenchera votre DM automatique.',
      onePost: 'Une publication ou un Reel spécifique',
      allPosts: 'Toutes les publications ou Reels',
      triggerText: 'Quand les commentaires incluent ceci, votre DM sera envoyé.',
      addMessage: 'Ajoutez un message à envoyer automatiquement avec votre lien.',
      clickLink: `Quand quelqu'un clique sur le lien dans votre DM :`,
      anyComment: `N'importe quel commentaire`,
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Tout message',
      specificKeywords: 'Commentaires avec des mots-clés spécifiques',
      sendLink: 'Les envoyer vers votre UniLink et mettre en avant ',
      skipLink: 'Ignorer UniLink et les envoyer directement',
      keywordsTitle: 'Commentaires avec des mots-clés spécifiques',
      keywordsText: 'Vos DM seront envoyés lorsque les commentaires incluent ou excluent\ndes mots-clés spécifiques (non sensible à la casse) :',
      keywordsPlaceholder: 'Tapez un mot-clé',
      keywordsExclude: 'Exclure des mots-clés',
      keywordsExcludeText: `Doit exclure l'un de ceux-ci`,
      replyComment: 'Répondre au commentaire',
      replyCommentTooltip: 'Entrez la réponse au commentaire',
    },
    blockEditProduct: {
      productPreview: 'Aperçu du produit',
      productDetails: 'Détails du produit',
      settings: 'Paramètres',
      design: 'Design',
    },
    editMenuItems: {
      overview: `Vue d'ensemble`,
      analytics: 'Analytique',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Entrez le token de votre bot',
      connect: 'Connecter',
      token: 'Token',
    },
    rewards: {
      title: 'Titre',
      titleTooltip: 'Entrez le titre de la réponse',
      text: 'Texte',
      textTooltip: 'Entrez le texte de la réponse',
      link: 'Lien',
      linkTooltip: 'Entrez le lien de la réponse',
      code: 'Code',
      codeTooltip: 'Entrez le code de la réponse',
      files: 'Fichiers',
      filesTooltip: 'Entrez les fichiers de la réponse',
      removeReward: 'Êtes-vous sûr(e) de vouloir supprimer cette réponse ?',
    },
    addRewardModal: {
      addReward: 'Ajouter une réponse',
      textTitle: 'Texte',
      textText: `Donnez accès à des instructions ou à du texte avec l'éditeur riche`,
      fileTitle: 'Fichiers',
      fileText: 'Donnez accès à des fichiers et collectez les coordonnées',
      linkTitle: 'Lien',
      linkText: 'Donnez accès à du contenu exclusif et collectez les coordonnées',
      codeTitle: 'Code',
      codeText: 'Donnez accès à des promotions exclusives et collectez les coordonnées',
    },
    blockEmpty: {
      isNotAdded: `n'est pas ajouté`,
      itSeems: 'Il semble que votre',
      itemsNot: 'éléments ne sont pas encore ajoutés. Ajoutez vos vidéos maintenant',
      add: 'Ajouter',
    },
    blockList: {
      add: 'Ajouter',
      item: 'élément',
    },
    submitAction: {
      action: 'Action (après soumission)',
      actionTooltip: 'Choisissez une action après la soumission',
      upload: 'Téléverser des pièces jointes',
      none: 'Aucune',
      page: 'Afficher la page de confirmation',
      email: 'Envoyer un e-mail de confirmation',
      redirect: `Rediriger vers l'URL`,
    },
    blockEditItem: {
      content: 'Contenu',
      preview: 'Aperçu',
      settings: 'Paramètres',
    },
    domainButton: {
      customizeDomain: 'Personnalisez votre domaine.',
      upgradeToLink: 'Passez au forfait Pro Lien en bio et utilisez un domaine personnalisé.',
    },
    coverText: {
      text: 'Texte',
      textTooltip: 'Entrez le texte de votre couverture',
      description: 'Description',
      descriptionTooltip: 'Entrez la description de votre couverture',
      textColor: 'Couleur du texte',
    },
    itemModal: {
      edit: 'Modifier',
      addNew: 'Ajouter un nouvel',
      item: 'élément',
      update: 'Mettre à jour',
      add: 'Ajouter',
    },
    productSheet: {
      openFullEditor: `Ouvrir l'éditeur complet`,
      copyLink: 'Copier le lien',
      active: 'Actif',
      notActive: 'Inactif',
      statistics: 'Statistiques',
      clicks: 'Clics',
      sales: 'Ventes',
      revenue: 'Revenus',
      onlyName: 'Seul le nom est obligatoire',
      name: 'Nom',
      required: 'Obligatoire',
      price: 'Prix',
      optional: 'Facultatif',
      free: 'Gratuit',
      appearance: 'Apparence',
      cover: 'Couverture',
      coverNote: `Carrée, à partir de 600×600. Vous pourrez l'ajouter plus tard.`,
      description: 'Description',
      descriptionPlaceholder: 'Une ligne sur ce que ça contient',
      remove: 'Supprimer',
      photo: 'Photo',
      enterName: 'Saisissez un nom',
      adding: 'Ajout…',
    },
    viewDesign: {
      compact: 'Compact',
      card: 'Carte',
      button: 'Bouton',
      list: 'Liste',
      hero: 'Hero',
      featured: 'En vedette',
    },
    moveItemModal: {
      title: `Déplacer l'élément vers une autre page`,
      cancel: 'Annuler',
      move: 'Déplacer',
      page: 'Page',
      pageTooltip: `Choisissez une page pour déplacer l'élément`,
      blocks: 'Blocs',
      blocksTooltip: `Choisissez un bloc pour déplacer l'élément`,
      emptyBlocks: `Il n'y a pas de blocs requis sur cette page.`,
    },
    limitModal: {
      title: 'Limite atteinte',
      text1: 'Vous avez atteint la limite de votre site.',
      text2: 'Veuillez nous contacter pour mettre à niveau votre forfait.',
      close: 'Fermer',
    },
    cropPicture: {
      title: 'Recadrer votre image',
      cancel: 'Annuler',
      save: 'Enregistrer',
    },
    uploadFile: {
      uploadProductImage: `Téléverser l'image du produit`,
      coverImage: 'Image de couverture',
      uploadImages: 'Vous ne pouvez téléverser que des images ici',
    },
    userMediaLibrary: {
      addImage: 'Ajouter une image',
      uploadImage: 'Téléverser une image',
      orSelectFrom: 'ou téléverser',
      orSelectLink: 'ou coller le lien',
      myMedia: 'Mes médias',
      stockImages: 'Images stock',
      gifs: 'GIF',
      icons: 'Icônes',
      noImagesYet: 'Aucune image pour le moment',
      loadMore: 'Charger plus',
    },
    itemMenu: {
      active: 'Actif',
      willBeAvailable: `L'élément sera disponible le :`,
      save: 'Enregistrer',
      copied: 'Copié',
      copyLink: 'Copier le lien',
      delete: 'Supprimer',
    },
    itemDesign: {
      linkColor: 'Couleur du lien',
      gradient: 'Dégradé',
      background: 'Arrière-plan',
      backgroundOpacity: `Opacité de l'arrière-plan`,
      backgroundOpacityTooltip: `Faites glisser le curseur pour définir l'opacité de l'arrière-plan`,
      backgroundDarkness: `Obscurcissement de l'arrière-plan`,
      backgroundDarknessTooltip: `Faites glisser le curseur pour définir l'obscurcissement de l'arrière-plan`,
      text: 'Texte',
      color1: 'Couleur 1',
      color2: 'Couleur 2',
      direction: 'Direction',
      directionTooltip: 'Faites glisser le curseur pour définir la direction du dégradé',
      offset: 'Décalage',
      offsetTooltip: 'Faites glisser le curseur pour définir le décalage du dégradé',
      linkHeight: 'Hauteur du lien',
      linkHeightTooltip: 'Faites glisser le curseur pour changer la hauteur du bouton',
      icon: 'Icône',
      iconTooltip: 'Choisissez une icône pour votre bouton',
      imageShape: `Forme de l'image`,
      imageShapeTooltip: `Choisissez la forme de l'image pour votre lien`,
    },
    menu: {
      linkInBio: 'Lien en bio',
      home: 'Accueil',
      overview: 'Aperçu',
      linkInBioApps: 'Lien en bio',
      posts: 'Publications',
      audience: 'Audience',
      orders: 'Commandes',
      marketing: 'Marketing',
      emailMarketing: 'Marketing par e-mail',
      socialPlanner: 'Planificateur social',
      shortLinks: 'Raccourcisseur de liens',
      businessCards: 'Cartes de visite',
      recentProfiles: 'Profils récents',
      standalonePage: 'Page autonome',
      soloApps: 'App en bio',
      bots: 'Bots',
      smartReply: 'Instagram Reply',
      analytics: 'Analytique',
      settings: 'Paramètres',
      shop: 'Gagner',
      publish: 'Publier',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'Codes QR',
      singlePages: 'Apps',
      forms: 'Formulaires',
      form: 'Formulaires',
      automations: 'Automatisations',
      community: 'Communauté',
      messages: 'Boîte de réception',
      library: 'Bibliothèque',
      plugins: 'Plugins',
      agents: 'Agents',
      apps: 'Apps',
      emailSignatures: 'Signatures d’e-mail',
      virtualBackgrounds: 'Arrière-plans virtuels',
    },
    notificationsBlockSetting: {
      title: 'Notifications',
      setUp: 'Configurer',
      notifications: 'notifications',
      connect: 'Connecter',
      telegramText: `Recevoir une notification Telegram quand quelqu'un fait`,
      change: 'modification',
      email: 'E-mail',
      emailText: `Recevoir un e-mail quand quelqu'un fait`,
      webhook: 'Webhook',
      webhookTooltip: 'Ajouter un webhook',
      activate: 'Activer',
      webhookText: `Envoyer un événement vers un site web tiers quand quelqu'un fait`,
      webhookURL: 'URL du webhook (requête POST)',
      error: 'Entrez un lien correct',
      save: 'Enregistrer',
    },
    navigation: {
      content: 'Contenu',
      pages: 'Pages',
      posts: 'Publications',
      shop: 'Boutique',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytique',
      settings: 'Paramètres',
      apps: 'Applications',
      store: 'Boutique',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytique',
      settings: 'Paramètres',
      editTabs: 'Modifier les onglets',
    },
    unlockModal: {
      title: 'Débloquer les fonctionnalités Pro',
      text: 'Tirez le meilleur parti de votre lien en bio. Seulement 5$/mois — débloquez tout ce que Pro a à offrir :',
      checkBoxTitle1: 'Plus de blocs :',
      checkBoxText1: 'Ajoutez des formulaires, boutiques, comptes à rebours et lecteurs média',
      checkBoxTitle2: 'Analytique avancée :',
      checkBoxText2: 'Suivez les clics, vues et informations sur votre audience',
      checkBoxTitle3: 'Domaine personnalisé :',
      checkBoxText3: 'Utilisez votre propre domaine pour un aspect professionnel',
      checkBoxTitle4: 'Boutique intégrée :',
      checkBoxText4: 'Vendez des produits et gérez les commandes facilement',
      checkBoxTitle5: 'Outils SEO :',
      checkBoxText5: 'Améliorez votre classement avec les balises méta, UTM et slugs personnalisés',
      checkBoxTitle6: 'Intégrations :',
      checkBoxText6: `Synchronisez avec MailChimp, Zapier et d'autres outils`,
      checkBoxTitle7: 'Marketing par e-mail :',
      checkBoxText7: 'Collectez des prospects et envoyez des campagnes automatisées',
      checkBoxTitle8: 'Support prioritaire :',
      checkBoxText8: `Obtenez de l'aide plus rapidement quand vous en avez besoin`,
      upgradeToPro: 'Passer au Pro',
      viewAllPlans: 'Voir tous les forfaits',
    },
    profileSwitcher: {
      title: 'Tous les profils',
      button: 'Ajouter un nouveau profil',
    },
    account: {
      signOut: 'Se déconnecter',
      createNew: 'Créer un nouveau lien en bio',
      tryPro: 'Essayez Pro maintenant !',
      tryProText: 'Obtenez une personnalisation avancée et des informations plus approfondies sur votre audience pour attirer plus de visiteurs !',
    },
    accountSettings: {
      title: 'Paramètres du compte',
    },
    billingHistory: {
      title: 'Historique de facturation',
    },
    pages: {
      home: 'Accueil',
      newPage: 'Nouvelle page',
      managePages: 'Gérer les pages',
    },
    blockItem: {
      actionRequired: 'action requise',
      hidden: 'Masqué · personne ne le voit',
    },
    blockContent: {
      untitled: 'Sans titre',
      clickToRename: 'Cliquez pour renommer le sous-titre',
      saving: 'enregistrement',
      saved: 'enregistré',
      deleteTitle: 'Êtes-vous sûr(e) de vouloir supprimer ce bloc ?',
      cancel: 'Annuler',
      yes: 'Oui',
    },
    addButtonModal: {
      title: `Ajouter un bouton d'action`,
      close: 'Fermer',
      added: 'Ajouté',
      add: 'Ajouter',
      messageTitle: 'Message',
      messageText: 'Le bouton Message permet aux utilisateurs de vous contacter via une messagerie',
      subscribeTitle: `S'abonner`,
      subscribeText: `Le bouton S'abonner permet aux utilisateurs de s'abonner à votre liste e-mail ou messagerie`,
      ctaTitle: 'Bouton CTA',
      ctaText: `Le CTA est une invitation sur un site web qui indique à l'utilisateur d'effectuer une action spécifique`,
      cartTitle: 'Panier',
      cartText: 'Affichez une icône de panier pour indiquer que les visiteurs peuvent faire des achats sur votre site web',
      contactTitle: 'Contact',
      contactText: `Permettez aux visiteurs d'accéder rapidement à vos coordonnées`,
      qrcodeTitle: 'Code QR',
      qrcodeText: 'Affichez un code QR pour que les visiteurs puissent rapidement scanner et partager votre page',
      languageTitle: 'Langue',
      languageText: 'Permet aux visiteurs de changer la langue de votre page',
      searchTitle: 'Recherche',
      searchText: 'Permettez aux visiteurs de rechercher les produits de votre boutique depuis l’en-tête',
    },
    inputMask: {
      copyLink: 'Copier le lien',
    },
    videoLibrary: {
      addVideo: 'Ajouter une vidéo',
      myVideos: 'Mes vidéos',
      stockVideos: 'Vidéos stock',
      pasteUrl: `Coller l'URL`,
      uploadVideo: 'Téléverser une vidéo',
    },
    createBlockModal: {
      searchTitle: 'Choisissez un bloc pour votre page',
      title: 'Ajouter à UniLink',
      contentTitle: 'Contenu',
      contentText: 'Créez et gérez votre page',
      growTitle: 'Prospects',
      growText: `Collectez des prospects et stimulez l'engagement`,
      monetizeTitle: 'Monétiser',
      monetizeText: 'Vendez des produits, du contenu et des services',
      monetizationTitle: `Gagner et collecter de l'argent`,
      monetizationText: 'Vendez des produits, services et collectez des pourboires',
      socialTitle: 'Contenu de réseaux sociaux',
      socialText: 'Partagez du contenu de réseaux sociaux sur votre UniLink',
      toolsTitle: 'Outils de croissance',
      toolsText: 'Développez, gérez et connectez-vous avec votre audience',
      search: 'Rechercher',
      all: 'Tous',
      allCategories: 'Toutes les catégories',
      content: 'Contenu',
      monetization: 'Monétisation',
      social: 'Social',
      tools: 'Outils',
      header: 'En-tête',
      headerText: 'Ajoutez une photo de profil et une biographie',
      link: 'Liens',
      linkText: 'Sélectionnez la disposition des liens',
      text: 'Texte',
      textText: 'Sélectionnez la disposition du texte',
      videos: 'Vidéos',
      videosText: 'Sélectionnez le type de vidéo',
      image: 'Image',
      imageText: `Ajoutez des blocs d'images`,
      music: 'Musique',
      musicText: 'Sélectionnez le type de musique',
      socialFeeds: 'Flux sociaux',
      socialFeedsText: 'Sélectionnez le type de flux social',
      moreContent: 'Plus',
      moreContentText: 'Ajoutez plus de blocs de contenu',
      dataCollect: 'Collecte de données',
      dataCollectText: 'Sélectionnez le type de collecte de données',
      form: 'Formulaire',
      formText: 'Sélectionnez le type de formulaire',
      conversionTools: `Outils d'engagement`,
      conversionToolsText: 'Ajoutez des blocs de conversion',
      products: 'Produits',
      productsText: 'Ajoutez des blocs de produits',
      donation: 'Pourboires et dons',
      tipsAndDonations: 'Pourboires et dons',
      tipsDonationsText: 'Blocs de pourboires et de dons',
      event: 'Événement',
      eventText: `Sélectionnez le type d'événement`,
      quickAdd: 'Tous les blocs',
      quickAddText: `Ajouter n'importe quel bloc`,
    },
    addBlockModal: {
      title: 'Ajouter à UniLink',
      dragToAdd: 'Glissez pour ajouter',
      contentTitle: 'Partager du contenu de base',
      contentText: 'Partagez du contenu directement sur votre UniLink',
      monetizationTitle: `Gagner et collecter de l'argent`,
      monetizationText: 'Vendez des produits, services et collectez des pourboires',
      socialTitle: 'Contenu de réseaux sociaux',
      socialText: 'Partagez du contenu de réseaux sociaux sur votre UniLink',
      toolsTitle: 'Outils de croissance',
      toolsText: 'Développez, gérez et connectez-vous avec votre audience',
      search: 'Rechercher',
      searchPlaceholder: 'Rechercher du contenu...',
      all: 'Tous',
      allCategories: 'Toutes les catégories',
      content: 'Contenu',
      monetization: 'Monétisation',
      social: 'Social',
      tools: 'Outils',
      suggestTitle: 'Proposez votre bloc',
      suggestText: 'Un bloc manque ? Dites-nous ce que vous aimeriez voir',
      suggestModalTitle: 'Proposer un bloc',
      suggestModalSubtitle: 'Décrivez le bloc que vous aimeriez voir dans UniLink. Nous lisons chaque idée.',
      suggestPlaceholder: 'par ex. Un bloc de réservation avec synchronisation Google Agenda…',
      suggestSubmit: 'Envoyer la suggestion',
      suggestSending: 'Envoi…',
      suggestSuccessTitle: 'Suggestion envoyée !',
      suggestSuccess: 'Merci ! Nous lisons chaque idée et nous en servons pour élaborer notre feuille de route.',
      suggestError: 'Échec de l’envoi. Veuillez réessayer.',
    },
    tabNavigation: {
      tabView: 'Vue des onglets',
      tabViewTooltip: 'Sélectionnez la vue des onglets pour la navigation',
      colors: 'Couleurs',
      colorsTooltip: 'Choisissez les couleurs des publications et des boutons',
      tabs: 'Onglets',
      tabsTooltip: `Choisissez les onglets qui s'affichent dans la navigation du site web`,
      content: 'Contenu',
      posts: 'Publications',
      store: 'Boutique',
      shop: 'Boutique',
      tabsSettings: 'Paramètres de navigation par onglets',
    },
    hideLogo: {
      text: 'Afficher le logo UniLink dans le pied de page de votre page.',
      text2: 'Afficher le logo UniLink dans le pied de page de votre page.',
    },
    palettePreview: {
      custom: `Couleur d'arrière-plan personnalisée`,
      hexColor: 'Couleur hexadécimale',
      hexColorTooltip: 'Entrez la couleur hexadécimale de votre aperçu',
    },
    backgroundVideo: {
      insert: `Insérer l'URL`,
      upload: 'Téléverser une vidéo',
      search: 'Rechercher une vidéo',
    },
    periodDropdown: {
      today: `Aujourd'hui`,
      yesterday: 'Hier',
      last7days: '7 derniers jours',
      last30days: '30 derniers jours',
      allTime: 'Tout le temps',
      custom: 'Personnalisé',
    },
    subsections: {
      content: 'Contenu',
      design: 'Design',
      settings: 'Paramètres',
    },
    wrapperSettings: {
      lock: 'Passer au forfait PRO',
    },
    shareModal: {
      addSocials: 'Ajouter aux réseaux sociaux',
      shareTo: 'Partager sur',
      qrCode: 'Code QR',
      customizeUrl: `Personnaliser l'URL`,
      goToMy: 'Aller à mon',
      print: 'Vous pouvez imprimer votre code QR unique sur',
      cards: 'des cartes de visite et des flyers',
      download: 'Télécharger',
      copy: 'Copier',
      previewMobile: 'Aperçu sur mobile',
      scanMobilePreview: 'Scannez le code QR sur votre appareil mobile pour prévisualiser votre site web',
      types: {
        socials: 'réseaux sociaux',
        shareTo: 'partager',
        qrCode: 'QR',
        title: 'Partagez votre UniLink',
        titleSocials: 'Ajoutez UniLink à vos réseaux sociaux',
        titleShareTo: 'Partager vers...',
        titleQRCode: 'Code QR',
        titlePreviewMobile: 'Aperçu sur mobile',
      },
      socialList: {
        instagramText: 'Ajoutez votre UniLink à votre profil Instagram. Copiez simplement votre URL UniLink, allez dans Modifier le profil, et collez-la dans le champ Site web.',
        facebookText:
          'Ajoutez votre UniLink à votre profil Facebook. Copiez simplement votre URL UniLink, allez à la page À propos de votre profil, cliquez sur Coordonnées et informations de base, puis cliquez sur + Ajouter un site web, collez votre URL UniLink dans le champ Adresse du site web, et cliquez sur Enregistrer.',
        tikTokText:
          'Ajoutez votre UniLink à votre profil Facebook. Copiez simplement votre URL UniLink, allez à la page À propos de votre profil, cliquez sur Coordonnées et informations de base, puis cliquez sur + Ajouter un site web, collez votre URL UniLink dans le champ Adresse du site web, et cliquez sur Enregistrer.',
        twitchText: `Ajoutez votre UniLink à votre chaîne Twitch. Copiez simplement votre URL UniLink, allez sur votre chaîne Twitch, cliquez sur À propos, puis cliquez sur Modifier à propos et les paramètres de liens, faites défiler jusqu'aux Liens sociaux, ajoutez UniLink dans le premier champ texte, et collez votre URL UniLink dans le second champ texte, puis cliquez sur Ajouter.`,
        youTubeText:
          'Ajoutez votre UniLink à votre chaîne YouTube. Copiez simplement votre URL UniLink, allez sur votre chaîne YouTube, cliquez sur Personnaliser la chaîne, puis cliquez sur Informations de base, et sous Liens, ajoutez un titre de lien et collez votre URL UniLink dans le champ URL, puis cliquez sur Publier.',
        linkedInText: `Ajoutez votre UniLink à votre profil LinkedIn. Copiez simplement votre URL UniLink, allez sur votre profil LinkedIn, cliquez sur l'icône crayon, faites défiler jusqu'aux Coordonnées, collez votre URL UniLink dans le champ URL du site web, puis cliquez sur Appliquer.`,
        pinterestText:
          'Ajoutez votre UniLink à votre profil Pinterest. Copiez simplement votre URL UniLink, allez dans vos paramètres Pinterest, collez votre URL UniLink dans le champ URL du site web, puis cliquez sur Enregistrer.',
        twitterText:
          'Ajoutez votre UniLink à votre profil Twitter. Copiez simplement votre URL UniLink, allez sur votre profil, cliquez sur Modifier le profil, et collez votre URL UniLink dans le champ Site web.',
      },
      share: {
        shareFacebook: 'Partager sur Facebook',
        shareLinkedIn: 'Partager sur LinkedIn',
        shareTwitter: 'Partager sur Twitter',
        shareWhatsApp: 'Partager via WhatsApp',
        shareMessenger: 'Partager via Messenger',
        shareEmail: 'Partager par e-mail',
      },
    },
  },
  popupMenu: {
    edit: 'Modifier la page',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    copyLink: `Copier l'URL`,
    delete: 'Supprimer',
    showThumbnail: 'Afficher les miniatures des pages dans le tableau de bord',
    manageTabs: 'Gérer les onglets',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nouvel onglet',
  },
  blocks: {
    header: {
      blockTitle: 'En-tête',
      blockText: 'Personnalisez votre photo de profil, ajoutez une courte biographie et mettez à jour vos icônes sociales',
      blockShortText: 'Personnalisez votre profil',
      layout: 'Disposition',
      layoutTooltip: `Créez la disposition de l'en-tête que vous souhaitez`,
      layoutAlign: 'Alignement de la disposition',
      layoutAlignTooltip: 'Aligner le texte',
      profilePicture: 'Photo de profil',
      profilePictureTooltip: 'Changez votre photo de profil',
      pictureSize: `Taille de l'image`,
      pictureSizeTooltip: `Vous pouvez changer la taille de l'image`,
      pictureHeight: `Hauteur de l'image`,
      pictureHeightCaption: `Vous pouvez changer la hauteur de l'image`,
      preview: 'Aperçu',
      badge: 'Badge',
      badgeTooltip: `Ajoutez un badge vérifié à l'en-tête`,
      tags: 'Tags',
      tagsTooltip: 'Afficher les tags de catégorie sous votre nom (jusqu’à 5)',
      tagsAdd: 'Ajouter des tags',
      addTags: '+ Ajouter des tags',
      tagsEdit: 'Modifier les tags',
      tagsCustomPlaceholder: 'Ajouter un tag personnalisé',
      tagsCustomAdd: 'Ajouter',
      tagsSuggested: 'Catégories suggérées',
      tagsSelected: 'Sélectionnés',
      tagsEmpty: 'Pas encore de tags — choisissez parmi les suggestions ou ajoutez les vôtres',
      tagsLimit: 'Max 5 tags',
      visibility: 'Visibilité',
      visibilityTooltip: 'Afficher ou masquer la photo de profil',
      cover: 'Couverture',
      coverTooltip: `Ajoutez une image ou une vidéo à la couverture de l'en-tête`,
      addCover: 'Ajouter une couverture',
      image: 'Image',
      video: 'Vidéo',
      positionCover: 'Position du texte et du bouton',
      positionCoverTooltip: 'Faites glisser le curseur pour changer la position',
      buttons: 'Boutons',
      block: 'Bloc',
      videoProcessing: 'Traitement vidéo',
      vibe: 'Ambiance',
      vibeTooltip: 'Ajoutez votre ambiance',
      stories: 'Stories',
      storiesTooltip: 'Ajoutez vos stories',
      addStory: 'Ajouter une story',
      storiesSubtitle: 'Ajoutez une image ou une vidéo à vos stories',
      subscribeMethod: `Méthode d'abonnement`,
      subscribeMethodTooltip: `Choisissez votre méthode d'abonnement`,
      subscribeLink: `Lien d'abonnement`,
      subscribeLinkTooltip: `Copiez votre lien d'abonnement`,
      minWidth: 'Largeur minimale',
      addVCard: 'Ajouter une vCard',
      vCard: 'vCard',
      vCardTooltip: 'Vous pouvez ajouter des informations sur vous',
      buttonInline: `Bouton en ligne dans l'en-tête`,
      buttonInsideContact: `Bouton à l'intérieur du bouton Contact`,
      showSaveContact: 'Afficher enregistrer le contact',
      options: 'Options',
      showBusinessCard: 'Afficher la carte de visite',
      showBusinessCardCaption: 'Ajoute un bouton « Enregistrer le contact » ici.',
      editBusinessCard: 'Modifier la carte',
      editContactDetails: 'Modifier les coordonnées sur Business cards',
      needAddContact: 'Vous devez ajouter un bouton Contact',
      socialGap: 'Espacement',
      socialGapCaption: `Vous pouvez changer l'espacement`,
      socialSize: 'Taille',
      socialSizeCaption: 'Vous pouvez changer la taille',
      icons: 'Icônes',
      iconsTooltip: 'Ajouter une icône au bouton',
      bottomButtonsSettings: 'Boutons du bas',
      bottomButtonsLayout: 'Disposition',
      bottomButtonsRow: 'Côte à côte',
      bottomButtonsColumn: 'Empilés',
      cropMismatch: 'Cette photo est recadrée pour une autre disposition.',
      adjustCrop: 'Ajuster le recadrage',
      photoShapeLabel: 'Forme de la photo',
      photoShapeTooltip: 'Choisissez si cette disposition affiche la photo carrée ou un recadrage vertical.',
      photoShapeSquare: 'Carrée',
      photoShapeVertical: 'Verticale',
      coverShape: 'Forme de la couverture',
      coverShapeTooltip: 'Choisissez le bord inférieur de la couverture : droit, courbé vers le bas ou vers le haut.',
      coverShapeStraight: 'Droit',
      coverShapeArcDown: 'Arc vers le bas',
      coverShapeArcUp: 'Arc vers le haut',
      avatarOffsetLabel: 'Position de l’avatar',
      avatarOffsetTooltip: 'Décalez l’avatar vers le haut ou le bas par rapport au bord de la couverture.',
      photoStyleProTitle: 'Débloquez les styles de photo avancés',
      photoStyleProDesc: 'Sans arrière-plan et Texte derrière sont des fonctionnalités PRO.',
      photoShapeCustom: 'Personnalisée',
      sliderStyleLabel: 'Style de diaporama',
      sliderStyleTooltip: 'Balayage affiche une photo à la fois ; Galerie affiche une rangée de miniatures — touchez une miniature pour changer la photo principale.',
      sliderStyleSwipe: 'Balayage',
      sliderStyleGallery: 'Galerie',
      photoPositionLabel: 'Position de la photo',
      photoPositionHint: 'Cadrage vertical',
      verticalCropHint: 'Cette disposition affiche une photo originale. Choisissez la zone verticale à afficher.',
      verticalCropReady: 'Ajustez la zone verticale affichée dans cette disposition.',
      pickVerticalArea: 'Choisir la zone verticale',
      photoStyle: 'Style de la photo',
      photoStyleTooltip: 'Affichez la photo telle quelle, avec son arrière-plan supprimé, ou placez du texte derrière le sujet.',
      avatarModeOriginal: 'Originale',
      avatarModeCutout: 'Sans arrière-plan',
      avatarModeLayered: 'Texte derrière',
      overlayText: 'Texte',
      overlayTextPlaceholder: 'Votre nom (par défaut)',
      overlayColor: 'Couleur du texte',
      overlaySize: 'Taille',
      overlayY: 'Position verticale',
      overlayEffect: 'Animation',
      overlayEffectNone: 'Aucune',
      overlayEffectShimmer: 'Scintillement',
      overlayEffectGlow: 'Lueur',
      overlayEffectGradient: 'Dégradé',
      overlayEffectSparkle: 'Étincelles',
      overlayUsesName: 'Sur cette disposition, le texte est le nom de votre profil — il apparaît derrière vous. Modifiez-le dans la section « Nom ».',
      cutoutGenerate: 'Générer le détourage',
      cutoutRegenerate: 'Régénérer',
      cutoutUpload: 'Importer',
      cutoutOr: 'ou',
      cutoutGenerating: 'Génération...',
      cutoutUploading: 'Import en cours...',
      cutoutVideoHint: `La suppression de l'arrière-plan ne fonctionne qu'avec des photos, pas des vidéos.`,
      cutoutTimeout: `La suppression de l'arrière-plan prend trop de temps. Veuillez réessayer.`,
      profileBadges: 'Badges',
      profileBadgesTooltip: `Choisissez jusqu'à 3 badges à afficher à côté de votre nom`,
      profileBadgesProLockHint: 'Passez à PRO pour utiliser ce badge',
      profileBadgesAdd: 'Ajouter des badges',
      profileBadgesManage: 'Gérer les badges',
      profileBadgesModalTitle: 'Ajoutez des badges à votre profil',
      profileBadgesModalSubtitle: 'Mettez en avant vos réussites et distinctions.',
      profileBadgesCustomCta: 'Importez votre propre badge',
      profileBadgesCustomDesc: 'Votre badge personnalisé',
      profileBadgesCustomName: 'Nom du badge',
      profileBadgesCustomChoose: 'Choisir une image',
      profileBadgesCustomChange: `Changer l'image`,
      profileBadgesCustomUploading: 'Import en cours…',
      profileBadgesCustomAdd: 'Ajouter le badge',
      ribbonLabel: 'Ruban décoratif',
      ribbonLabelTooltip: `Ajoutez une bande de couleur sous le héros de l'en-tête`,
      addTint: 'Ajouter un ruban',
      ribbonTitle: 'Ruban',
      ribbonText: 'Texte du ruban',
      ribbonTextPlaceholder: `p. ex. -20 % jusqu'à la fin du mois`,
      ribbonColor: 'Couleur du ruban',
      ribbonTheme: 'Style',
      ribbonThemes: {
        none: 'Aucun décor',
        birthday: 'Anniversaire',
        newyear: 'Nouvel An',
        valentine: 'Saint-Valentin',
        halloween: 'Halloween',
        summer: 'Été',
      },
      ribbonEffect: 'Effet',
      ribbonEffects: {
        none: 'Aucun',
        gradient: 'Dégradé animé',
        shimmer: 'Scintillement',
        lights: 'Guirlande lumineuse',
      },
      ribbonPosition: 'Position',
      ribbonPositions: {
        bottom: `Sous l'en-tête`,
        underPhoto: 'Sous la photo',
      },
      ribbonRemove: 'Retirer le ruban',
      statusBadges: 'Activité',
      statusBadgesTooltip: `Affichez l'activité en temps réel sur votre page`,
      addStatus: 'Ajouter une activité',
      statusDisabledHint: 'Masqué · désactivé',
      followersTitle: 'Abonnés',
      followersCounter: `Compteur d'abonnés`,
      followersTooltip: `Affichez le nombre total d'abonnés de vos comptes sociaux connectés`,
    },
    text: {
      blockTitle: 'Texte',
      blockText: `Bloc de texte général pour écrire ce que vous voulez. Vous pouvez mettre en forme votre texte avec l'éditeur WYSIWYG`,
      blockShortText: 'Bloc de texte général',
      title: 'Titre',
      titleText: 'Personnalisez la taille de votre titre',
      orderOfElements: 'Ordre des éléments',
      orderOfElementsTooltip: `Faites glisser le curseur pour changer l'ordre des éléments`,
      changeOrder: `Changer l'ordre`,
      text: 'Texte',
      content: 'Contenu',
      image: 'Image',
      button: 'Bouton',
      addButtons: `Ajouter d'autres boutons`,
      renameTabHint: "Renommer l'onglet",
      addElement: 'Ajouter un élément',
      showFullText: 'afficher en entier',
      displayedContent: 'Contenu affiché',
      displayedContentTooltip: 'Afficher ou masquer le contenu',
      buttonLayout: 'Disposition du bouton',
      buttonLayoutTooltip: 'Choisissez une disposition verticale ou horizontale des boutons',
    },
    timeline: {
      blockTitle: 'Chronologie',
      blockText: 'Affichez une chronologie verticale avec des événements. Chaque événement peut avoir une date/heure, un titre, une description et une image facultative',
      blockShortText: 'Afficher la chronologie des événements',
      editItem: `Modifier l'événement`,
      title: 'Titre',
      titlePlaceholder: `Titre de l'événement`,
      subtitle: 'Sous-titre',
      subtitlePlaceholder: 'Rôle ou affiliation (facultatif)',
      description: 'Description',
      descriptionPlaceholder: `Description de l'événement (facultatif)`,
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      showEndDate: 'Afficher la date de fin',
      showEndDateTooltip: 'Désactivez pour les événements en cours (ex. « ici depuis 2023 »)',
      includeTime: `Inclure l'heure`,
      includeTimeTooltip: `Si désactivé, seule la date sera affichée sans l'heure`,
      image: 'Image',
      imagePlaceholder: 'Téléverser un avatar ou une icône',
      imageUploadFailed: `Impossible de téléverser l'image. Utilisez Mes médias ou collez un lien.`,
      untitled: 'Sans titre',
      listLayout: 'Disposition en liste',
      lineColor: 'Couleur de la ligne',
    },
    trust: {
      blockTitle: 'Confiance',
      blockShortText: 'Partagez vos partenariats',
      blockText: 'Regroupez toutes vos connexions en un seul endroit.',
      titleText: 'Personnalisez la taille de votre titre',
      orderOfElements: 'Ordre des éléments',
      orderOfElementsTooltip: `Faites glisser le curseur pour changer l'ordre des éléments`,
      changeOrder: `Changer l'ordre`,
      text: 'Texte',
      content: 'Contenu',
      image: 'Image',
      button: 'Bouton',
      displayedContent: 'Contenu affiché',
      displayedContentTooltip: 'Afficher ou masquer le contenu',
      enterTrustLink: `Entrez l'URL du partenaire`,
      enterTrustLinkTooltip: `Collez l'URL du partenaire`,
      enterPartnerName: 'Entrez le nom du partenaire',
      enterPartnerUrl: 'https://www.votrePartenaire.com/',
      enterDescription: 'Entrez la description (optionnel)',
      partnerLogo: 'Logo du partenaire',
      uploadPartnerLogo: 'Téléversez le logo de votre partenaire',
    },
    link: {
      blockTitle: 'Liens',
      blockText: 'Dirigez le trafic vers votre site web, blog, boutique en ligne ou toute autre page web',
      blockShortText: 'Dirigez le trafic vers un site web',
      addLink: 'Ajouter un lien',
      addNewLink: 'Ajouter un nouveau lien',
      restrictedTitle: 'Les liens {platform} sont une fonctionnalité PRO',
      restrictedText: `L'ajout de liens {platform} est disponible avec le forfait PRO. Améliorez votre forfait pour ajouter ce lien à votre page.`,
      upgradeToPro: 'Passer à PRO',
      showMore: 'Afficher plus',
      showLess: 'Afficher moins',
      viewArchive: 'Voir les archives',
      archivedLinks: 'Liens archivés',
      noArchivedLinks: `Gardez votre administration de liens propre et concentrée en archivant les liens que vous n'utilisez pas actuellement.`,
      archiveAllUnpublished: 'Archiver tous les liens non publiés',
      addFormExisting: 'Ajouter depuis les liens existants',
      addYourLink: 'Ajoutez votre lien au groupe',
      add: 'Ajouter',
      otherTypes: `Type d'action`,
      link: 'Lien',
      navigate: 'Naviguer',
      navigateTo: 'Aller à',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Page',
      navigateProduct: 'Produit',
      navigateBlock: 'Bloc',
      modal: 'Modale',
      showModal: 'Afficher la modale',
      modalBlock: 'Afficher le bloc',
      modalItem: `Afficher l'élément`,
      modalCustom: 'Personnalisé',
      document: 'Document',
      privat24: 'Privat24',
      phone: 'Appel téléphonique',
      viber: 'Ouvrir Viber',
      skype: 'Ouvrir Skype',
      email: 'Envoyer un e-mail',
      discount: 'Réduction',
      smartLink: 'Lien intelligent',
      mobileApp: 'Deep Link',
      enterURL: `Entrez l'URL`,
      enterPrivat: 'Entrez votre carte de Privat24',
      enterPhone: 'Entrez le numéro de téléphone',
      enterViber: 'Entrez le numéro Viber',
      enterSkype: 'Entrez le Skype',
      enterEmail: `Entrez l'e-mail`,
      enterTitle: 'Entrez le titre',
      enterCopyText: 'Entrez le texte à copier',
      enterPromoCode: 'Entrez le code promo',
      group: 'Créer un groupe',
      content: 'Contenu',
      links: 'Liens',
      heading: 'En-tête',
      settings: 'Paramètres',
      thumbnail: 'Miniature',
      typeTooltip: '  Le clic ouvrira ce lien',
      title: 'Titre',
      titleTooltip: 'Nom de votre lien',
      description: 'Description',
      descriptionTooltip: 'Description optionnelle des caractéristiques du lien, types, couleurs, tailles, etc.',
      label: 'Étiquette',
      labelTooltip: `Ajoutez un nom d'étiquette`,
      button: 'Bouton',
      buttonTooltip: 'Ajoutez un nom de bouton',
      buttonText: 'Texte du bouton',
      buttonTextTooltip: 'Nom de votre bouton',
      buttonUrl: 'URL du bouton',
      buttonUrlTooltip: `Entrez l'URL du bouton`,
      addLinkToGroup: 'Ajouter un lien au groupe',
      removeFromGroup: 'Retirer du groupe',
      deletePermanently: 'Supprimer définitivement',
      image: 'Image',
      buttonBg: 'Arrière-plan du bouton',
      postPreview: 'Aperçu de la publication',
      separatorType: 'Type de séparateur',
      separatorTypeTooltip: 'Ajoutez un type de séparateur à votre bouton',
      section: 'Section',
      sectionTooltip: 'Section du lien',
      descriptionSeparator: 'Description',
      descriptionSeparatorTooltip: 'Description optionnelle de la section',
      sectionText: 'Texte de la section',
      linkInstant: 'Redirection instantanée du lien',
      spotlight: 'Mettre le lien en avant',
      addEffect: 'Ajouter un effet spécial',
      countdown: 'Compte à rebours',
      countdownTimer: 'Minuteur',
      countdownText: `Ajoutez un compte à rebours en direct jusqu'au moment où votre lien devient cliquable`,
      chooseDate: 'Choisir la date',
      chooseDateTooltip: 'Choisissez la date pour votre lien',
      chooseAction: `Choisir l'action`,
      chooseActionTooltip: `Choisissez l'action pour votre lien`,
      addCountdown: 'Ajouter un compte à rebours au lien',
      scheduler: 'Planificateur',
      schedule: 'Planifier',
      scheduleText: 'Choisissez une date et une heure futures pour activer votre lien',
      activateOn: 'Activer le',
      activateOnTooltip: 'Choisissez la date',
      deactivateOn: 'Désactiver le',
      deactivateOnTooltip: 'Choisissez la date',
      addSchedule: 'Ajouter une planification pour',
      scheduleError: 'La date de fin ne peut pas être antérieure à la date de début et la date de début ne peut pas être dans le passé.',
      scheduleErrorPast: `La date d'activation ne peut pas être dans le passé.`,
      scheduleErrorPastDeactivate: 'La date de désactivation ne peut pas être dans le passé.',
      scheduleErrorOrder: `La date de désactivation doit être postérieure à la date d'activation.`,
      activatesIn: `S'active dans`,
      deactivatesIn: 'Se désactive dans',
      lock: 'Verrouiller',
      lockText: `Les visiteurs ne peuvent accéder à ce lien qu'en remplissant l'un des critères.`,
      lockCode: 'Code',
      lockCodeTitle: 'Code pour déverrouiller ce lien',
      lockCodeText: 'Les visiteurs doivent entrer un code à 4 chiffres pour déverrouiller ce lien',
      lockSubscribe: `S'abonner`,
      lockSubscribeTitle: `Les visiteurs doivent s'abonner à votre UniLink pour déverrouiller le lien.`,
      lockSubscribeText: 'Le verrouillage a été configuré avec succès.',
      lockPayment: 'Paiement',
      lockPaymentText: 'Le verrouillage a été configuré avec succès.',
      price: 'Prix',
      priceTooltip: 'Ajoutez le prix de votre produit',
      lockAge: 'Date de naissance (Âge)',
      lockAgeTitle: `Définir l'âge minimum`,
      lockAgeText: `Les visiteurs doivent avoir plus d'un certain âge pour déverrouiller le lien avec leur date de naissance`,
      lockAgeAlert: 'Le verrouillage a été configuré avec succès.',
      lockSensitive: 'Contenu sensible',
      lockSensitiveText: `Les visiteurs doivent reconnaître que ce lien peut contenir du contenu qui n'est pas approprié pour tous les publics.`,
      makeLink: 'Rendre le lien payant',
      addLock: 'Ajouter un verrouillage au lien',
      save: 'Enregistrer',
      clear: 'Effacer',
      buttonColor: 'Couleur du bouton',
      labelColor: `Couleur de l'étiquette`,
      background: 'Arrière-plan',
      imageHeight: `Hauteur de l'image`,
      imageHeightTooltip: `Faites glisser le curseur pour changer la hauteur de l'image`,
      buttonMinimum: 'Hauteur minimale',
      buttonMinimumTooltip: 'Faites glisser le curseur pour changer la hauteur du bouton',
      textPosition: 'Position du texte',
      textPositionTooltip: 'Choisir la position verticale du texte',
      preview: 'aperçu',
      defaultDesign: 'Design par défaut',
      defaultDesignTooltip: 'Configurer le design par défaut des liens',
      defaultDesignTitle: 'Veuillez noter que ce design sera appliqué à tous les liens.',
      defaultDesignText: 'Vous pouvez changer le design par défaut des liens',
      changeDefault: 'Changer le défaut',
      applyDefault: 'Appliquer le défaut',
      scheduled: 'Planifié',
      scheduledVisible: 'Le lien planifié est maintenant visible',
      scheduledHidden: 'Le lien planifié est maintenant masqué',
      linkClickable: 'Lien cliquable dans',
      linkDisable: 'Lien désactivé dans',
      lockedBy: 'Verrouillé par',
      items: 'Éléments',
      doNotAnyLinks: `Vous n'avez pas encore de liens`,
      sublinks: 'Sous-liens',
      layout: 'Disposition',
      layoutTooltip: 'Choisissez la disposition des sous-liens que vous souhaitez',
      hideGroupLink: 'Masquer le lien du groupe',
      rules: 'Règles',
      rulesText: 'Modifiez la visibilité de ce lien selon les visiteurs de votre page.',
      rulesEmpty: 'Aucune condition pour le moment. Ajoutez une condition pour contrôler qui voit ce lien.',
      rulesAddCondition: 'Ajouter une condition',
      rulesActive: 'Règles de visibilité',
      rulesIf: 'Si',
      rulesThen: 'Alors',
      ruleTypeLocation: 'Localisation',
      ruleTypeDevice: 'Appareil',
      ruleTypeTime: 'Jour et heure',
      ruleOperatorIs: 'est',
      ruleOperatorIsNot: `n'est pas`,
      ruleActionHide: 'Masquer le lien',
      ruleActionShow: 'Afficher le lien',
      ruleSelectLocations: 'Sélectionner des localisations',
      ruleSearchLocations: 'Rechercher des pays…',
      ruleFrom: 'De',
      ruleTo: 'À',
      ruleAnyTime: 'Indifférent',
    },
    'data-collect': {
      blockTitle: 'Collecte de données',
      blockText: 'Collectez les e-mails ou numéros de téléphone de vos visiteurs',
      blockShortText: 'Collectez les e-mails',
      maxSize: 'Vous pouvez ajouter un maximum de 3 canaux',
      customTerms: 'CGU personnalisées',
      customTermsTooltip: 'Ajoutez des CGU personnalisées à votre formulaire',
      termsConditions: 'Conditions générales',
      text: 'Texte',
      subscribe: `S'abonner`,
      title: 'Titre',
      titleTooltip: 'Entrez le titre des conditions générales',
      titleResultTooltip: 'Entrez le titre pour votre soumission',
      url: 'URL',
      urlTooltip: `Entrez l'URL`,
      editItem: `Modifier l'élément`,
      placeholder: 'Placeholder',
      placeholderTooltip: 'Entrez le texte du placeholder',
      button: 'Bouton',
      buttonTooltip: 'Texte qui motivera le visiteur à entrer son e-mail (réduction de 10%, abonnez-vous maintenant, téléchargez le fichier, etc.)',
      successMessage: 'Message de succès',
      successMessageTooltip: 'Message de succès pour vos abonnés',
      botURL: 'URL du bot (optionnel)',
      botURLTooltip: `Entrez l'URL de votre bot`,
      botToken: 'Token du bot',
      botTokenTooltip: 'Entrez le token de votre bot',
      rewards: 'Réponses',
      rewardsTooltip: 'Ajoutez des réponses pour vos abonnés',
      addReward: 'Ajouter une réponse',
      thankYou: 'Message de remerciement',
      email: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse par e-mail',
        redirect: `Rediriger vers l'URL`,
      },
      phone: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse par téléphone',
        redirect: `Rediriger vers l'URL`,
      },
      telegram: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Telegram',
        redirect: `Rediriger vers l'URL`,
      },
      whatsapp: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot WhatsApp',
        redirect: `Rediriger vers l'URL`,
      },
      instagram: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Instagram',
        redirect: `Rediriger vers l'URL`,
      },
      messenger: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Messenger',
        redirect: `Rediriger vers l'URL`,
      },
      viber: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Viber',
        redirect: `Rediriger vers l'URL`,
      },
      connect: 'Connecter',
      toChangeReward: 'Pour changer le type de réponse, vous devez supprimer la réponse actuelle',
      remove: 'Supprimer',
      viewTypes: 'Types de vue',
    },
    form: {
      blockTitle: 'Formulaire',
      blockText: 'Vous permet de capturer des informations et des données de votre audience',
      blockShortText: 'Capturer des informations',
      fields: 'Champs',
      fieldsTooltip: 'Ajoutez des champs au formulaire',
      addCustomField: 'Ajouter un champ personnalisé',
      addItem: 'Ajouter un élément',
      editItem: `Modifier l'élément`,
      type: 'Type',
      typeTooltip: 'Choisissez le type de champ',
      string: 'Réponse courte',
      textarea: 'Réponse longue',
      dropdown: 'Menu déroulant',
      radio: 'Radio',
      checkbox: 'Case à cocher',
      date: 'Date',
      time: 'Heure',
      country: 'Pays',
      file: 'Envoi de fichier',
      rating: 'Note',
      email: 'E-mail',
      phone: 'Téléphone',
      number: 'Nombre',
      url: 'Site web',
      submissionsClosed: 'Ne plus accepter de réponses',
      submissionsClosedTooltip: 'Le formulaire est remplacé par un court message. Les réponses déjà reçues sont conservées.',
      closedTitle: 'Titre de clôture',
      closedText: 'Message de clôture',
      autoCloseAt: 'Fermer le',
      autoCloseAtTooltip: 'Le formulaire se ferme seul à cette heure, dans votre fuseau horaire.',
      autoCloseMax: 'Limite de réponses',
      autoCloseMaxTooltip: 'Le formulaire se ferme seul dès qu’il a reçu ce nombre de réponses.',
      autoCloseClear: 'Effacer',
      autoClosedByDate: 'Fermé : la date de fermeture est passée.',
      autoClosedByLimit: 'Fermé : la limite de réponses est atteinte.',
      showIfMatchAll: 'Si toutes les règles sont remplies',
      showIfMatchAny: 'Si une règle est remplie',
      showIfRule: 'Règle',
      showIfChooseField: 'Choisir un champ',
      showIfAddRule: 'Ajouter une règle',
      templates: {
        contact: 'Formulaire de contact',
        contactCaption: 'Une phrase, les champs, un bouton — le formulaire attendu',
        steps: 'En plusieurs étapes',
        stepsCaption: 'Deux questions par écran avec une barre de progression. Un long formulaire cesse de le paraître',
        upload: 'Envoi de fichier',
        uploadCaption: 'La zone de dépôt d’abord — pour visuels, briefs et documents',
        schedule: 'Jour et heure',
        scheduleCaption: 'Choisir un jour et un créneau, puis laisser un nom',
        rating: 'Note et avis',
        ratingCaption: 'Des étoiles, quelques sujets à toucher, un champ de commentaire',
        card: 'Classique',
        cardCaption: 'Le formulaire simple : champs empilés sur la page, bouton en dessous',
        button: 'Bouton avec fenêtre',
        buttonCaption: 'Un bouton sur la page ; le formulaire s’ouvre en fenêtre',
      },
      fieldName: 'Nom du champ',
      fieldNameTooltip: 'Entrez le nom du champ',
      name: 'Nom',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Entrez le texte du placeholder',
      required: 'Obligatoire',
      requiredTooltip: 'Vérifiez si le champ est obligatoire',
      value: 'Valeur',
      enterTitle: 'Entrez le titre',
      addValue: 'Ajouter une valeur',
      delete: 'Supprimer',
      update: 'Mettre à jour',
      add: 'Ajouter',
      confirmationPage: 'Action de confirmation',
      confirmationPageSubtitle: `Choisissez l'action résultat après la soumission du formulaire`,
      successMessage: 'Message de succès',
      successMessageTooltip: 'Message de succès après la soumission du formulaire',
      thankYou: 'Message de remerciement',
      submit: 'Soumettre',
    },
    contact: {
      blockTitle: 'Contacts',
      blockText: 'Les contacts permettent aux utilisateurs de communiquer directement avec vous. Ajoutez votre téléphone, e-mail, messagerie ou localisation',
      blockShortText: 'Communiquer avec les utilisateurs',
      addNewContact: 'Ajouter un nouveau contact',
      newContact: 'Nouveau contact',
      friendlyName: 'Nom convivial',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Foire aux questions — utilisée pour présenter une liste de réponses aux questions typiques que les utilisateurs pourraient poser',
      blockShortText: 'Questions fréquentes',
      addNewItem: 'Ajouter un nouvel élément',
      editItem: `Modifier l'élément`,
      title: 'Titre',
      titleTooltip: 'Entrez le titre',
      description: 'Description',
      descriptionTooltip: 'Entrez la description',
      update: 'Mettre à jour',
      add: 'Ajouter',
      howToFind: 'Comment nous trouver',
      view: 'Affichage',
      viewTooltip: 'Choisissez comment les éléments de la FAQ sont affichés',
      feed: 'Fil',
      slider: 'Diaporama',
      emptyTitle: `Vous n'avez encore aucun élément`,
      emptyText: 'Ajoutez votre première question pour remplir ce bloc.',
    },
    ama: {
      blockTitle: 'Posez-moi une question',
      blockShortText: 'Répondez aux questions des fans',
      blockText: 'Laissez votre audience poser des questions et répondez-y directement sur votre page',
    },
    feature: {
      blockTitle: 'Fonctionnalités',
      blockText: 'Section de texte avec image pour expliquer à vos utilisateurs pourquoi votre entreprise est la meilleure',
      blockShortText: 'Expliquez à vos utilisateurs pourquoi',
      title: 'Titre',
      titleTooltip: `Changer le titre de l'élément`,
      description: 'Description',
      descriptionTooltip: `Changer la description de l'élément`,
    },
    highlight: {
      blockTitle: 'Points forts',
      blockText: `Mettez en avant les liens les plus importants avec des miniatures (jusqu'à 3)`,
      blockShortText: 'Mettez en avant les plus importants',
      title: 'Titre',
      titleTooltip: `Changer le titre de l'élément`,
      url: 'URL',
      urlTooltip: `Changer l'URL de l'élément`,
      modeLink: 'Lien',
      modeStory: 'Story',
      coverPhoto: 'Photo',
      coverIcon: 'Icône',
      templates: {
        scroll: 'Rangée défilante',
        scrollCaption: 'Le bloc d’origine — des couvertures rondes réparties en rangées, qui défilent au-delà de trois',
        story: 'Stories',
        storyCaption: 'Des couvertures plus grandes dans l’anneau dégradé, pour qu’on les lise comme des stories à ouvrir',
        square: 'Couvertures carrées',
        squareCaption: 'Des couvertures carrées dans une rangée défilante — cela se lit comme une étagère, pas comme des stories',
        tall: 'Cartes hautes',
        tallCaption: 'Des cartes verticales avec le nom sur l’image. Idéal quand la couverture est l’essentiel',
        icon: 'Couvertures en icônes',
        iconCaption: 'Une grille d’icônes plutôt que des photos — quand il n’y a pas encore d’images',
        grid: 'Grille',
        gridCaption: 'Tous les moments d’un coup sur une grille de quatre colonnes, pour un ensemble trop long à faire défiler',
      },
    },
    banner: {
      blockTitle: 'Bannière',
      blockText:
        'Image, vidéo ou votre dernier produit en vedette pour le faire ressortir. Vous pouvez ajouter un bouton CTA pour guider les utilisateurs vers votre objectif de conversion',
      blockShortText: 'Image, vidéo en vedette',
      height: 'Hauteur',
      heightTooltip: 'Changer la hauteur de la bannière',
      badge: 'Étiquette',
      badgeTooltip: 'La petite ligne imprimée au-dessus du titre dans ce modèle',
      badgePlaceholder: 'Tout juste imprimé',
      templates: {
        classic: 'Classique',
        classicCaption: `La bannière d'origine — le texte flottant au milieu de l'image, dimensionné par le réglage de proportions`,
        coverTop: 'Couverture avec surtitre',
        coverTopCaption: 'Une petite ligne au-dessus du titre, tout centré. Idéal quand la bannière dit qui vous êtes',
        coverTitle: 'Titre seul',
        coverTitleCaption: 'Un mot en grand et espacé, avec une ligne en dessous. Aucun bouton, rien de plus',
        coverLeft: 'Aligné à gauche',
        coverLeftCaption: `Le texte dans le coin bas et deux boutons côte à côte, comme s'ouvre une landing page`,
        coverCenter: 'Boutons centrés',
        coverCenterCaption: 'Tout centré, les boutons empilés en pastilles. Le plus direct des six',
        coverVideo: 'Couverture vidéo',
        coverVideoCaption: 'Pour une bannière qui lit une vidéo — une pastille de statut, le son et un bouton',
        coverBadge: 'Étiquette et CTA',
        coverBadgeCaption: 'Un cadre plus court : une pastille blanche annonçant la nouveauté, un titre et un bouton',
      },
    },
    slider: {
      blockTitle: 'Carrousel',
      blockText: `Carrousel d'images qui vous permet de présenter votre contenu visuel et d'ajouter différentes fonctionnalités`,
      blockShortText: `Carrousel d'images`,
      image: 'Image',
      imageTooltip: 'Image de votre galerie',
      addText: 'Ajouter du texte',
      title: 'Titre',
      titleTooltip: 'Titre de votre diapositive',
      titleSize: 'Taille du titre',
      titleSizeTooltip: 'Choisissez la taille pour une meilleure lisibilité',
      description: 'Description',
      descriptionTooltip: 'Description de votre diapositive',
      textColor: 'Couleur du texte',
      addButton: 'Ajouter un bouton',
      url: 'URL',
      urlTooltip: 'URL de votre image',
      button: 'Bouton',
      buttonTooltip: 'Titre de votre bouton',
      buttonText: 'Texte du bouton',
      buttonColor: 'Couleur du bouton',
      height: 'Hauteur',
      heightTooltip: 'Changer la hauteur des diapositives',
      view: 'Vue',
      viewTooltip: 'Choisissez la vue du carrousel',
      auto: 'Auto',
      square: 'Carré',
      rectangle: 'Rectangle',
      single: 'Simple',
      multi: 'Multiple',
      templates: {
        multi: 'Multiple',
        multiCaption: `La bande de cartes d'origine, la suivante dépassant du bord`,
        single: 'Simple',
        singleCaption: `Le carrousel d'origine, une image à la fois, avec les points en dessous`,
        showcase: 'Vitrine',
        showcaseCaption: `La vitrine d'origine — un grand numéro, un compteur et une bande de vignettes`,
        full: 'Pleine page avec points',
        fullCaption: `Une image d'un bord à l'autre, les points pour seul ornement. Pour les photos sans légende`,
        peek: 'Aperçu de la suivante',
        peekCaption: `La diapositive suivante dépasse du bord : le geste est évident avant même d'essayer`,
        caption: 'Diapositive légendée',
        captionCaption: 'La photo dans une carte, avec le titre et la description de la diapositive en dessous',
        thumbs: 'Avec vignettes',
        thumbsCaption: 'Une bande sous la photo, pour parcourir une longue série sans tout balayer',
        counter: 'Compteur et flèches',
        counterCaption: 'Le compte écrit et deux flèches — pour une série qui mérite un parcours posé',
        auto: 'Barres de lecture auto',
        autoCaption: 'Barres de stories : le carrousel avance seul et dit où il en est',
        compare: 'Avant et après',
        compareCaption: 'Les deux premières diapositives superposées, avec une ligne à faire glisser. Leurs titres servent de libellés',
        video: 'Diapositives vidéo',
        videoCaption: 'Pour des diapositives qui sont des fichiers vidéo — le son que le visiteur active, et le temps écoulé',
        shop: 'Diapositives boutique',
        shopCaption: 'Le titre, la description et le bouton de la diapositive se lisent comme nom, prix et action',
      },
    },
    gallery: {
      blockTitle: 'Galerie',
      blockText: `Carrousel d'images qui vous permet de présenter votre contenu visuel`,
      blockShortText: `Carrousel d'images`,
      image: 'Image',
      imageTooltip: 'Image de votre élément de galerie',
      layout: 'Disposition',
      layoutTooltip: 'Choisissez la disposition de la galerie',
      feed: 'Flux',
      slider: 'Carrousel',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Créez un blog de vos publications',
      blockShortText: 'Créer un blog',
      writeYourStory: 'Écrivez votre histoire',
      shortDescription: 'Description courte',
      shortDescriptionTooltip: 'Description optionnelle pour votre blog',
      description: 'Description',
    },
    map: {
      blockTitle: 'Carte',
      blockText: 'Ajoutez une carte Google pour aider les utilisateurs à trouver votre entreprise locale',
      blockShortText: 'Ajouter une carte Google',
      buttonText: 'Texte du bouton',
      buttonTextTooltip: 'Le bouton apparaît lorsque la deuxième vue est sélectionnée',
      text: 'Texte',
      addAddress: 'Ajouter une autre adresse',
      address: 'Adresse',
      addressTooltip: `Collez l'adresse depuis Google Maps par exemple`,
      googleMap: `Google Maps (code d'intégration)`,
      googleMapTooltip: `Collez le code d'intégration depuis Google Maps`,
      howToFind: `Comment trouver le code d'intégration`,
      incorrectCode: `Code d'intégration incorrect.`,
      moreInfo: `Plus d'informations`,
      code: 'Code',
      addressSettings: `Paramètres d'adresse`,
      addressContent: `Ajoutez l'URL, le titre et le texte du bouton ou l'icône`,
      title: 'Titre',
      titleTooltip: 'Le nom de votre adresse',
      url: 'URL',
      urlTooltip: `Collez l'URL de l'adresse depuis Google Maps par exemple`,
      directionText: 'Texte de direction',
      directionTextTooltip: `Texte d'appel à l'action pour vos utilisateurs`,
    },
    footer: {
      templates: {
        minimal: 'Minimal',
        minimalCaption: 'La marque, la rangée sociale et la ligne légale. Termine la page sans second menu',
        columns: 'Deux colonnes de liens',
        columnsCaption: 'Liens groupés sous des intitulés, sur deux colonnes. Pour quelques sections',
        accordion: 'Menu accordéon',
        accordionCaption: 'Groupes repliables sur panneau sombre. Pour plus de sections qu’une liste plate',
        subscribe: 'Pied avec inscription',
        subscribeCaption: 'Un champ e-mail au-dessus des puces de navigation. Pour collecter des adresses',
        contacts: 'Pied de contact',
        contactsCaption: 'Téléphone, e-mail et adresse en lignes tapables, messageries en dessous',
        shop: 'Grand pied de boutique',
        shopCaption: 'Promesse de livraison, colonnes de liens, badges d’app et moyens de paiement',
        cta: 'Appel à l’action',
        ctaCaption: 'Panneau plein avec titre et deux actions. La conclusion de la page',
        sticky: 'Pied avec barre d’actions',
        stickyCaption: 'Un pied classique et dessous l’appel, le chat et le bouton principal',
        locale: 'Langue et devise',
        localeCaption: 'Langue, devise et pays de livraison au-dessus des liens d’aide de la boutique',
      },
      defaults: {
        groups: [
          { title: 'Services', links: ['Design', 'Développement', 'Branding'] },
          { title: 'Société', links: ['À propos', 'Cas', 'Emplois'] },
        ],
        subscribeTitle: 'Une lettre par mois',
        subscribeText: 'Cas, processus et un peu de coulisses. Sans spam.',
        subscribeButton: 'S’abonner',
        ctaTitle: 'Parlez-nous de votre projet',
        ctaText: 'Nous répondons sous une heure les jours ouvrés.',
        ctaButton: 'Écrivez-nous',
        languages: [
          { code: 'fr', label: 'Fr' },
          { code: 'en', label: 'Eng' },
          { code: 'pl', label: 'Pl' },
        ],
        currency: '€ Euro',
        country: 'France',
        contacts: [
          { icon: 'phone', value: '+33 1 23 45 67 89' },
          { icon: 'mail', value: 'hi@studio.fr' },
          { icon: 'pin', value: '22 rue Khoryva, Kyiv' },
        ],
      },
      blockTitle: 'Pied de page',
      blockText: `Section de contenu en bas de page. Vous pouvez ajouter des coordonnées, des icônes de réseaux sociaux et un formulaire d'inscription par e-mail`,
      blockShortText: 'Section de contenu en bas',
      addBlock: 'Ajouter un bloc',
      blockType: 'Type de bloc',
      blockTypeTooltip: 'Choisissez le type de bloc',
      addBlockTitle: 'Titre du bloc',
      addBlockTitleTooltip: 'Choisissez le titre du bloc',
      faq: 'FAQ',
      'data-collect': 'Collecte de données',
      contact: 'Contact',
      pages: 'Pages',
      payments: 'Paiements',
      social: 'Social',
      cancel: 'Annuler',
      add: 'Ajouter',
      None: 'Aucun',
      link: 'lien',
      faqText: 'Vous pouvez modifier les questions fréquemment posées dans le bloc FAQ. Vous pouvez y accéder en cliquant sur ce',
      socialText: 'Vous pouvez modifier les icônes sociales dans le bloc En-tête. Vous pouvez y accéder en cliquant sur ce',
      dataCollectText: 'Vous pouvez modifier la collecte de données dans le bloc Collecte de données. Vous pouvez y accéder en cliquant sur ce',
      contactText: 'Vous pouvez modifier le contact dans le bloc Contact. Vous pouvez y accéder en cliquant sur ce',
      pagesText: 'Vous pouvez ajouter de nouvelles pages sur le site web',
      paymentsText: 'Les méthodes de paiement seront affichées',
      showOnAllpages: 'Afficher sur toutes les pages',
      footerText: `Le pied de page de la page d'accueil est actuellement activé.`,
      editSocialIcons: 'Vous pouvez modifier les icônes sociales dans la section En-tête. Vous pouvez y accéder en cliquant sur ce',
      editSubscribe: `Vous pouvez modifier l'abonnement dans la section Abonnement. Vous pouvez y accéder en cliquant sur ce`,
      editContacts: 'Vous pouvez modifier les contacts dans la section Contacts. Vous pouvez y accéder en cliquant sur ce',
      editFrequently: 'Vous pouvez modifier les questions fréquemment posées dans la section FAQ. Vous pouvez y accéder en cliquant sur ce',
      text: 'Texte',
      image: 'Image',
      divider: 'Séparateur',
      linkViewLabel: 'Disposition',
      linkViewTooltip: 'Comment les liens sont disposés',
      linkViewSingle: 'Empilés',
      linkViewRow: 'En rangée',
      linkItemsLabel: 'Liens',
      linkItemsTooltip: `Ajoutez jusqu'à 5 liens (p. ex. Politique de confidentialité, Conditions)`,
      linkLabelPlaceholder: 'Libellé',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Ajouter un lien',
      alignLabel: 'Alignement',
      alignTooltip: 'Alignement horizontal',
      alignLeft: 'Gauche',
      alignCenter: 'Centre',
      alignRight: 'Droite',
      imageLabel: 'Image',
      imageTooltip: 'Importez un logo ou une image',
      imageLinkLabel: 'Lien (facultatif)',
      imageLinkTooltip: `Rendez l'image cliquable`,
      dividerLabel: 'Type de séparateur',
      dividerTooltip: 'Une ligne ou un espace vide',
      dividerLine: 'Ligne',
      dividerSpace: 'Espace',
      picker: {
        subtitle: 'Choisissez un élément à ajouter à votre pied de page',
        configureSubtitle: 'Configurez-le et ajoutez-le à votre pied de page',
        back: 'Retour',
        saveButton: 'Enregistrer',
        availableTitle: 'Disponible à ajouter',
        addedTitle: 'Déjà ajouté',
        addedLabel: 'Ajouté',
        addButton: 'Ajouter le bloc',
        linkTitle: 'Liens',
        linkSub: `Boutons vers n'importe quelle URL`,
        socialTitle: 'Réseaux sociaux',
        socialSub: 'Icônes de vos profils sociaux',
        textTitle: 'Texte',
        textSub: 'Un titre ou un paragraphe',
        pagesTitle: 'Pages',
        pagesSub: 'Lien vers des sous-pages imbriquées',
        paymentsTitle: 'Paiements',
        paymentsSub: 'Modes de paiement acceptés',
        imageTitle: 'Image',
        imageSub: 'Un logo ou une image',
        dividerTitle: 'Séparateur',
        dividerSub: 'Une ligne ou un espacement',
        faqTitle: 'FAQ',
        faqSub: 'Questions fréquentes',
        dataCollectTitle: 'Collecte de données',
        dataCollectSub: `Formulaire d'inscription par e-mail`,
        contactTitle: 'Contact',
        contactSub: 'Coordonnées',
        importMode: 'Importer depuis un bloc',
        manualMode: 'Ajouter manuellement',
        noContactsToImport: 'Aucun contact à importer — ajoutez-les manuellement.',
        noSocialsToImport: 'Aucune icône sociale à importer — ajoutez-les manuellement.',
        manualItemsLabel: 'Éléments',
        manualItemsTooltip: 'Choisissez un type et saisissez sa valeur.',
        contactValuePlaceholder: '@identifiant / e-mail / téléphone',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Ajouter',
      },
      contactDesign: {
        editSource: 'Modifiez les contacts eux-mêmes dans le bloc Contact —',
        variantLabel: 'Style',
        variantList: 'Liste',
        variantButton: 'Bouton',
        shapeLabel: 'Forme',
        shape_square: 'Carrée',
        shape_rounded: 'Arrondie',
        shape_pill: 'Pilule',
        widthLabel: 'Largeur',
        widthFull: 'Pleine',
        widthHalf: 'Moitié',
        widthHalfStacked: 'Demi-colonne',
        borderLabel: 'Bordure',
        borderOn: 'Activée',
        borderOff: 'Désactivée',
        borderColorLabel: 'Couleur de la bordure',
      },
      layout: 'Disposition',
      splitImage: 'Image latérale',
    },
    'chat-ai': {
      blockTitle: 'Chat en direct',
      blockShortText: `Discuter avec l'IA`,
      blockText: `Discuter avec l'IA`,
      suggestionsTitle: 'Suggestions',
      suggestionsSubtitle: 'Invites rapides',
    },
    custom: {
      blockTitle: 'Personnalisé',
      blockShortText: `Micro-application propulsée par l'IA`,
      blockText: `Décrivez une mini-application interactive et l'IA la générera pour vous`,
    },
    shop: {
      blockTitle: 'Boutique',
      blockText: 'Ajoutez votre liste de produits',
      blockShortText: 'Ajoutez vos produits',
      view: 'Vue',
      products: 'Produits',
      categories: 'Catégories',
      cardLayout: 'Disposition des cartes',
      cardLayoutTooltip: 'La vitrine affiche chaque produit sous forme de carte de vente détaillée, une par rangée',
      standardCards: 'Standard',
      showcaseCards: 'Vitrine',
      featured: 'À la une',
      shoppingCart: 'Panier',
      shoppingCartNote: 'Le bouton du panier apparaît dès qu’un visiteur ajoute un produit',
      cartIconDisabledHint: 'Activez le panier pour utiliser cette option',
    },
    digital: {
      blockTitle: 'Produits numériques',
      blockText: 'Vendez un téléchargement numérique : PDF, tableurs, modèles, exclusivités',
      blockShortText: 'Vendre du numérique',
    },
    podcast: {
      templates: {
        latest: 'Dernier épisode',
        latestCaption: 'Le plus récent et un bouton pour le lancer',
        player: 'Lecteur',
        playerCaption: 'Barre de lecture, −15, +30 et vitesse',
        list: 'Liste des épisodes',
        listCaption: 'Lecture, numéro, titre, durée — le fil simple',
        resume: 'Reprendre l’écoute',
        resumeCaption: 'Où ce visiteur s’est arrêté, gardé dans son navigateur',
        bestOf: 'Le meilleur',
        bestOfCaption: 'Trois épisodes pour commencer, dans votre ordre',
        cover: 'Pochette de l’émission',
        coverCaption: 'La pochette, le sujet et les applis où elle est',
        subscribe: 'Ligne d’abonnement',
        subscribeCaption: 'Une ligne et les annuaires — ni pochette ni épisodes',
        trailer: 'Bande-annonce',
        trailerCaption: 'La réponse en deux minutes à « est-ce pour moi ? »',
        guest: 'Épisode avec invité',
        guestCaption: 'Un entretien vendu par la personne qui y parle',
        guests: 'Les invités',
        guestsCaption: 'Les visages passés dans l’émission, en grille',
        hosts: 'Les animateurs',
        hostsCaption: 'Qui fait l’émission, d’après l’auteur des épisodes',
        chapters: 'Chapitres et notes',
        chaptersCaption: 'Lignes horodatées ; un appui déplace la lecture',
        transcript: 'Transcription',
        transcriptCaption: 'L’épisode par écrit, chaque ligne déplace la lecture',
        clip: 'Extrait à partager',
        clipCaption: 'Une phrase en grand et un bouton de partage',
        video: 'Podcast vidéo',
        videoCaption: 'L’image, et le choix entre regarder et écouter',
        seasons: 'Saisons',
        seasonsCaption: 'Vos émissions en pastilles, leurs épisodes en dessous',
        topics: 'Filtre par thème',
        topicsCaption: 'Les épisodes selon la catégorie de leur émission',
        showCards: 'Cartes d’émission',
        showCardsCaption: 'Chaque émission en carte, défilement latéral',
        ask: 'Question d’auditeur',
        askCaption: 'Une invitation, un exemple et où vont les réponses',
        ratings: 'Notes et avis',
        ratingsCaption: 'Votre note et un avis qui mérite d’être cité',
        support: 'Soutenir l’émission',
        supportCaption: 'Ce que reçoivent les soutiens et où s’inscrire',
        classic: 'Listen Now',
        classicCaption: 'Le bloc d’origine — le fil avec l’onglet Émissions',
        showcase: 'Vitrine',
        showcaseCaption: 'La vue éditoriale : une grande carte et un rail de pochettes',
      },
      copy: {
        askTitle: 'Question d’auditeur',
        askHint: 'L’invitation, un exemple de question et où vont les réponses : un formulaire, une adresse, une boîte vocale.',
        ratingTitle: 'Notes et avis',
        ratingHint: 'Votre note et un avis à citer. Le bloc affiche ce que vous écrivez — il ne va pas le chercher chez Apple ou Spotify.',
        supportTitle: 'Soutenir l’émission',
        supportHint: 'Ce que reçoivent les soutiens et où s’inscrire. Le bouton mène là où vous encaissez déjà.',
        title: 'Titre',
        text: 'Texte',
        question: 'Exemple de question',
        url: 'Lien du bouton',
        buttonText: 'Texte du bouton',
        voiceUrl: 'Lien vocal',
        value: 'Note',
        count: 'Provenance',
        quote: 'Avis',
        author: 'Qui l’a dit',
        tiers: 'Paliers',
        tierName: 'Nom',
        tierPerk: 'Ce que ça donne',
        tierPrice: 'Prix',
        addTier: '+ Ajouter un palier',
        removeTier: 'Supprimer le palier',
      },
      blockTitle: 'Podcasts',
      blockText: 'Promouvez vos podcasts',
      blockShortText: 'Promouvez vos podcasts',
    },
    'page-list': {
      blockTitle: 'Liste de pages',
      blockText: 'Créez votre liste de pages',
      blockShortText: 'Créez votre liste de pages',
      description: 'Description',
      addNewPageItem: 'Ajouter un lien de page',
    },
    appointment: {
      blockTitle: 'Rendez-vous',
      blockText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
      blockShortText: 'Permettez aux visiteurs de réserver',
    },
    service: {
      modal: {
        title: 'Ajouter un nouveau service',
        subtitle: "Saisissez l'essentiel — ajoutez le reste sur la page du service",
        thumbnail: 'Miniature (facultatif)',
        thumbnailTooltip: 'Téléchargez une photo de couverture',
        label: 'Étiquette (facultatif)',
        labelTooltip: 'Mettez ce service en avant avec un badge',
        titleField: 'Titre',
        titleTooltip: 'Ajoutez un titre pour votre service',
        titlePlaceholder: 'ex. Séance photo en famille — 1 heure',
        cancel: 'Annuler',
        submit: 'Ajouter',
      },
      blockTitle: 'Services',
      blockText: `Vous recevrez une notification par e-mail lorsqu'une demande vous sera soumise`,
      blockShortText: 'Recevoir un e-mail',
    },
    requests: {
      blockTitle: 'Services',
      blockText: `Vous recevrez une notification par e-mail lorsqu'une demande vous sera soumise`,
      blockShortText: 'Recevoir un e-mail',
    },
    tips: {
      blockTitle: 'Pourboires',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    tip: {
      blockTitle: 'Pourboires',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    donation: {
      blockTitle: 'Dons',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    course: {
      blockTitle: 'Cours ou tutoriel',
      blockText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
      blockShortText: 'Permettez aux visiteurs de réserver',
    },
    event: {
      blockTitle: 'Événements ou billets',
      blockText: 'Permettez à votre audience de participer à vos événements',
      blockShortText: `Permettez à l'audience de participer`,
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Créez un menu unique avec des prix',
      blockShortText: 'Créer un menu unique',
    },
    recipe: {
      blockTitle: 'Recette',
      blockText: 'Partagez une recette avec ingrédients, étapes et photos',
      blockShortText: 'Partager une recette',
    },
    booking: {
      blockTitle: 'Réservation',
      blockText: 'Permettez aux visiteurs de réserver vos espaces',
      blockShortText: 'Permettez aux visiteurs de réserver',
      name: 'Nom',
      nameCaption: `Entrez le nom de l'espace`,
      description: 'Description',
      descriptionCaption: 'Courte description de cet espace',
      rentalType: 'Type de location',
      rentalTypeCaption: 'Par exemple : appartement, voiture, bureau',
      duration: 'Durée',
      durationCaption: 'Par exemple : par jour, par semaine, par mois',
      price: 'Prix',
      priceCaption: 'Prix de base pour cet espace',
      oldPrice: 'Ancien prix',
      oldPriceCaption: 'Ancien prix optionnel',
      rating: 'Note',
      ratingCaption: 'Note moyenne (optionnel)',
      label: 'Étiquette',
      labelCaption: 'Court badge comme HOT ou NOUVEAU',
      image: 'Image',
      imageCaption: 'Téléversez une image de couverture pour cet espace',
      location: 'Localisation',
      locationCaption: 'Ville, quartier ou adresse',
      capacity: 'Capacité (invités)',
      capacityCaption: `Nombre maximum d'invités`,
      rooms: 'Chambres et surface',
      roomsCaption: 'Chambres, salles de bain et surface',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      areaSqM: 'Surface (m²)',
      minStay: 'Séjour minimum (jours)',
      minStayCaption: 'Nombre minimum de jours pour la réservation',
      requiresDeposit: 'Acompte requis',
      depositAmount: `Montant de l'acompte`,
      depositAmountCaption: 'Acompte initial pour confirmer la réservation',
      noSmoking: 'Non-fumeur',
      noPets: `Pas d'animaux`,
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Parking',
      amenitiesKitchen: 'Cuisine',
      amenitiesHeating: 'Chauffage',
      amenitiesAC: 'Climatisation',
      amenitiesPool: 'Piscine',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Toilettes',
      validationNameRequired: 'Le nom est obligatoire',
      validationPriceRequired: 'Le prix doit être un nombre positif ou nul',
      validationDepositRequired: `Le montant de l'acompte est obligatoire lorsque l'acompte est activé`,
      validationCapacityNumber: 'La capacité doit être un nombre positif ou nul',
      validationOldPriceNumber: `L'ancien prix doit être un nombre positif ou nul`,
      brand: 'Marque',
      brandCaption: 'Marque de voiture, ex. Tesla',
      model: 'Modèle',
      modelCaption: 'Modèle de voiture, ex. Model 3',
      year: 'Année',
      yearCaption: 'Année de fabrication',
      color: 'Couleur',
      colorCaption: 'Couleur extérieure, ex. noir',
      fuelType: 'Type de carburant',
      fuelTypeCaption: 'Essence, diesel, électrique, hybride, etc.',
      transmission: 'Transmission',
      transmissionCaption: 'Automatique ou manuelle',
      seatCount: 'Nombre de sièges',
      seatCountCaption: 'Nombre de sièges dans la voiture',
      edit: `Modifier l'élément`,
      add: 'Ajouter un élément',
    },
    membership: {
      blockTitle: 'Adhésion',
      blockText: 'Créez un abonnement gratuit ou payant à votre contenu',
      blockShortText: 'Créer un abonnement',
    },
    pricing: {
      blockTitle: 'Tarification',
      blockText: 'Créez un menu unique avec des prix',
      blockShortText: 'Créer un menu unique',
      name: 'Nom',
      nameTooltip: 'Entrez le nom de votre produit',
      pricingPlanName: 'Nom du plan tarifaire',
      pricingPlanNameTooltip: 'Entrez le nom de votre plan tarifaire',
      description: 'Description',
      descriptionTooltip: 'Entrez la description de votre produit',
      pricingPlanDescriptionTooltip: 'Entrez la description de votre plan tarifaire',
      priceValue: 'Valeur du prix',
      priceUnit: 'Unité de prix',
      label: 'Étiquette',
      labelTooltip: `Entrez l'étiquette de votre plan tarifaire`,
      orderButtonText: 'Texte du bouton de commande',
      orderButtonTextDescriptionTooltip: 'Entrez le texte du bouton de commande de votre plan tarifaire',
      orderButtonLink: 'Lien du bouton de commande',
      orderButtonLinkDescriptionTooltip: 'Entrez le lien du bouton de commande de votre plan tarifaire',
      subtitle: 'Sous-titre',
      subtitleTooltip: 'Entrez le sous-titre de votre produit',
      price: 'Prix',
      priceTooltip: 'Entrez le prix de votre produit',
      pricingTiers: 'Niveaux de tarification',
      pricingTiersTooltip: 'Entrez les niveaux de tarification de votre produit',
      addPriceValue: 'Ajouter un autre prix',
      group: 'Groupe',
      groupTooltip: 'Choisissez le groupe de votre produit',
      image: 'Image',
      imageTooltip: 'Téléversez une image pour votre produit',
      unit: 'Unité de prix',
      unitTooltip: `Entrez l'unité de votre prix`,
      addUnitTitle: 'Unités de prix',
      addPriceUnitValue: 'Ajouter une autre unité de prix',
      addUnitButtonText: 'Enregistrer',
      button: 'Bouton',
      buttonTooltip: 'Ajoutez un bouton pour votre produit',
      buttonAddText: '+ Ajouter un bouton',
      buttonModalTextField: 'Texte du bouton',
      buttonModalTextFieldTooltip: 'Entrez le texte du bouton',
      buttonModalURLField: 'URL du bouton',
      buttonModalURLFieldTooltip: `Entrez l'URL du bouton`,
      buttonModalTitle: 'Ajouter un bouton',
      groups: {
        title: 'Groupes',
        subtitle: 'Ajouter, modifier et supprimer des groupes',
        groups: 'Groupes',
        groupsTooltip: 'Ajouter, modifier et supprimer des groupes',
        addNewGroup: 'Ajouter un nouveau groupe',
        newGroup: 'Nouveau groupe',
        titleGroup: 'Titre',
        titleGroupTooltip: 'Entrez le titre de votre groupe',
        descriptionGroup: 'Description',
        descriptionGroupTooltip: 'Entrez la description de votre groupe',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Créez un menu avec des éléments et des prix',
      add: 'Ajouter un nouvel élément',
      edit: `Modifier l'élément`,
      name: 'Nom',
      nameCaption: `Entrez le nom de l'élément`,
      description: 'Description',
      descriptionCaption: 'Entrez une courte description',
      ingredients: 'Ingrédients',
      ingredientsCaption: 'Listez les ingrédients ou la composition',
      price: 'Prix',
      priceCaption: 'Entrez le prix',
      weight: 'Poids (g)',
      weightCaption: 'Entrez le poids en grammes',
      calories: 'Calories (kcal)',
      caloriesCaption: 'Entrez les calories en kcal',
      label: 'Étiquette',
      labelCaption: `Entrez le texte de l'étiquette`,
      labelColor: `Couleur de l'étiquette`,
      labelColorCaption: `Choisissez une couleur d'arrière-plan pour l'étiquette`,
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre élément',
      available: 'Disponible à la commande',
      visible: 'Visible sur la page',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Affichez un NFT depuis la plateforme OpenSea',
      blockShortText: 'Afficher un NFT',
    },
    wallet: {
      wallet: 'Portefeuille',
      blockTitle: 'Portefeuille bancaire/crypto',
      blockText: 'Affichez votre carte bancaire ou portefeuille Bitcoin pour faciliter la copie et le transfert de fonds par vos utilisateurs',
      blockShortText: 'Affichez vos portefeuilles',
      title: 'Titre',
      titleTooltip: 'Titre de votre portefeuille',
      walletNumber: 'Numéro de portefeuille',
      walletNumberTooltip: 'Collez votre numéro de portefeuille',
      icon: 'Icône',
      iconTooltip: `Définissez l'icône pour votre portefeuille`,
      card: 'Carte',
      bank: 'Banque',
      crypto: 'Crypto',
      transfer: 'Transfert',
      paymentLink: 'Lien de paiement',
      cardNumber: 'Numéro de carte',
      cardNumberTooltip: 'Collez votre numéro de carte',
      cardHolder: 'Titulaire de la carte',
      cardHolderTooltip: 'Entrez le titulaire de la carte',
      bankAccountDetails: 'Coordonnées bancaires',
      bankAccountDetailsTooltip: 'Entrez vos coordonnées bancaires',
      walletAddress: 'Adresse du portefeuille',
      walletAddressTooltip: `Entrez l'adresse de votre portefeuille`,
      network: 'Réseau',
      networkTooltip: 'Entrez votre réseau',
      publicKey: 'Clé publique',
      publicKeyTooltip: 'Entrez votre clé publique',
      providerName: 'Nom du fournisseur',
      providerNameTooltip: 'Entrez le nom de votre fournisseur',
      link: 'Lien',
      linkTooltip: 'Entrez votre lien',
      serviceName: 'Nom du service',
      serviceNameTooltip: 'Entrez le nom de votre service',
      email: 'E-mail',
      emailTooltip: 'Entrez votre e-mail',
      phone: 'Téléphone',
      phoneTooltip: 'Entrez votre téléphone',
      username: `Nom d'utilisateur`,
      usernameTooltip: `Entrez votre nom d'utilisateur`,
      fullName: 'Nom complet',
      fullNameTooltip: 'Entrez votre nom complet',
      referenceNumber: 'Numéro de référence',
      referenceNumberTooltip: 'Entrez votre numéro de référence',
      country: 'Pays',
      countryTooltip: 'Entrez votre pays',
      transferProvider: 'Fournisseur de transfert',
      transferProviderTooltip: 'Entrez votre fournisseur de transfert',
      cryptoCurrency: 'Crypto-monnaie',
      cryptoCurrencyTooltip: 'Entrez votre crypto-monnaie',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Présentez vos meilleurs médias et vidéos Instagram ou vendez vos produits avec un flux Instagram achetable',
      blockShortText: 'Vos meilleurs médias Instagram',
      blockConnectTitle: `Instagram n'est pas connecté`,
      blockConnectText: 'Il semble que vos produits Instagram ne soient pas encore importés. Connectez votre compte maintenant',
      blockConnectButton: 'Ajouter Instagram',
      emptyList: `Vous n'avez pas encore de médias Instagram.`,
      addInstagramUsername: `Ajouter le nom d'utilisateur Instagram`,
      username: `Nom d'utilisateur`,
      downloadTakes: `Le téléchargement prend jusqu'à 2 minutes`,
      displayPost: 'Afficher la publication sur votre site web',
      view: 'Vue',
      redirect: 'Redirection URL',
      text: 'Texte et bouton',
      actionType: `Type d'action`,
      url: 'URL',
      openInNewTab: 'Ouvrir dans un nouvel onglet',
      delete: 'Supprimer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      editMedia: 'Modifier le média',
      title: 'Titre',
      automation: 'Automatisation',
      automationText: 'Automatisez votre compte avec les fonctionnalités Autopilote',
      autopilot: 'Autopilote',
      autopilotTooltip: 'Téléversez une publication avec la légende modèle et vos tags produits/liens seront automatiquement générés',
      switchTitle: 'Détecter automatiquement le titre, le prix, les liens',
      sampleCaption: 'Légende modèle : #49.99 #BelleRobe https://google.com',
      integrations: 'Intégrations',
      integrationsText: 'Ajoutez Instagram à votre site web',
      connectInstagram: 'Connecter Instagram',
      connectInstagramText: 'Connectez votre compte Instagram pour afficher vos publications ou reels au choix.',
      selectAccount: 'Sélectionner un compte',
      connectNewInstagram: 'Connecter un nouveau compte Instagram',
      continue: 'Continuer',
      disconnectInstagram: 'Déconnecter Instagram',
      addTag: 'Ajouter une étiquette',
      tagClickHint: `Cliquez sur l'image pour placer l'étiquette`,
      tagPositionSet: 'Position défini. Remplissez les détails ci-dessous.',
      tagTypeLink: 'Lien',
      tagTypeProduct: 'Produit',
      tagLabel: 'Étiquette',
      tagSelectProduct: 'Sélectionner un produit',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Présentez votre meilleure vidéo TikTok ou vendez vos produits avec un flux TikTok achetable',
      blockShortText: 'Votre meilleure vidéo TikTok',
      addTikTok: 'Ajouter un compte TikTok',
      individualVideo: 'Vidéo individuelle',
      videoCollection: 'Collection de vidéos',
      add: 'Ajouter',
      blockConnectTitle: `TikTok n'est pas connecté`,
      blockConnectText: 'Il semble que vos produits TikTok ne soient pas encore importés. Connectez votre compte maintenant',
      blockConnectButton: 'Connecter TikTok',
      enterUsername: `Entrez le nom d'utilisateur`,
      enterVideo: `Entrez l'URL d'une vidéo TikTok`,
      emptyList: `Vous n'avez pas encore de médias TikTok.`,
      editMedia: 'Modifier le média',
      addTikTokVideo: 'Ajouter une vidéo TikTok',
      displayPost: 'Afficher la publication sur votre site web',
      delete: 'Supprimer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      integrations: 'Intégrations',
      integrationsText: 'Ajoutez TikTok à votre site web',
      connectTikTok: 'Connecter TikTok',
      disconnectTikTok: 'Déconnecter TikTok',
      individualText: `Vous ne pouvez pas connecter un compte TikTok à ce type de bloc ('individuel').`,
      individualText2: 'Veuillez ajouter une vidéo TikTok unique à la place.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Présentez une vidéo YouTube ou un stream sur votre page. Taguez des produits sur la vidéo YouTube',
      blockShortText: 'Présentez une vidéo YouTube',
      enterYouTubeLink: `Entrez l'URL YouTube`,
      enterYouTubeLinkTooltip: `Collez l'URL YouTube`,
    },
    overview: {
      blockTitle: `Vue d'ensemble`,
      blockText: 'Présentez une vidéo ou un stream sur votre page. Taguez des produits sur la vidéo',
      blockShortText: 'Taguer des produits sur la vidéo',
    },
    video: {
      blockTitle: 'Vidéo',
      blockText: 'Présentez une vidéo ou un stream sur votre page',
      blockShortText: 'Présentez une vidéo',
    },
    short: {
      blockTitle: 'Shorts / Reels',
      blockText: 'Ajoutez des vidéos verticales courtes — Shorts, Reels, TikToks',
      blockShortText: 'Vidéos verticales',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: `Affichez vos Tweets sur votre page UniLink pour augmenter l'engagement`,
      blockShortText: 'Affichez vos Tweets',
      twitterURL: 'URL Twitter',
      twitterURLTooltip: `Ajoutez l'URL depuis Twitter pour générer le code d'intégration`,
      enterTwitterURL: 'Entrez une URL Twitter',
    },
    music: {
      templates: {
        nowPlaying: 'Lecteur',
        nowPlayingCaption: 'Une carte sombre avec la pochette, une barre de progression et les commandes — elle parcourt les titres du bloc',
        compact: 'Lecteur compact',
        compactCaption: 'Le même lecteur trois fois moins haut, pour un titre qui n’est pas l’essentiel',
        tracklist: 'Liste des titres',
        tracklistCaption: 'Des lignes numérotées avec la durée et un bouton lecture, comme au dos d’un disque',
        queue: 'File d’attente',
        queueCaption: 'Ce qui joue, puis ce qui suit : un petit lecteur d’album avec sa file',
        featured: 'Titre à la une',
        featuredCaption: 'La pochette en grand, le titre par-dessus et un bouton lecture',
        waveform: 'Forme d’onde',
        waveformCaption: 'Un enregistrement dessiné en onde qui se remplit à la lecture — pour une démo ou un mix',
        mix: 'Mix DJ',
        mixCaption: 'Une photo pleine carte, la durée du set et sa tracklist derrière un bouton',
        release: 'Sortie avec liens',
        releaseCaption: 'La pochette, le titre et une ligne par service de streaming — la carte smart-link',
        streaming: 'Liens de streaming',
        streamingCaption: 'Uniquement les services, sans pochette : envoie le visiteur sur la plateforme qu’il utilise',
        presave: 'Pré-enregistrement',
        presaveCaption: 'Un disque pas encore sorti, et les boutons qui l’ajoutent à la bibliothèque le jour J',
        shelf: 'Étagère d’albums',
        shelfCaption: 'Chaque sortie en pochette, défilement latéral. Un tap ouvre ses liens',
        playlistCard: 'Carte de playlist',
        playlistCardCaption: 'Une mosaïque du contenu de la playlist, sa durée et un bouton pour l’écouter',
        record: 'Acheter le disque',
        recordCaption: 'La pochette, le prix et deux boutons — acheter, ou écouter d’abord',
        classic: 'Onglets',
        classicCaption: 'Le bloc d’origine : Titres, Playlists et Sorties en onglets avec les cartes habituelles',
        showcase: 'Vitrine',
        showcaseCaption: 'La vue éditoriale — de grandes cartes de sorties et un rail avec le reste en dessous',
      },
      blockTitle: 'Musique',
      blockText: 'Intégrez une chanson Spotify, SoundCloud, une playlist ou téléversez votre propre fichier audio',
      blockShortText: 'Ajoutez votre musique',
      brand: 'Marque',
      brandTooltip: 'Choisissez le type pour ajouter votre musique',
      url: 'URL',
      embed: `Code d'intégration`,
      custom: 'Personnalisé',
      musicUrl: 'URL de la musique',
      musicUrlTooltip: `Entrez l'URL de la musique`,
      embedCodeTitle: `Code d'intégration`,
      embedCodeTooltip: `Collez le code d'intégration de votre chanson depuis la plateforme musicale choisie`,
      audioFile: 'Fichier audio',
      uploadAudios: 'Vous ne pouvez téléverser que des fichiers audio ici',
      title: 'Titre',
      titleTooltip: 'Entrez le titre de votre musique',
      artist: 'Artiste',
      artistTooltip: `Entrez l'artiste de votre musique`,
      audioFileTitle: 'Fichier audio',
      audioFileTooltip: 'Nom de votre fichier audio',
      coverImage: 'Image de couverture',
      coverImageTooltip: 'Téléversez une image pour votre musique',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Intégrez une vidéo ou un stream Twitch sur votre page',
      blockShortText: 'Intégrer une vidéo Twitch',
      twitchURL: 'URL Twitch',
      twitchURLTooltip: `Collez l'URL de la chaîne ou le nom de la chaîne`,
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Afficher ma chaîne Twitch',
      displayChat: 'Afficher ma chaîne Twitch et le chat',
    },
    splash: {
      blockTitle: 'Pop-up',
      blockText: 'Bannière plein écran avec texte et bouton qui apparaît avant le chargement du site pour promouvoir un produit ou événement',
      blockShortText: 'Bannière plein écran',
    },
    pageList: {
      templates: {
        classic: 'Liste simple',
        classicCaption: 'Le bloc d’origine : une page par ligne avec une flèche. Bien jusqu’à cinq pages',
        described: 'Liste avec descriptions',
        describedCaption: 'Lignes numérotées, chaque page avec une ligne d’explication',
        icons: 'Grille d’icônes',
        iconsCaption: 'Deux colonnes avec l’icône au-dessus du nom. Bien à partir de six pages',
        covers: 'Cartes avec visuel',
        coversCaption: 'Une image à côté de chaque page, pour les sections à montrer',
        groups: 'Sections groupées',
        groupsCaption: 'Un plan du site : les pages sous les libellés de groupe que vous définissez',
        headline: 'Grandes lignes',
        headlineCaption: 'Lignes surdimensionnées sur un panneau plein, pour quatre ou cinq destinations',
        tiles: 'Tuiles photo',
        tilesCaption: 'Tuiles photo par deux ; la dernière seule prend toute la largeur',
        tags: 'Étiquettes',
        tagsCaption: 'Chaque page en pastille. Le choix compact à partir de dix pages',
        prevNext: 'Précédente et suivante',
        prevNextCaption: 'Les deux pages voisines, pour le pied d’une page longue',
      },
    },
    promo: {
      blockTitle: 'Barre promotionnelle',
      blockText: `Mise en avant qui vous permet d'afficher des promotions`,
      blockShortText: 'Mettez en avant vos promotions',
    },
    welcome: {
      blockTitle: 'Message de bienvenue',
      blockText: `Rédigez des messages de bienvenue qui incitent les visiteurs à commencer une conversation. Il apparaît en bas de page pour accueillir les visiteurs et offrir de l'aide`,
      blockShortText: 'Rédigez des messages de bienvenue',
    },
    review: {
      blockTitle: 'Avis',
      blockText: `Les avis aident les clients à en savoir plus sur le produit et à décider s'il leur convient`,
      blockShortText: 'Les avis aident les clients',
      name: 'Nom',
      nameTooltip: `Entrez le nom de l'évaluateur`,
      comment: 'Commentaire',
      commentTooltip: `Entrez le commentaire de l'évaluateur`,
      date: 'Date',
      dateTooltip: `Entrez la date de l'évaluation`,
      rate: 'Note',
      rateTooltip: `Définissez la note de l'avis`,
      image: 'Image',
      imageTooltip: `Téléversez l'image de l'évaluateur`,
    },
    coupon: {
      blockTitle: 'Coupons',
      blockText: 'Un coupon en ligne fait référence à un code de réduction ou un numéro qui peut être utilisé sur un site web',
      blockShortText: 'Coupon en ligne',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText: `Un minuteur est une horloge virtuelle sur une page qui compte à rebours à partir d'un certain nombre ou d'une date pour indiquer le début ou la fin d'un événement ou d'une offre`,
      blockShortText: 'Un minuteur',
    },
    outfit: {
      blockTitle: 'Tenues',
      blockText: 'Créez votre propre liste de produits',
      blockShortText: 'Créer une liste de produits',
    },
    spacer: {
      blockTitle: 'Espacement',
      blockText: 'Ajoutez un espace vertical vide à votre page',
      blockShortText: 'Ajouter un espace vide',
    },
    html: {
      blockTitle: 'Embed',
      blockText:
        'Vous pouvez coller votre propre code HTML sur la page UniLink. HTML est un langage de balisage standard pour la création de pages web. Il prend en charge les iframes, sections, paragraphes et liens.',
      blockShortText: 'Collez votre propre HTML',
      markupCode: 'Code de balisage',
      markupCodeTooltip: 'Collez le code de balisage de votre HTML',
      strippedWarning: `Supprimé pour des raisons de sécurité lors de l'affichage :`,
    },
    unlock: {
      blockTitle: 'Déverrouiller',
      blockText: 'Vous pouvez ajouter votre contenu à déverrouiller sur la page UniLink.',
      blockShortText: 'Collez votre fichier déverrouillable',
    },
    file: {
      blockTitle: 'Fichier',
      blockText:
        'Ce bloc vous permet de téléverser et de partager des fichiers tels que des documents, images ou audio. Les visiteurs peuvent facilement les consulter ou les télécharger directement depuis votre page.',
      blockShortText: 'Téléversez et partagez vos fichiers.',
      addNewItem: 'Ajouter un nouveau fichier',
      editFile: 'Modifier le fichier',
      fileName: 'Entrez le nom du fichier',
      fileDescription: 'Description du fichier (facultatif)',
      coverImage: 'Image de couverture (facultatif)',
      templates: {
        classic: 'Liste classique',
        classicCaption: "Le bloc d'origine : une ligne par fichier avec icône, poids et badge d'accès",
        list: 'Liste de fichiers',
        listCaption: 'Des lignes avec le format sur une plaque et le bouton de téléchargement à droite',
        single: 'Téléchargement unique',
        singleCaption: 'Une carte, un grand bouton. Pour le bloc qui publie une seule chose',
        cover: 'Aperçu de couverture',
        coverCaption: 'La première page en image, avec le texte et le bouton en dessous',
        folders: 'Dossiers',
        foldersCaption: 'Fichiers groupés par type ; chaque dossier indique combien et quel poids',
        formats: 'Formats',
        formatsCaption: 'Un même élément dans tous ses formats, sous forme de pastilles',
        versions: 'Versions',
        versionsCaption: 'Le fichier actuel encadré en haut, les anciens accessibles en dessous',
        gate: 'Fichier contre e-mail',
        gateCaption: "Le téléchargement s'ouvre après qu'un visiteur a laissé un e-mail",
        transfer: 'Gros transfert',
        transferCaption: 'Une carte sombre pour une remise lourde, avec un avertissement de taille',
      },
    },
    stat: {
      templates: {
        grid: 'Quatre chiffres',
        gridCaption: 'Deux par ligne, chacun avec une légende disant ce qu’il compte',
        hero: 'Un grand nombre',
        heroCaption: 'Un seul chiffre remplissant le bloc, dans l’encre de la page',
        row: 'Trois sur une ligne',
        rowCaption: 'Trois chiffres courts sur une ligne, séparés par des filets',
        change: 'Avec variation',
        changeCaption: 'Un chiffre et son évolution, depuis le champ supplémentaire de chaque donnée',
        bars: 'Diagramme en barres',
        barsCaption: 'Une colonne par donnée, la plus haute dans votre couleur d’accent',
        progress: 'Barres de progression',
        progressCaption: 'Une répartition en barres pleines : nom, chiffre, barre',
        photo: 'Avec photo',
        photoCaption: 'L’image du titre du bloc au-dessus d’une ligne de chiffres',
        live: 'Compteur en direct',
        liveCaption: 'Un chiffre avec un point qui pulse à côté',
        source: 'Note de source',
        sourceCaption: 'Deux chiffres et une ligne disant d’où ils viennent',
        trend: 'Tendance',
        trendCaption: 'Les données en courbe dans le temps, le chiffre le plus récent en haut',
        share: 'Répartition',
        shareCaption: 'Comment un total se divise, en anneau avec légende',
        ranked: 'Classement',
        rankedCaption: 'Un top cinq numéroté avec une barre sous chaque ligne',
        feed: 'Fil',
        feedCaption: 'Le bloc d’origine — des tuiles de données qui passent à la ligne',
        slider: 'Carrousel',
        sliderCaption: 'Les mêmes tuiles sur un rail que le visiteur fait défiler',
      },
      blockTitle: 'Statistiques',
      blockText: `Ce bloc vous permet d'afficher des informations clés sur votre page, comme les vues, les visiteurs ou l'engagement. Il vous aide à surveiller votre audience et à comprendre les performances de votre page.`,
      blockShortText: 'Ajoutez des statistiques à votre page.',
      addNewItem: 'Ajouter une nouvelle statistique',
      editItem: 'Modifier la statistique',
      statName: 'Entrez le nom de la statistique',
      statValue: 'Entrez la valeur de la statistique',
      statDescription: 'Entrez la description de la statistique',
      statProgress: 'Barre de progression, % (facultatif)',
      statLabel: 'Variation ou note de source',
      statLabelTooltip: 'La pastille à côté du chiffre dans « Avec variation » et « Tendance » (« +18 % », « −1,1 »), ou la ligne sous les chiffres dans « Note de source »',
      matchScreenshot: 'Reproduire une capture',
      matchScreenshotRunning: 'Lecture du design…',
      matchScreenshotSkipped: 'La couleur des tuiles et la police sont inchangées',
      compose: 'Composer',
      composePlaceholder: 'Décris le style : « clair et moderne », « plus affirmé »',
      composeHint: 'La palette fournit la couleur ; le contraste du texte est garanti',
      composeDone: 'Design mis à jour',
      review: 'Vérifier',
      reviewClean: 'Vérifié — rien à corriger',
      reviewFixed: 'Vérifié et corrigé',
      statItemFields: 'Sélectionnez les champs à afficher.',
      columns: 'Colonnes',
      subtitleColumns: 'Nombre de statistiques par ligne',
      feed: 'Flux',
      slider: 'Carrousel',
      titleSize: 'Taille du titre',
      subtitleTitleSize: 'Vous pouvez changer la taille du titre',
    },
    listing: {
      blockTitle: 'Annonce',
      blockText: `Affichez des annonces de biens ou d'articles avec images, détails et tarifs.`,
      blockShortText: 'Ajoutez des annonces à votre page.',
    },
    rental: {
      blockTitle: 'Location',
      blockText: 'Listez des biens ou articles à louer avec disponibilité et tarifs par période.',
      blockShortText: 'Ajoutez des locations à votre page.',
    },
    'single-product': {
      blockTitle: 'Produit unique',
      blockText: `Mettez en avant un produit unique avec image, description et bouton d'achat.`,
      blockShortText: 'Mettez un produit en avant.',
    },
    team: {
      blockTitle: 'Équipe',
      blockText: 'Présentez les membres de votre équipe avec photos, noms, rôles et liens sociaux.',
      blockShortText: 'Présentez votre équipe.',
    },
    timetable: {
      blockTitle: 'Emploi du temps',
      blockText: 'Affichez un planning hebdomadaire avec cours, événements ou sessions.',
      blockShortText: 'Ajoutez un planning hebdomadaire.',
    },
    wall: {
      blockTitle: 'Mur',
      blockShortText: 'Collectez les messages des visiteurs',
      blockText: 'Affichez un mur public où les visiteurs peuvent laisser des messages et interagir avec votre contenu',
    },
    'live-stream': {
      blockTitle: 'Diffusion en direct',
      blockShortText: 'Passez en direct sur votre page',
      blockText: 'Diffusez en direct pour votre audience — nativement via notre plateforme, ou intégrez YouTube / Twitch',
    },
    workout: {
      blockTitle: 'Entraînement',
      blockShortText: 'Partagez et vendez des entraînements',
      blockText: 'Publiez un entraînement structuré — exercices avec séries, répétitions et vidéos de démonstration. Vendez-le ou partagez-le gratuitement',
      templates: {
        sessionCard: 'Carte de séance',
        sessionCardCaption: 'Visuel, nom et une ligne d’infos au-dessus d’un bouton de départ',
        exerciseList: 'Liste des exercices',
        exerciseListCaption: 'Chaque exercice avec sa vignette, ses séries et sa charge',
        setTracker: 'Suivi des séries',
        setTrackerCaption: 'Une ligne par série — faite, en cours, à venir',
        restTimer: 'Minuteur de repos',
        restTimerCaption: 'Un grand décompte entre les séries et ce qui suit',
        weekPlan: 'Plan de la semaine',
        weekPlanCaption: 'Les jours de la semaine, avec aujourd’hui prêt à démarrer',
        videoExercise: 'Vidéo de l’exercice',
        videoExerciseCaption: 'Une vidéo technique verticale avec les consignes en dessous',
        progress: 'Progression',
        progressCaption: 'Les séances du mois en barres, plus deux totaux',
        circuit: 'Circuit',
        circuitCaption: 'Des tours de travail et de repos, l’exercice en cours allumé',
        sessionDone: 'Séance terminée',
        sessionDoneCaption: 'Ce qui vient d’être terminé, la série de jours et un espace pour noter vos ressentis',
      },
      defaults: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Jeu',
        fullBody: 'Corps entier',
        legsAndCore: 'Jambes et gainage',
        upperBody: 'Haut du corps',
        restDay: 'Repos',
      },
    },
    videoFeedback: {
      blockTitle: 'Avis vidéo',
      blockShortText: 'Collectez des témoignages vidéo',
      blockText: 'Collectez de courts témoignages vidéo et retours de votre audience',
    },
    'premium-inbox': {
      blockTitle: 'Boîte de réception premium',
      blockShortText: 'Messages payants des fans',
      blockText: 'Permettez aux fans de vous envoyer des messages et demandes payants directement dans votre boîte de réception premium',
    },
    'order-form': {
      blockTitle: 'Formulaire de commande',
      blockShortText: 'Collectez des commandes depuis votre page',
      blockText: 'Collectez les commandes directement depuis votre page avec un formulaire de commande personnalisable',
    },
  },
  pinnedDock: {
    title: 'Blocs épinglés',
    label: 'ÉPINGLÉ',
    expand: 'Déployer les blocs épinglés',
    collapse: 'Réduire les blocs épinglés',
  },
  reviewButton: {
    title: 'Bouton « Laisser un avis »',
    desc: 'Affiche sous les avis un bouton qui dirige les visiteurs vers l’endroit où ils peuvent laisser un avis.',
    buttonText: 'Texte du bouton',
    link: 'Lien',
    leaveReview: 'Laisser un avis',
    googleHint: 'Laissez vide pour utiliser votre page d’avis Google.',
    design: 'Design du bouton',
    background: 'Arrière-plan',
    textColor: 'Texte',
  },
  themeTokens: {
    title: 'Style du thème',
    subtitle: 'Typographie, coins et espacement',
    typography: 'Typographie',
    corners: 'Coins',
    density: 'Densité',
  },
  headingDesign: {
    colors: 'Couleurs',
    title: 'Titre du bloc',
    subtitle: 'Hérite de la couleur de texte du bloc',
    hint: 'Une couleur non modifiée suit celle du bloc. Une couleur définie ne s’applique qu’à cette partie.',
    titleColor: 'Titre',
    descriptionColor: 'Description',
    inherited: 'hérité',
    reset: 'Réinitialiser',
    custom: 'personnalisées',
  },
  advancedDesign: {
    inherited: 'hérité',
    reset: 'Réinitialiser',
    title: 'Avancé',
    subtitle: 'Ajustez chaque partie',
    slot_title: 'Titre',
    slot_description: 'Description',
    slot_label: 'Sur-titre',
    fontSize: 'Taille de police',
    fontWeight: 'Graisse',
    textTransform: 'Casse',
    textAlign: 'Alignement',
    color: 'Couleur',
  },
  layoutPicker: {
    title: 'Disposition',
    tooltip: 'Choisissez comment les éléments sont disposés',
    layout_list: 'Liste',
    layout_grid: 'Grille',
    layout_cards: 'Cartes',
  },
  importDesign: {
    title: 'Importer un design',
    subtitle: 'Recréez un design à partir d’une capture d’écran',
    upload: 'Importer une capture d’écran',
    extracting: 'Analyse…',
    apply: 'Appliquer à la page',
    applying: 'Application…',
    blocksCount: '+{n} blocs',
    applied: 'Design appliqué — {n} blocs ajoutés',
  },
  adminUi: {
    podcastEnterShowTitle: `Saisissez le titre de l'émission`,
    podcastMaximum: 'Maximum',
    podcastCharacters: 'caractères',
    podcastShowTitleExists: 'Une émission avec ce titre existe déjà',
    podcastEditShow: `Modifier l'émission`,
    podcastNewShow: 'Nouvelle émission',
    podcastCover: 'Couverture',
    podcastTitle: 'Titre',
    podcastShowTitlePlaceholder: `Titre de l'émission`,
    podcastCategory: 'Catégorie',
    podcastCategoryPlaceholder: 'p. ex. True Crime',
    podcastDescription: 'Description',
    podcastDescriptionPlaceholder: 'De quoi parle cette émission…',
    podcastSubscribeButtons: `Boutons « S'abonner »`,
    podcastAddPlatform: 'Ajouter une plateforme',
    podcastSave: 'Enregistrer',
    podcastCreate: 'Créer',
    episodeOne: 'épisode',
    episodeFew: 'épisodes',
    episodeMany: 'épisodes',
    edit: 'Modifier',
    delete: 'supprimer',
    addShow: 'Ajouter une émission',
    importFromRss: 'Importer depuis RSS',
    importFromRssFeed: 'Importer depuis un flux RSS',
    importFromRssHint: 'Collez un lien RSS de podcast — les épisodes seront importés automatiquement dans une nouvelle émission.',
    import: 'Importer',
    trackWordOne: 'piste',
    trackWordFew: 'pistes',
    trackWordMany: 'pistes',
    albumLabel: 'Album',
    pause: 'Pause',
    play: 'Lire',
    emptyTracks: `Aucune piste dans cet album pour l'instant`,
    untitled: 'Sans titre',
    show: 'Émission',
    audioFileNotAttached: 'Fichier audio non joint',
    paypalConnectionTitle: 'Choisissez la méthode de connexion PayPal',
    paypalConnectionSubtitle: 'Sélectionnez la méthode de connexion la plus pratique pour vous',
    paypalRecommendedBadge: 'Recommandé',
    paypalPartnerTitle: 'Via PayPal Partner',
    paypalPartnerFeatureQuickConnect: 'Connexion rapide en 1 clic',
    paypalPartnerFeatureAutoTokens: 'Renouvellement automatique des tokens',
    paypalPartnerFeatureMostSecure: 'Méthode la plus sécurisée',
    paypalPartnerFeatureNoApiKeys: 'Aucune clé API à copier',
    paypalPartnerButton: 'Connecter via Partner',
    paypalDirectTitle: 'Directement (identifiants API)',
    paypalDirectFeatureClientIdSecret: 'Nécessite un Client ID et un Secret',
    paypalDirectFeatureManualSetup: 'Configuration manuelle',
    paypalDirectFeatureFullControl: `Contrôle total de l'API`,
    paypalDirectFeatureAdvancedUsers: 'Pour utilisateurs avancés',
    paypalDirectButton: 'Connecter directement',
    clientIdRequired: 'Le Client ID est un champ obligatoire',
    clientSecretRequired: 'Le Client Secret est un champ obligatoire',
    invalidPaypalCredentials: 'Identifiants PayPal invalides',
    connectPaypalDirectly: 'Connecter PayPal directement',
    paypalConnectedSuccessfully: 'PayPal connecté avec succès !',
    yourPaypalClientId: 'Votre Client ID PayPal depuis le Dashboard',
    yourPaypalClientSecret: 'Votre Client Secret PayPal depuis le Dashboard',
    chooseOperatingMode: 'Choisissez le mode de fonctionnement',
    sandboxTest: 'Sandbox (test)',
    liveProduction: 'Live (production)',
    whereToFindCredentials: '💡 Où trouver les identifiants ?',
    goTo: 'Allez sur',
    createOrSelectApp: 'Créez une nouvelle App ou sélectionnez-en une existante',
    copyClientIdAndSecret: 'Copiez le Client ID et le Secret',
    cancel: 'Annuler',
    connected: 'Connecté !',
    connect: 'Connecter',
    monobankTokenTooltip: 'Token de Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Saisissez le token Monobank',
    whereToGetToken: 'Où obtenir le token ?',
    statusChangedTo: 'Statut changé en',
    all: 'Tout',
    loading: 'Chargement...',
    noBookingsYet: `Aucune réservation pour l'instant`,
    noBookingsWithStatus: 'Aucune réservation avec ce statut',
    nightsAbbr: 'nuits',
    uah: 'UAH',
    oneNightDeposit: `Acompte d'une nuit`,
    fullPrepayment: `Paiement intégral d'avance`,
    online: 'En ligne',
    confirm: 'Confirmer',
    complete: 'Terminer',
    restore: 'Restaurer',
    bookingCalendarBooked: 'Réservé',
    bookingCalendarBlockedManually: 'Bloqué manuellement',
    bookingCalendarAvailable: 'Disponible',
    bookingCalendarNoSettings: 'Aucun réglage',
    bookingCalendarSaveItemFirst: `Enregistrez d'abord l'élément`,
    bookingCalendarLoading: 'Chargement...',
    bookingCalendarBlocked: 'Bloqué',
    bookingCalendarSelected: 'Sélectionné',
    bookingCalendarSelectedDates: 'Dates sélectionnées',
    bookingCalendarPricePerDay: 'Prix/jour',
    bookingCalendarOpen: 'Ouvrir',
    bookingCalendarBlock: 'Bloquer',
    bookingCalendarCancel: 'Annuler',
    responseDeleted: 'Réponse supprimée',
    deleteAllConfirm: 'Supprimer toutes les réponses ? Cette action est irréversible.',
    allResponsesDeleted: 'Toutes les réponses ont été supprimées',
    responseOne: 'réponse',
    responseFew: 'réponses',
    responseMany: 'réponses',
    deleteAll: 'Tout supprimer',
    allForms: 'Tous les formulaires',
    noResponsesYet: `Aucune réponse pour l'instant`,
    exportCsv: 'Exporter en CSV',
    exportUnavailable: 'L’export n’est pas encore disponible.',
    funnelViews: 'Vues',
    funnelStarted: 'Commencés',
    funnelSubmitted: 'Envoyés',
    funnelConversion: 'Conversion',
    funnelPeriod: 'Visiteurs uniques, 30 derniers jours',
    funnelProOnly: 'Les vues et la conversion sont disponibles avec Pro',
    funnelUpgrade: 'Passer au Pro',
    leadSource: 'Source',
    fieldName: 'Nom',
    fieldPhone: 'Téléphone',
    fieldAddress: 'Adresse',
    fieldComment: 'Commentaire',
    customFields: 'Champs supplémentaires',
    more: 'Plus',
    view: 'Voir',
    track: 'Suivre',
    showing: 'Affichage de',
    of: 'sur',
    ordersLower: 'commandes',
    ordersEmpty: `Aucun enregistrement pour l'instant`,
    ordersCountLabel: 'enregistrements',
    ordersName: 'Nom',
    ordersPhone: 'Téléphone',
    ordersLoading: 'Chargement...',
    ordersComment: 'Commentaire',
    ordersPayment: 'Paiement',
    ordersPrev: 'Précédent',
    ordersNext: 'Suivant',
    revokeAccessConfirm: `Révoquer l'accès ?`,
    accessRevoked: 'Accès révoqué',
    activeGrants: 'accès actifs',
    noActiveGrants: 'Aucun accès actif',
    type: 'Type',
    grantedBy: 'Accordé par',
    started: 'Débuté',
    until: `Jusqu'à`,
    revoke: 'Révoquer',
    deleted: 'Supprimé',
    subscribers: 'abonnés',
    noSubscribersYet: `Aucun abonné pour l'instant`,
    phone: 'Téléphone',
    name: 'Nom',
    step: 'Étape',
    done: 'terminé',
    stepFailedSingular: 'étape a échoué',
    stepFailedPlural: 'étapes ont échoué',
    done2: 'Terminé.',
    actionFailed: `Impossible d'effectuer l'action.`,
    starterCoffeeSite: 'Créer un site web pour un café',
    starterFaq: 'Ajouter un bloc FAQ avec 5 questions',
    starterTranslate: 'Traduire tout le site en anglais',
    starterBrandColors: 'Choisir des couleurs assorties à ma marque',
    stopped: 'Arrêté.',
    scopeSite: 'Site',
    scopePage: 'Page',
    followUpAddPhoto: 'Ajouter une autre photo',
    followUpAddQuestion: 'Ajouter une autre question',
    followUpAddPlan: 'Ajouter un autre forfait tarifaire',
    followUpAddService: 'Ajouter un autre service',
    followUpAddBlock: 'Ajouter un autre bloc',
    followUpMakeBetter: `L'améliorer encore`,
    followUpTweakColors: 'Ajuster les couleurs à ma marque',
    followUpChangeColors: 'Changer les couleurs',
    followUpTranslateEnglish: 'Traduire en anglais',
    undoneDeletedPrefix: 'Annulé — supprimé',
    undoneOf: 'sur',
    undoneCreatedBlocks: 'blocs créés',
    planAnalyzing: 'Analyse de la demande',
    planCheckingSite: `Vérification de l'état du site`,
    planChoosingBlocks: 'Choix des blocs',
    planPreparing: 'Préparation du plan',
    hideDetails: 'Masquer les détails',
    details: 'Détails',
    emptyStateTitle: 'Comment puis-je vous aider ?',
    emptyStateSubtitle: `Décrivez ce qu'il faut faire — ou choisissez un exemple ci-dessous`,
    undoing: 'Annulation…',
    undo: 'Annuler',
    blockSingular: 'bloc',
    blockPlural: 'blocs',
    usageCostTitle: 'Coût de cette demande',
    tokens: 'tokens',
    stop: 'Arrêter',
    scopeSiteTitle: 'Modifications sur tout le site',
    scopePageTitle: 'Modifications uniquement sur la page actuelle',
    customDesign: 'Design personnalisé',
    appointmentEmbedTitle: 'URL d’intégration',
    appointmentEmbedSubtitle: 'Intégrer Calendly en iframe intégré',
    appointmentEmbedCaption: 'URL Calendly',
    appointmentEmbedTooltip: 'Collez l’URL de votre événement Calendly (p. ex. https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Saisissez une URL Calendly valide (p. ex. https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'questions',
    all: 'Toutes',
    unanswered: 'Sans réponse',
    answered: 'Répondues',
    loading: 'Chargement...',
    noQuestions: `Aucune question pour l'instant`,
    anonymous: 'Anonyme',
    noName: 'Sans nom',
    yourAnswer: 'Votre réponse',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    enterAnswer: 'Saisissez votre réponse...',
    saveAnswer: 'Enregistrer la réponse',
    confirmDelete: 'Supprimer cette question ?',
    answerSaved: 'Réponse enregistrée',
    deleted: 'Supprimé',
  },
  adsManager: {
    estimatedAudience: `Taille estimée de l'audience`,
    audienceTooLarge: 'Votre audience est très large — pensez à la restreindre.',
    audienceTooNarrow: `Votre audience est très réduite — pensez à l'élargir.`,
    audience: 'Audience',
    suggestedAudience: `Utiliser l'audience suggérée`,
    suggestedAudienceHint: 'Ciblage large, idéal pour la portée',
    buildYourOwn: 'Créer la vôtre',
    buildYourOwnHint: `Définissez l'âge, le genre et les pays`,
    expectedViewers: `Spectateurs attendus pour l'annonce`,
    totalBudget: 'Budget total de la campagne',
    duration: 'Durée',
    days: 'jours',
    advancedSchedule: 'Planning avancé',
    hideAdvanced: 'Masquer le planning avancé',
    adPreview: `Aperçu de l'annonce`,
    sponsored: 'Sponsorisé',
    seeMore: 'Voir plus',
    learnMore: 'En savoir plus',
    yourPage: 'Votre Page',
  },
  virtualBackgrounds: {
    title: 'Arrière-plans virtuels',
    canvasSize: 'Taille du canevas',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Carré',
    fmtClassic: 'Classique',
    background: 'Arrière-plan',
    bg_color: 'Couleur',
    bg_gradient: 'Dégradé',
    bg_photo: 'Photo',
    bg_pattern: 'Motif',
    from: 'De',
    to: 'À',
    angle: 'Angle',
    ink: 'Encre',
    paper: 'Papier',
    blur: 'Flou',
    darken: 'Assombrir',
    presets: 'Préréglages',
    uploadImage: 'Importer une image',
    removeImage: `Retirer l'image`,
    replace: 'Remplacer',
    remove: 'Retirer',
    photoPlaceholder: 'Importez une image depuis le panneau',
    overlay: 'Superposition',
    showName: 'Afficher le nom',
    namePlaceholder: 'Votre nom',
    subtitlePlaceholder: 'Sous-titre / identifiant',
    typeface: 'Police',
    textColour: 'Couleur du texte',
    nameSizeLabel: 'Taille du nom',
    position: 'Position',
    showQr: 'Afficher le QR code',
    qrPlaceholder: 'https://lien',
    style: 'Style',
    qrCard: 'Carte',
    qrBrand: 'Marque',
    qrLight: 'Clair',
    qrSolid: 'Uni',
    qrSizeLabel: 'Taille du QR',
    logo: 'Logo / avatar',
    uploadLogo: 'Importer un logo (PNG)',
    logoSizeLabel: 'Taille du logo',
    finishing: 'Finition',
    vignette: 'Vignette',
    vignetteHint: 'Bords sombres et doux pour la profondeur',
    shuffle: 'Mélanger',
    reset: 'Réinitialiser',
    dragHint: 'Faites glisser le nom, le QR ou le logo sur le canevas pour les repositionner',
    preparing: 'Préparation…',
    download: 'Télécharger',
    sizeHint: 'Enregistré en JPG 1920 × 1080',
  },
  emailSignatures: {
    signatures: 'Signatures',
    signature: 'Signature',
    signatureName: 'Libellé',
    signatureNamePlaceholder: 'Pro, Perso…',
    newSignature: 'Nouvelle signature',
    createSignature: 'Créer une signature',
    emptyText: 'Créez une signature et chaque e-mail envoyé renverra vers votre page.',
    default: 'Par défaut',
    isDefault: 'Signature par défaut',
    makeDefault: 'Définir par défaut',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Signature enregistrée',
    fillFromCard: 'Remplir depuis la carte de visite',
    noCard: 'Pas encore de carte de visite — remplissez les champs manuellement',
    extras: 'Extras',
    socialLinks: 'Réseaux sociaux',
    logo: 'Logo de l’entreprise',
    upload: 'Téléverser',
    uploading: 'Téléversement…',
    uploadFailed: 'Échec du téléversement',
    imageTooLarge: 'L’image doit faire moins de {size} Mo',
    remove: 'Retirer',
    ctaText: 'Texte du bouton',
    ctaTextPlaceholder: 'Réserver un appel',
    ctaUrl: 'Lien du bouton',
    banner: 'Bannière',
    disclaimer: 'Mentions légales',
    disclaimerPlaceholder: 'Clause de confidentialité, coordonnées…',
    tracking: 'Suivi',
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié',
    renewLink: 'Renouveler le lien',
    renewing: 'Renouvellement…',
    linkRenewed: 'Lien renouvelé',
    renewHint: 'Le renouvellement crée un nouveau lien. Les signatures déjà envoyées cesseront de fonctionner — les compteurs ci-dessous sont conservés.',
    statClicks: 'Clics sur le lien',
    statQrScans: 'Scans QR',
    statCtaClicks: 'Clics sur le bouton',
    title: `Signatures d'e-mail`,
    details: 'Détails',
    name: 'Nom',
    jobTitle: 'Poste',
    company: 'Entreprise',
    email: 'E-mail',
    phone: 'Téléphone',
    website: 'Site web',
    style: 'Style',
    styleModern: 'Moderne',
    styleClassic: 'Classique',
    styleMinimal: 'Minimal',
    styleBold: 'Audacieux',
    styleCard: 'Carte',
    accent: `Couleur d'accent`,
    showAvatar: 'Afficher la photo',
    showQr: 'Afficher le QR code',
    preview: 'Aperçu',
    copySignature: 'Copier la signature',
    copyHtml: 'Copier le HTML',
    copied: 'Signature copiée',
    copiedHtml: 'HTML copié',
    instructions: {
      gmail: 'Gmail : Paramètres → Voir tous les paramètres → Général → Signature → Créer, puis collez (Ctrl/Cmd+V) et enregistrez les modifications.',
      outlook:
        'Outlook : Fichier → Options → Courrier → Signatures → Nouveau, puis collez. Nouveau Outlook / web : Paramètres → Courrier → Rédaction et réponse → collez dans le champ de signature.',
      apple: 'Apple Mail : Mail → Réglages → Signatures → ajoutez une signature, puis collez-la. Décochez « Toujours utiliser la police par défaut de mes messages ».',
    },
  },
  storyEditor: {
    back: 'Retour',
    general: 'Général',
    text: 'Texte',
    cta: 'CTA',
    media: 'Médias',
    items: 'Produits',
    addOns: 'Modules',
    stickers: 'Stickers',
    layers: 'Calques',
    save: 'Enregistrer',
    delete: 'Supprimer',
    addText: 'Ajouter du texte',
    addCta: 'Cliquez ici',
    unsavedChanges: 'Modifications non enregistrées',
    leaveConfirm: 'Quitter sans enregistrer ? Vos modifications seront perdues.',
    title: 'Titre',
    enterTitle: 'Saisissez le titre',
    duration: 'Durée',
    durationHint: "Combien de temps la story reste à l'écran",
    kenBurns: 'Ken Burns (zoom lent)',
    content: 'Contenu',
    enterContent: 'Saisissez le contenu',
    url: 'URL',
    enterUrl: "Saisissez l'URL",
    fontSize: 'Taille de police',
    chooseFontSize: 'Choisissez la taille',
    stylePreset: 'Style',
    stylePresetHint: 'Appliquer un style prédéfini',
    animation: 'Animation',
    animationHint: "Animation d'entrée",
    color: 'Couleur',
    chooseColors: 'Choisissez les couleurs',
    filter: 'Filtre',
    cropImage: "Recadrer l'image",
    nothingToAdd: 'Rien à ajouter pour le moment',
    noLayers: 'Aucun calque',
    bringForward: 'Vers l’avant',
    sendBackward: 'Vers l’arrière',
    responses: 'Réponses',
    noResponses: 'Aucune réponse pour le moment',
  },
  storyGroups: {
    stories: 'Stories',
    addStoryGroup: '+ Ajouter un groupe',
    newStory: '+ Nouvelle story',
    previewGroup: 'Aperçu du groupe',
    noStoriesYet: 'Aucune story',
    editGroup: 'Modifier le groupe',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    preview: 'Aperçu',
    name: 'Nom',
    content: 'Contenu',
    views: 'Vues',
    behavior: 'Comportement',
    live: 'En ligne',
    cover: 'Couverture',
    groupName: 'Nom',
    enterGroupName: 'Saisissez le nom du groupe',
    save: 'Enregistrer',
    behaviour: 'Comportement',
    behaviourPermanent: 'Permanent',
    behaviourPermanentHint: 'Toujours disponible dans le widget',
    behaviourDaily: 'Quotidien',
    behaviourDailyHint: 'Marqué comme vu une fois par jour',
    behaviourOnce: 'Une fois',
    behaviourOnceHint: 'Masqué après visionnage',
    widgets: 'Widgets',
    widgetsHint: 'Widgets qui affichent ce groupe',
    noWidgets: 'Aucun widget',
  },
};
